import React, { Component } from "react";
import { Select, MenuItem } from "@mui/material";
import ReactPlayer from "react-player";
import { PlayArrow } from "@mui/icons-material";
import VCF from "vcf";
import Button from "@material-ui/core/Button";
import AddLinkIcon from "@mui/icons-material/AddLink";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import MailIcon from "@mui/icons-material/Mail";
import PhoneIcon from "@mui/icons-material/Phone";
import LanguageIcon from "@mui/icons-material/Language";
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import NotesIcon from "@mui/icons-material/Notes";
import TextField from "@material-ui/core/TextField";
import ReactSpeedometer from "react-d3-speedometer";
import Confetti from "react-confetti";
import { withRouter } from "../../../withRouter";
// import { ListItemSecondaryAction, ListItemText } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
// import ListItem from "@material-ui/core/ListItem";
// import DeleteIcon from "@material-ui/icons/Delete";
// import EditIcon from "@material-ui/icons/Edit";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import InfoTooltip from "../infoTooltip/InfoTooltip";
import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import Utils from "../../../provider/Utils";
import FetchServerData from "../../../provider/FetchServerData";
import PtsAlert from "../ptsAlert/PtsAlert";
import store from "../../../redux/store";
import Tooltip from "@material-ui/core/Tooltip";
import CancelIconButton from "../buttons/CancelIconButton";
import { ValidatorForm } from "react-material-ui-form-validator";
import { Autocomplete } from "@mui/material";
import { Container } from "@mui/material";
import { Box, Typography } from "@mui/material";
import CreateButton from "../buttons/CreateButton";
import "./Message.css";
import MenuWithBreadScrum from "../menu/MenuWithBreadScrum";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "@material-ui/core/IconButton";
import PtsButton from "../buttons/PtsButton";
import MessageQuestion from "./MessageQuestion";
import {
  CreateMessage_Url,
  CreateShort_URL,
  GetMessage_Url,
  AllGroupList_Url,
  PledgeStaticData_Url,
  ShortLinkList_Url,
  UpdateMMS_Url,
  getCrmStatic_Url,
} from "../../../provider/ServiceUrl";
import { BUSINESS_DOMAIN, MESSAGE_TYPES } from "../../../provider/Enums";
// import ActivityAlert from "./ActivityAlert";
import CustomerMessageTemplate from "./CustomerMessageTemplate";
import _ from "lodash";
import HorizontalBar from "../pledge/HorizontalBar";
// import BorderColorIcon from "@mui/icons-material/BorderColor";
// import FormatColorTextIcon from "@mui/icons-material/FormatColorText";
import BannerColorPicker from "../pledge/BannerColorPicker";
import VCardDialog from "./VCardDialog";
import MessageVcard from "./MessageVcard";

class CreateSimilarMessage extends Component {
  addressRef = React.createRef();
  header = store.getState().header.header;
  smsCategoryColorList = store.getState().staticData.smsCategoryColorList;
  smsMessageTypeList = store.getState().staticData.smsMessageTypeList;
  smsActivityAlertList = store.getState().staticData.smsActivityAlertList;
  interactiveQuestionTypeList =
    store.getState().staticData.interactiveQuestionTypeList;
  // smsVariablesList = store.getState().staticData.smsVariablesList;
  smsFundraisingOptionList =
    store.getState().staticData.smsFundraisingOptionList;
  crmIntegration = store.getState().crmIntegration.crmIntegration;
  accountSettings = store.getState().accountSetting?.accountSetting;
  businessDomain =
    store.getState().appUserData.appUserData.appuser?.businessDomain;
  businessDomainId = store.getState().businessDomain?.businessDomainId;
  paymentServiceType =
    store.getState().appUserData.appUserData.paymentServiceType;
  tollfreeNumber = store.getState().appUserData.tollfreeNumber;
  tollFreeNumberStatus = store.getState().appUserData.tollFreeNumberStatus;
  itemReferenceList = [];
  mobileItemReferenceList = [];
  emailItemReferenceList = [];
  valueIndexMap = new Map();
  givbeeBreadCrumb = [
    { pageid: "/messages", uiname: "Messages" },
    { pageid: "", uiname: "Message Details" },
  ];
  eventBreadCrumb = [
    { pageid: "/eventMessages", uiname: "Messages" },
    { pageid: "", uiname: "Message Details" },
  ];
  dptextBreadCrumb = [
    { pageid: "/dptextMessages", uiname: "Messages" },
    { pageid: "", uiname: "Message Details" },
  ];

  constructor(props) {
    super(props);
    let action = props.action;
    let messageId = props.messageId;
    let smsVariableList = [];
    if (!action && props.state) {
      action = props.state.action;
      messageId = props.state.messageId;
      smsVariableList = props.state.smsVariableList;
    }
    this.getMessageDetails(messageId);
    // const modifiedData = [...this.smsFundraisingOptionList];
    // modifiedData.map((item) => {
    //   if (Utils.equalsIgnoreCase(item.name, "Without Introduction")) {
    //     item.isChecked = true;
    //   } else {
    //     item.isChecked = false;
    //   }
    //   return item;
    // });

    let breadCrumb = [];
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      breadCrumb = this.eventBreadCrumb;
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      breadCrumb = this.dptextBreadCrumb;
    } else {
      breadCrumb = this.givbeeBreadCrumb;
    }
    this.state = {
      action: action,
      breadCrumb: breadCrumb,
      smsVariableList: smsVariableList,
      messageName: "",
      textMessage: "",
      textPledgeMessage: `${this.companyName ? this.companyName : ""} thanks you for your pledge! Please tap here to complete payment: INSERT YOUR DONATION PAGE LINK HERE.`,
      closingTextMessage: "",
      question: "",
      keyword: "",
      recordActivity: "",
      alertEmail: "",
      alertMobileNo: "",
      mmsId: "",
      mmsData: "",
      cursorPosition: 0,
      selectedFile: { name: "" },
      messageType: Utils.getArrayElement(this.smsMessageTypeList, 0),
      activityAlert: Utils.getArrayElement(this.smsActivityAlertList, 0),
      colorCode: Utils.getArrayElement(this.smsCategoryColorList, 4)?.hashColor,
      colorCodeId: Utils.getArrayElement(this.smsCategoryColorList, 4)?.id,
      getUpdatePermission: false,
      getDeletePermission: false,
      copied: false,
      introMessage: "",
      amountQuestion: "",
      amountOption1: "",
      amountOption2: "",
      amountOption3: "",
      amountOption4: "",
      donationAmount: "",
      donationAmountList: [],
      shortLinkList: [],
      messageTemplateList: [],
      questionItems: [],
      emailItems: "",
      mobileItems: "",
      actionTypeList: [],
      appealsList: [],
      campaignsList: [],
      fundList: [],
      packageList: [],
      activityList: [
        { label: "No", value: false },
        { label: "Yes", value: true },
      ],
      activityCodeList: [],
      assignToCodeList: [],
      campaignCodeList: [],
      solicitationCodeList: [],
      subSolicitationCodeList: [],
      glCodeList: [],
      fundraisingGoal: 10000,
      totalDonation: 0,
      actionType: null,
      blackbaudAppeal: null,
      blackbaudCampaign: null,
      blackbaudFund: null,
      blackbaudPackage: null,
      activityCode: null,
      assignToCode: null,
      generalLedger: null,
      campaign: null,
      solicitation: null,
      subSolicitation: null,
      dpTextPropertiesId: "",
      messageTemplate: null,
      smsMessageFundRaising: null,
      contact: null,
      assignToGroup: null,
      questionType: Utils.getArrayElement(this.interactiveQuestionTypeList),
      // donnerExperince: this.smsFundraisingOptionList[0],
      smsFundraisingOptionList: [],
      displayStyles: [],
      displayTypeList: [],
      colorTypeList: [],
      effectTypeList: [],
      smsGroupList: [],
      bannerText: "Thank you for your support!",
      bannerTextColor: "#353538",
      bannerBackground: "#ffffff",
      displayStyle: null,
      displayType: null,
      displayColor: null,
      displayEffect: null,
      isOptinkeyword: false,
      isAutoscroll: true,
      isShowGoalAmount: true,
      is3dEffect: true,
      isConfetti: true,
      isWithoutChecked: true,
      isWithChecked: false,
      isIntroMessage: true,
      isMms: false,
      neonRecordActivity: false,
      isBlackbaudActivity: false,
      isDptextActivity: this.crmIntegration === BUSINESS_DOMAIN.dpText ? true : false,
      isRecordAsPledge: false,
      isTextMessageLength: false,
      isPledge: false,
      isMeterSetting: false,
      isPaymentLinkIncluded: false,
      open: false,
      keywordSpaceError: false,
      render: false,
      isDragging: false,
      isAssignToGroup: false,
      donationAmountError: false,
      hasMessageWithYesNoKeyword: false,
      hasYesNoQuestion: false,
      isBlackbaudTokenAbsent: false,
      isDpTextCrmAbsent: false,
      offlimitKeywordForMessage: false,
      hasEmDashError: false,
    };
    this.debouncedMessageName = _.debounce(this.getDuplicateMessageName, 1000);
    this.debouncedKeyword = _.debounce(this.getDuplicateKeyword, 1000);
  }

  componentDidMount() {
    document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
    this.getMessageTemplateList();
    if (Utils.equalsIgnoreCase(this.businessDomain === BUSINESS_DOMAIN.D)) {
      this.getDPTextCrmStaticData();
    }

    let isInteractivePledge = false;
    for (let i = 0; i < this.itemReferenceList.length; i++) {
      if (this.itemReferenceList[i].current) {
        isInteractivePledge =
          this.itemReferenceList[i].current.state.question?.includes(
            "{{Payment Link}}"
          );
      }
    }
  }

  getActivityAndAssignedToData(dpTextProperties) {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostServiceWithoutAlert(
      "/dptextCrmms/getActivityAndAssignedToData",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let dpTextCrmStaticData = output.data;

        const keywords = ["text", "sms", "message", "msg"];

        const defaultActivity = dpTextCrmStaticData.activityCodeList.find(item => {
          const value =
            (item.code || "").toLowerCase() +
            " " +
            (item.description || "").toLowerCase();

          return keywords.some(keyword => value.includes(keyword));
        });

        this.setState({
          render: true,
          activityCode: dpTextProperties === null ? defaultActivity || null : dpTextProperties?.activityCode,
          activityCodeList: dpTextCrmStaticData.activityCodeList,
          assignToCodeList: dpTextCrmStaticData.assignToCodeList,
        });
      } else {
        this.setState({
          isDpTextCrmAbsent: true,
        })
      }
    });
  }

  getDPTextCrmStaticData() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/dptextCrmms/getStaticData",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let dpTextCrmStaticData = output.data;
        this.setState({
          render: true,
          activityCodeList: dpTextCrmStaticData.activityCodeList,
          assignToCodeList: dpTextCrmStaticData.assignToCodeList,
          campaignCodeList: dpTextCrmStaticData.campaignCodeList,
          solicitationCodeList: dpTextCrmStaticData.solicitationCodeList,
          subSolicitationCodeList: dpTextCrmStaticData.subSolicitationCodeList,
          glCodeList: dpTextCrmStaticData.glCodeList,
        });
      } else {
        this.setState({
          isDpTextCrmAbsent: true
        })
      }
    });
  }

  getMessageTemplateList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(
      "/custMsgTemplatems/getList",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let messageTemplateDetails = output.data;
        let messageTemplateList = output.data.messageTemplateList;
        messageTemplateList.unshift({
          messageName: "Add New Template",
          id: "Add New Template",
        });
        this.setState({
          messageTemplateList: messageTemplateList,
          hasMessageWithYesNoKeyword: messageTemplateDetails.hasMessageWithYesNoKeyword,
          hasYesNoQuestion: messageTemplateDetails.hasYesNoQuestion,
        });
      } else {
      }
    });
  }

  getActionTypes(actionType) {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostServiceWithoutAlert(
      "/blackbaudcrmms/getActionTypes",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let actionTypeData = output.data;
        const keywords = ["text", "sms", "message", "msg"];

        const defaultActivity = actionTypeData.value.find(item => {
          const value = item.toLowerCase();
          return keywords.some(keyword => value.includes(keyword));
        });
        this.setState({
          render: true,
          actionType: actionType !== null ? actionType : defaultActivity,
          actionTypeList: actionTypeData.value,
        });
      } else {
        this.setState({
          isBlackbaudTokenAbsent: true,
        })
      }
    });
  }

  getCrmStaticData(staticData, blackbaudAppeal) {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(getCrmStatic_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let blackbaudCrmStaticData = output.data;
          // if (staticData) {
          // this.getAppealPackages(blackbaudAppeal);
          this.setState({
            render: true,
            appealsList: blackbaudCrmStaticData.appealsList,
            campaignsList: blackbaudCrmStaticData.campaignsList,
            fundList: blackbaudCrmStaticData.fundList,
            giftSubTypeList: blackbaudCrmStaticData.giftSubTypeList,
          });
          // } else {
          //   this.getAppealPackages(
          //     Utils.getArrayElement(blackbaudCrmStaticData.appealsList, 0)
          //   );
          //   this.setState({
          //     render: true,
          //     blackbaudAppeal: Utils.getArrayElement(
          //       blackbaudCrmStaticData.appealsList,
          //       0
          //     ),
          //     blackbaudCampaign: Utils.getArrayElement(
          //       blackbaudCrmStaticData.campaignsList,
          //       0
          //     ),
          //     blackbaudFund: Utils.getArrayElement(
          //       blackbaudCrmStaticData.fundList,
          //       0
          //     ),
          //     blackbaudGiftsubtype: Utils.getArrayElement(
          //       blackbaudCrmStaticData.giftSubTypeList,
          //       0
          //     ),
          //     // blackbaudPackage: blackbaudCrmStaticData.packageList[0],
          //     appealsList: blackbaudCrmStaticData.appealsList,
          //     campaignsList: blackbaudCrmStaticData.campaignsList,
          //     fundList: blackbaudCrmStaticData.fundList,
          //     giftSubTypeList: blackbaudCrmStaticData.giftSubTypeList,
          //     // packageList: blackbaudCrmStaticData.packageList,
          //   });
          // }
        } else {
        }
      }
    );
  }

  getAppealPackages(blackbaudAppeal) {
    const postObject = {
      header: this.header,
      appealId: blackbaudAppeal?.id,
    };

    FetchServerData.callPostService(
      "/blackbaudcrmms/getAppealPackages",
      postObject
    ).then((output) => {
      if (output.status === "SUCCESS") {
        let appealPackageList = output.data;
        this.setState({
          packageList: appealPackageList,
          blackbaudPackage: null,
        });
      } else {
      }
    });
  }

  async urlToImageBase64(imageUrl) {
    // const proxy = "http://localhost:3000/givBeeApi/";
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    // Convert to base64
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // result includes data:image/... prefix
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });

    return base64;
  }

  getMessageDetails(messageId) {
    const postObject = {
      header: this.header,
      smsMessage: {
        id: messageId,
      },
    };
    FetchServerData.callPostService(GetMessage_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          let smsMessageDetails = output.data;
          let smsMessage = output.data.smsMessage;
          let pledgeDetails = output.data.smsMessage?.pledgeDetails;
          let smsMessageFundRaisingDetails =
            output.data.smsMessage?.smsMessageFundRaising;
          let getPermission = Utils.getRolePermission(["*"]);
          let getUpdatePermission = getPermission[3];
          let getDeletePermission = getPermission[4];
          let questionType = {};
          for (let i = 0; i < smsMessage.smsMessageQuestions?.length; i++) {
            let ref = React.createRef();
            this.itemReferenceList.push(ref);
            smsMessage.smsMessageQuestions[i].operation = "Update";
            if (
              smsMessage.smsMessageQuestions[i]?.questionType?.type === "Pledge"
            ) {
              questionType.type =
                smsMessage.smsMessageQuestions[i]?.questionType?.type;
              this.valueIndexMap.set(i, questionType?.type);
              this.getPledgeStaticData();
            }
          }

          if (Utils.equalsIgnoreCase(this.crmIntegration, "BlackBaudCRM")) {
            let isPledge = smsMessage?.isPledge;
            if (isPledge || Utils.equalsIgnoreCase(
              smsMessage.messageType?.type,
              MESSAGE_TYPES.fundraising
            ) || Utils.equalsIgnoreCase(
              smsMessage.messageType?.type,
              MESSAGE_TYPES.textToPledge
            )) {
              this.getActionTypes(smsMessage.blackbaudSmsPropertiesVo?.actionType);
              this.getCrmStaticData(
                true,
                smsMessage.blackbaudSmsPropertiesVo?.appeal
              );
            } else {
              this.getActionTypes(smsMessage.blackbaudSmsPropertiesVo?.actionType);
            }
          }

          let isPledge = smsMessage?.isPledge;
          if (isPledge) {
            this.getPledgeStaticData(pledgeDetails);
          } else if (
            Utils.equalsIgnoreCase(
              smsMessage.messageType?.type,
              MESSAGE_TYPES.textToPledge
            ) ||
            Utils.equalsIgnoreCase(
              smsMessage.messageType?.type,
              MESSAGE_TYPES.fundraising
            )
          ) {
            this.getPledgeStaticData(pledgeDetails,
              smsMessage.messageType
            );
            isPledge = true;
          }

          let donationAmountList = [];
          if (
            smsMessageFundRaisingDetails?.amountOption1 !== null &&
            smsMessageFundRaisingDetails?.amountOption1 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption1
            );
          }
          if (
            smsMessageFundRaisingDetails?.amountOption2 !== null &&
            smsMessageFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption2
            );
          }
          if (
            smsMessageFundRaisingDetails?.amountOption3 !== null &&
            smsMessageFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption3
            );
          }
          if (
            smsMessageFundRaisingDetails?.amountOption4 !== null &&
            smsMessageFundRaisingDetails?.amountOption2 !== undefined
          ) {
            donationAmountList.push(
              smsMessageFundRaisingDetails?.amountOption4
            );
          }
          const modifiedData = [...(this.smsFundraisingOptionList || [])];
          modifiedData.forEach((item) => {
            item.isSelected =
              item.id === +smsMessageFundRaisingDetails?.donnerExperince?.id;
          });

          let isIntroMessage = false;
          if (
            Utils.equalsIgnoreCase(
              smsMessageFundRaisingDetails?.donnerExperince?.name,
              "With Introduction"
            )
          ) {
            isIntroMessage = true;
          }
          if (
            smsMessage.mmsInfo?.filename !== null &&
            smsMessage.mmsInfo?.url !== null
          ) {
            if (smsMessage?.mmsInfo !== null) {
              let fileName = smsMessage?.mmsInfo?.filename;

              let urlArr = fileName?.split(".");

              let fileType = urlArr[1];
              this.setState({
                mmsInfo: smsMessage.mmsInfo,
                mmsUrl: smsMessage.mmsInfo?.url,
                mmsId: smsMessage.mmsInfo?.id,
                documentType: smsMessage?.mmsType,
                fileType: fileType,
                isMms: smsMessage?.isMms,
                mmsType: smsMessage?.mmsType,
                selectedFile: { name: smsMessage.mmsInfo?.filename },
              });
            }
          }

          if (
            smsMessage.vCardInfo?.filename !== null &&
            smsMessage.vCardInfo?.url !== null
          ) {
            if (smsMessage?.vCardInfo !== null) {
              let fileName = smsMessage?.vCardInfo?.filename;

              let urlArr = fileName?.split(".");
              let fileType = urlArr[1];
              this.setState({
                vCardInfo: smsMessage.vCardInfo,
                vCardUrl: smsMessage.vCardInfo?.url,
                vCardId: smsMessage.vCardInfo?.id,
                documentType: smsMessage?.mmsType,
                fileType: fileType,
                isVcard: smsMessage?.isVcard,
                mmsType: smsMessage?.mmsType,
                selectedFile: { name: smsMessage.vCardInfo?.filename },
              });
            }
          }
          let isMeterSetting = false;
          if (
            smsMessage.messageType?.type === "Standard" ||
            smsMessage.messageType?.type === "optIn"
          ) {
            isMeterSetting =
              smsMessage.textMessage?.includes("{{Payment Link}}");
          } else if (smsMessage.messageType?.type === "Interactive") {
            isMeterSetting = smsMessage.smsMessageQuestions?.some(
              (item) =>
                typeof item.question === "string" &&
                item.question.includes("{{Payment Link}}")
            );
          }

          // If supported, fetch vCard details
          if (smsMessage?.isVcard) {
            this.getVCardDetails(messageId, smsMessage?.vCardInfo?.filename);
          }
          if (smsMessage.assignToGroupId !== null) {
            this.getGroupList(smsMessage.assignToGroupId)
          }
          if (smsMessage.isRecordAsPledge) {
            this.getDPTextCrmStaticData()
          }
          if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            this.getActivityAndAssignedToData(smsMessage?.dpTextProperties)
          }

          this.setState({
            render: true,
            // action: "view",
            messageId: smsMessage.id,
            // messageName: smsMessage.messageName,
            messageType: smsMessage.messageType,
            // keyword: smsMessage.keyword,
            isAssignToGroup: smsMessage.assignToGroupId !== null,
            assignToGroupId: smsMessage.assignToGroupId,
            colorCode: smsMessage.categoryColor?.hashColor,
            colorCodeId: smsMessage.categoryColor?.id,
            textMessage: smsMessage.textMessage,
            textPledgeMessage: smsMessage.textMessage,
            neonRecordActivity: smsMessage.isNeonActivity,
            isBlackbaudActivity: smsMessage.isBlackbaudActivity,
            actionType: smsMessage.blackbaudSmsPropertiesVo?.actionType,
            blackbaudAppeal: smsMessage.blackbaudSmsPropertiesVo?.appeal,
            blackbaudPackage: smsMessage.blackbaudSmsPropertiesVo?.packge,
            blackbaudFund: smsMessage.blackbaudSmsPropertiesVo?.fund,
            blackbaudCampaign: smsMessage.blackbaudSmsPropertiesVo?.campaign,
            isDptextActivity: smsMessage.isDptextActivity,
            isRecordAsPledge: smsMessage.isRecordAsPledge,
            activityCode: smsMessage.dpTextProperties?.activityCode,
            assignToCode: smsMessage.dpTextProperties?.assignedTo,
            generalLedger: smsMessage.dpTextProperties?.generalLedger,
            campaign: smsMessage.dpTextProperties?.campaign,
            solicitation: smsMessage.dpTextProperties?.solicitation,
            subSolicitation: smsMessage.dpTextProperties?.subSolicitation,
            dpTextPropertiesId: smsMessage.dpTextProperties?.id,
            activityAlert: smsMessage.activityAlert !== null ? smsMessage.activityAlert : Utils.getArrayElement(this.smsActivityAlertList, 0),
            alertEmail: smsMessage.alertEmail,
            // alertMobileNo: Utils.phoneNumberFormate(smsMessage?.alertMobileNo),
            // mobile: Utils.phoneNumberFormate(smsMessage?.alertMobileNo),
            alertMobile: smsMessage.alertMobileNo,
            // emailItems: smsMessage.alertEmails,
            // mobileItems: smsMessage.alertMobiles,
            closingTextMessage: smsMessage.closingMessage,
            questionItems: smsMessage.smsMessageQuestions,
            // smsMessageFundRaising: smsMessage.smsMessageFundRaisingDetails,

            amountQuestion: smsMessageFundRaisingDetails?.amountQuestion,
            introMessage:
              smsMessageFundRaisingDetails?.introMessage !== null
                ? smsMessageFundRaisingDetails?.introMessage
                : "",
            amountOption1: smsMessageFundRaisingDetails?.amountOption1,
            amountOption2: smsMessageFundRaisingDetails?.amountOption2,
            amountOption3: smsMessageFundRaisingDetails?.amountOption3,
            amountOption4: smsMessageFundRaisingDetails?.amountOption4,
            donationAmountList: donationAmountList,
            donnerExperince: smsMessageFundRaisingDetails?.donnerExperince,
            smsMessageFundRaisingId: smsMessageFundRaisingDetails?.id,
            smsFundraisingOptionList: modifiedData,
            isIntroMessage: isIntroMessage,
            questionType: questionType,
            pledgeId: pledgeDetails !== null ? pledgeDetails?.id : "",
            bannerText:
              pledgeDetails !== null
                ? pledgeDetails?.bannerText
                : this.state.bannerText,
            bannerTextColor:
              pledgeDetails !== null
                ? smsMessage?.pledgeDetails?.bannerTextColor
                : this.state.bannerTextColor,
            bannerBackground: pledgeDetails !== null
              ? smsMessage?.pledgeDetails?.bannerBackground
              : this.state.bannerBackground,
            isOptinkeyword: pledgeDetails?.isOptinkeyword,
            isAutoscroll: pledgeDetails?.isAutoscroll,
            isShowGoalAmount: pledgeDetails !== null
              ? pledgeDetails?.isShowGoalAmount
              : this.state.isShowGoalAmount,
            is3dEffect: pledgeDetails !== null
              ? pledgeDetails?.is3dEffect
              : this.state.is3dEffect,
            isConfetti: pledgeDetails !== null
              ? pledgeDetails?.isConfetti
              : this.state.isConfetti,
            isPledge: isPledge,
            isMeterSetting: isMeterSetting,
            donationList:
              pledgeDetails !== null ? pledgeDetails?.donationList : [],
            displayType:
              pledgeDetails !== null
                ? pledgeDetails?.displayType
                : this.state.displayType,
            displayColor:
              pledgeDetails !== null
                ? pledgeDetails?.displayColor
                : this.state.displayColor,
            displayEffect:
              pledgeDetails !== null
                ? pledgeDetails?.displayEffect
                : this.state.displayEffect,
            displayStyle:
              pledgeDetails !== null
                ? pledgeDetails?.displayStyle
                : this.state.displayStyle,
            measureType:
              pledgeDetails !== null
                ? pledgeDetails?.measureType
                : this.state.measureType,
            fundraisingGoal:
              pledgeDetails !== null
                ? pledgeDetails?.goalAmount
                : this.state.fundraisingGoal,
            totalDonation:
              pledgeDetails !== null
                ? pledgeDetails?.totalDonation
                : this.state.totalDonation,
            // mmsData: smsMessage.mmsData,
            hasMessageWithYesNoKeyword: smsMessageDetails.hasMessageWithYesNoKeyword,
            hasYesNoQuestion: smsMessageDetails.hasYesNoQuestion,
            getUpdatePermission: getUpdatePermission,
            getDeletePermission: getDeletePermission,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  base64ToString(base64) {
    try {
      return decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      );
    } catch {
      return "";
    }
  }

  getVCardDetails(messageId, fileName) {
    const postObject = {
      header: this.header,
      smsMessage: { id: messageId },
    };

    FetchServerData.callPostService("/smsmessagems/getVcardData", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          const vCardBase64 = output.data;
          if (!vCardBase64) return;

          let text = this.base64ToString(vCardBase64);
          if (!text.startsWith("BEGIN:VCARD")) {
            const index = text.indexOf("BEGIN:VCARD");
            if (index >= 0) text = text.slice(index);
          }
          text = text.replace(/\r?\n/g, "\r\n").trim();

          const vcard = new VCF().parse(text);

          let phones = vcard.get("tel") || [];
          if (!Array.isArray(phones)) phones = [phones];
          let emails = vcard.get("email") || [];
          if (!Array.isArray(emails)) emails = [emails];
          let urls = vcard.get("url") || [];
          if (!Array.isArray(urls)) urls = [urls];
          let adr = vcard.get("adr") || [];
          if (!Array.isArray(adr)) adr = [adr];

          const addresses = adr.map((a) => {
            let parts = a.valueOf();
            if (typeof parts === "string") parts = parts.split(";");
            return {
              street: parts[2] || "",
              city: parts[3] || "",
              state: parts[4] || "",
              postalCode: parts[5] || "",
              country: parts[6] || "",
            };
          });

          const data = {
            name: vcard.get("fn")?.valueOf() || "",
            nickname: vcard.get("nickname")?.valueOf() || "",
            org: vcard.get("org")?.valueOf() || "",
            title: vcard.get("title")?.valueOf() || "",
            phones: phones.map((p) => p.valueOf()),
            emails: emails.map((e) => e.valueOf()),
            urls: urls.map((u) => u.valueOf()),
            note: vcard.get("note")?.valueOf() || "",
            addresses,
          };
          this.setState({
            contact: data, render: true, vCardFileData: {
              fileContent: vCardBase64,
              fileName: fileName,
            }
          });
        }
      })
      .catch((err) => console.error(err));
  }

  getPledgeStaticData(pledge, messageType) {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService(PledgeStaticData_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let pledgeDetails = output.data;
          let displayType = Utils.getArrayElement(
            pledgeDetails?.displayTypes,
            0
          );
          let displayStyle = Utils.getArrayElement(
            pledgeDetails?.displayStyles,
            1
          );
          let measureType = Utils.getArrayElement(
            pledgeDetails?.measureTypes,
            0
          );
          let displayEffect = Utils.getArrayElement(
            pledgeDetails?.effectTypes,
            1
          );
          if (pledge !== null) {
            this.setState({
              displayTypeList: pledgeDetails?.displayTypes,
              colorTypeList: pledgeDetails?.colorTypes,
              effectTypeList: pledgeDetails?.effectTypes,
              displayStyles: pledgeDetails?.displayStyles,
              measureTypes: pledgeDetails?.measureTypes,
              displayType: pledge?.displayType,
              displayStyle: pledge?.displayStyle,
              displayEffect: pledge?.displayEffect,
              displayColor: {
                color: "Blue-Grey ",
                hashColor: "#31a2cd ",
                description: null,
                displaySequence: 2.0,
                id: 2,
              },
              measureType: pledge?.measureType,
              bannerText:
                this.state.keyword !== "" &&
                  this.tollFreeNumberStatus !== "Verified" &&
                  this.tollFreeNumberStatus !== "Approved"
                  ? `To ${messageType?.type === "TextToPledge"
                    ? "pledge"
                    : "donate"
                  }, text "${this.state.keyword}" to ${Utils
                    .viewTollFreeNumberFormate(this.tollfreeNumber)
                    .slice(-12)}.`
                  : "Thank you for your support!",
            });
          } else {
            this.setState({
              render: true,
              displayTypeList: pledgeDetails?.displayTypes,
              colorTypeList: pledgeDetails?.colorTypes,
              effectTypeList: pledgeDetails?.effectTypes,
              displayStyles: pledgeDetails?.displayStyles,
              measureTypes: pledgeDetails?.measureTypes,
              displayType: displayType,
              displayStyle: displayStyle,
              displayEffect: displayEffect,
              displayColor: {
                color: "Blue-Grey ",
                hashColor: "#31a2cd ",
                description: null,
                displaySequence: 2.0,
                id: 2,
              },
              measureType: measureType,
              bannerText:
                this.state.keyword !== "" &&
                  this.tollFreeNumberStatus !== "Verified" &&
                  this.tollFreeNumberStatus !== "Approved"
                  ? `To ${messageType?.type === "TextToPledge"
                    ? "pledge"
                    : "donate"
                  }, text "${this.state.keyword}" to ${Utils
                    .viewTollFreeNumberFormate(this.tollfreeNumber)
                    .slice(-12)}.`
                  : "Thank you for your support!",
            });
          }
        } else {
        }
      }
    );
  }

  // handleMessageTypeChange(selectedValue) {
  //   if (
  //     Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.interactive)
  //   ) {
  //     this.addQuestionItem();
  //     this.setState({
  //       messageType: selectedValue,
  //       textMessage: this.state.textMessage,
  //       shortlinkUrl: "",
  //       shortUrl: "",
  //       messageName: this.state.messageName,
  //       keyword: this.state.keyword,
  //       messageTemplate: this.state.messageTemplate,
  //       actionType: null,
  //       blackbaudAppeal: null,
  //       blackbaudCampaign: null,
  //       blackbaudFund: null,
  //       blackbaudPackage: null,
  //     });
  //   } else if (
  //     Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.fundraising)
  //   ) {
  //     if (Utils.equalsIgnoreCase(this.crmIntegration, "BlackBaudCRM")) {
  //       this.getCrmStaticData();
  //     }
  //     if (this.state.action === "create") {
  //       const modifiedData = [...this.state.smsFundraisingOptionList];
  //       let isIntroMessage = true;
  //       modifiedData.map((item) => {
  //         if (Utils.equalsIgnoreCase(item.name, "Without Introduction")) {
  //           item.isSelected = true;
  //           isIntroMessage = false;
  //           return item;
  //         } else {
  //           item.isSelected = false;
  //           return item;
  //         }
  //       });
  //       this.setState({
  //         messageType: selectedValue,
  //         questionItems: [],
  //         textMessage: this.state.textMessage,
  //         closingMessage: "",
  //         shortlinkUrl: "",
  //         shortUrl: "",
  //         messageName: this.state.messageName,
  //         keyword: this.state.keyword,
  //         messageTemplate: this.state.messageTemplate,
  //         neonRecordActivity: null,
  //         donnerExperince: Utils.getArrayElement(
  //           this.smsFundraisingOptionList,
  //           0
  //         ),
  //         smsFundraisingOptionList: modifiedData,
  //         isIntroMessage: isIntroMessage,
  //         amountQuestion: "How much would you like to give?",
  //         actionType: null,
  //         isBlackbaudActivity: true,
  //       });
  //     } else {
  //       this.setState({
  //         messageType: selectedValue,
  //         questionItems: [],
  //         textMessage: this.state.textMessage,
  //         closingMessage: "",
  //         shortlinkUrl: "",
  //         shortUrl: "",
  //         messageName: this.state.messageName,
  //         keyword: this.state.keyword,
  //         messageTemplate: this.state.messageTemplate,
  //         actionType: null,
  //         isBlackbaudActivity: true,
  //       });
  //     }
  //   } else if (
  //     Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.optIn)
  //   ) {
  //     // this.getMessageTemplateList(selectedValue);
  //     this.setState({
  //       messageType: selectedValue,
  //       questionItems: [],
  //       textMessage: this.state.textMessage,
  //       closingMessage: "",
  //       shortlinkUrl: "",
  //       shortUrl: "",
  //       messageName: this.state.messageName,
  //       keyword: this.state.keyword,
  //       messageTemplate: this.state.messageTemplate,
  //       actionType: null,
  //       blackbaudAppeal: null,
  //       blackbaudCampaign: null,
  //       blackbaudFund: null,
  //       blackbaudPackage: null,
  //     });
  //   } else {
  //     // this.getMessageTemplateList(selectedValue);
  //     this.setState({
  //       messageType: selectedValue,
  //       questionItems: [],
  //       closingMessage: "",
  //       shortlinkUrl: "",
  //       shortUrl: "",
  //       actionType: null,
  //       blackbaudAppeal: null,
  //       blackbaudCampaign: null,
  //       blackbaudFund: null,
  //       blackbaudPackage: null,
  //     });
  //   }
  // }

  handleMessageTypeChange(selectedValue) {
    if (selectedValue?.id === "Use_Saved_Template") {
      this.getMessageTemplateList();
      this.setState({
        openTemplateList: true,
        smsMessageTypeList: this.smsMessageTypeList,
      });
      return false;
    }
    if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.interactive)
    ) {
      if (this.state.questionItems.length < 1) {
        this.addQuestionItem();
      }
      this.valueIndexMap = new Map();
      this.setState({
        messageType: selectedValue,
        textMessage: this.state.textMessage,
        shortlinkUrl: "",
        shortUrl: "",
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        messageTemplate: this.state.messageTemplate,
        actionType: null,
        blackbaudAppeal: null,
        blackbaudCampaign: null,
        blackbaudFund: null,
        blackbaudPackage: null,
        isPledge: false,
      });
    } else if (
      Utils.equalsIgnoreCase(
        selectedValue?.type,
        MESSAGE_TYPES.interactivePledge
      )
    ) {
      if (this.state.questionItems.length < 1) {
        this.addQuestionItem();
      }
      this.setState({
        messageType: selectedValue,
        textMessage: this.state.textMessage,
        shortlinkUrl: "",
        shortUrl: "",
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        messageTemplate: this.state.messageTemplate,
        actionType: null,
        blackbaudAppeal: null,
        blackbaudCampaign: null,
        blackbaudFund: null,
        blackbaudPackage: null,
        isPledge: false,
      });
    } else if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.textToPledge)
    ) {
      this.getPledgeStaticData(null, selectedValue);
      this.setState({
        messageType: selectedValue,
        textMessage: this.state.textMessage,
        shortlinkUrl: "",
        shortUrl: "",
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        messageTemplate: this.state.messageTemplate,
        actionType: null,
        blackbaudAppeal: null,
        blackbaudCampaign: null,
        blackbaudFund: null,
        blackbaudPackage: null,
        isPledge: true,
      });
    } else if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.fundraising)
    ) {
      this.getPledgeStaticData(null, selectedValue);
      let isBlackbaudActivity = this.state.isBlackbaudActivity;
      if (Utils.equalsIgnoreCase(this.crmIntegration, "BlackBaudCRM")) {
        this.getCrmStaticData();
        isBlackbaudActivity = true;
      }
      // this.getPledgeStaticData();
      if (this.state.action === "create") {
        const modifiedData = [...this.state.smsFundraisingOptionList];
        let isIntroMessage = true;
        modifiedData.map((item) => {
          if (Utils.equalsIgnoreCase(item.name, "Without Introduction")) {
            item.isChecked = true;
            isIntroMessage = false;
            return item;
          } else {
            item.isChecked = false;
            return item;
          }
        });
        this.setState({
          messageType: selectedValue,
          questionItems: [],
          textMessage: this.state.textMessage,
          closingMessage: "",
          shortlinkUrl: "",
          shortUrl: "",
          messageName: this.state.messageName,
          keyword: this.state.keyword,
          messageTemplate: this.state.messageTemplate,
          neonRecordActivity: null,
          donnerExperince: Utils.getArrayElement(
            this.smsFundraisingOptionList,
            0
          ),
          smsFundraisingOptionList: modifiedData,
          isIntroMessage: isIntroMessage,
          amountQuestion: "How much would you like to give?",
          actionType: null,
          isBlackbaudActivity: isBlackbaudActivity,
          isPledge: false,
        });
      } else {
        this.setState({
          messageType: selectedValue,
          questionItems: [],
          textMessage: this.state.textMessage,
          closingMessage: "",
          shortlinkUrl: "",
          shortUrl: "",
          messageName: this.state.messageName,
          keyword: this.state.keyword,
          messageTemplate: this.state.messageTemplate,
          actionType: null,
          isBlackbaudActivity: isBlackbaudActivity,
          isPledge: false,
        });
      }
    } else if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.optIn)
    ) {
      // this.getMessageTemplateList(selectedValue);
      this.setState({
        messageType: selectedValue,
        questionItems: [],
        textMessage: this.state.textMessage,
        closingMessage: "",
        shortlinkUrl: "",
        shortUrl: "",
        messageName: this.state.messageName,
        keyword: this.state.keyword,
        messageTemplate: this.state.messageTemplate,
        actionType: null,
        blackbaudAppeal: null,
        blackbaudCampaign: null,
        blackbaudFund: null,
        blackbaudPackage: null,
        isPledge: false,
      });
    } else if (
      Utils.equalsIgnoreCase(selectedValue?.type, MESSAGE_TYPES.accountvCard)
    ) {
      this.setState({
        messageType: selectedValue,
        questionItems: [],
        textMessage: `Hi from ${this.companyName ? this.companyName : ""
          }! Here's our contact card. Please save it to your phone so future texts from us don't get blocked or sent to spam. Thanks!`,
        closingMessage: "",
        shortlinkUrl: "",
        shortUrl: "",
        messageName: "Contact Card",
        keyword: "CONTACT",
        messageTemplate: this.state.messageTemplate,
        actionType: null,
        blackbaudAppeal: null,
        blackbaudCampaign: null,
        blackbaudFund: null,
        blackbaudPackage: null,
        isPledge: false,
      });
    } else {
      // this.getMessageTemplateList(selectedValue);
      // this.getPledgeStaticData();
      this.setState({
        messageType: selectedValue,
        questionItems: [],
        closingMessage: "",
        shortlinkUrl: "",
        shortUrl: "",
        actionType: null,
        blackbaudAppeal: null,
        blackbaudCampaign: null,
        blackbaudFund: null,
        blackbaudPackage: null,
        isPledge: false,
      });
    }
  }

  handleColorCodeChange(e) {
    const selectedId = e.target.value;
    const selectedOption = this.smsCategoryColorList.find(
      (item) => item.id === selectedId
    );

    if (selectedOption) {
      this.setState({
        colorCode: selectedOption.hashColor,
        colorCodeId: selectedOption.id,
      });
    }
  }

  handleActivityAlertChange(selectedValue) {
    if (selectedValue?.type === "Off") {
      this.setState({
        activityAlert: selectedValue,
        mobile: "",
        alertEmail: "",
        emailItems: "",
        mobileItems: "",
      });
    } else if (selectedValue?.type === "REPLY") {
      // if (this.state.emailItems.length <= 0) {
      //   this.addEmailItem();
      // }
      // if (this.state.mobileItems.length <= 0) {
      //   this.addMobileNoItem();
      // }
      this.setState({
        activityAlert: selectedValue,
        alertEmail: "",
      });
    } else {
      // if (this.state.mobileItems.length <= 0) {
      //   this.addMobileNoItem();
      // }
      this.setState({
        activityAlert: selectedValue,
        emailItems: "",
      });
    }
  }

  handleMobileNoChange(e) {
    this.setState({
      mobileItems: e.target.value,
    });
  }
  handleEmailsChange(e) {
    this.setState({
      emailItems: e.target.value,
    });
  }

  handleMessageNameChange(e) {
    this.setState({
      messageName: e.target.value,
    });
    this.debouncedMessageName(this.state.messageId);
  }
  getDuplicateMessageName() {
    const messageName = this.state.messageName?.trim();

    if (messageName && messageName.length > 48) {
      PtsAlert.error("Message name cannot exceed 48 characters.");
      return;
    }

    if (messageName !== "") {
      const postObject = {
        header: this.header,
        smsMessage: {
          messageName: this.state.messageName,
        },
      };
      FetchServerData.callPostService(
        "/smsmessagems/isDuplicateName",
        postObject
      ).then((output) => {
        if (output.status === "SUCCESS") {
          let smsMessageDetails = output.data.smsMessage;
          this.setState({
            messageName: smsMessageDetails.messageName,
          });
        } else {
          this.setState({
            messageName: "",
          });
        }
      });
    }
  }
  getDuplicateKeyword(e) {
    const keyword = this.state.keyword;
    if (keyword && keyword.length > 44) {
      PtsAlert.error("Keyword cannot exceed 44 characters.");
      return;
    }
    if (keyword !== "") {
      const postObject = {
        header: this.header,
        smsMessage: {
          keyword: this.state.keyword,
        },
      };
      FetchServerData.callPostService(
        "/smsmessagems/isDuplicateKeyword",
        postObject
      ).then((output) => {
        if (output.status === "SUCCESS") {
          let smsMessageDetails = output.data.smsMessage;
          this.setState({
            keyword: smsMessageDetails.keyword,
          });
        } else {
          this.setState({
            keyword: "",
          });
        }
      });
    }
  }

  handleKeywordChange(e) {
    let val = e.target.value;
    const hasSpaceError = !/^\S*$/.test(val);
    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.textToPledge
      )
    ) {
      this.setState({
        keyword: val,
        keywordSpaceError: hasSpaceError,
      });
    } else {
      this.debouncedKeyword(this.state.messageId);
      this.setState({
        keyword: e.target.value,
        keywordSpaceError: false,
      });
    }
    if (Utils.isRestrictedKeyWord(e.target.value) === true) {
      this.setState({
        keywordErrormessage: true,
        isAssignToGroup: false,
      });
    } else {
      this.setState({
        keywordErrormessage: false,
        isAssignToGroup: e.target.value === "" && false,
        bannerText:
          e.target.value !== "" &&
            this.tollFreeNumberStatus !== "Verified" &&
            this.tollFreeNumberStatus !== "Approved"
            ? `To ${this.state.messageType?.type === "TextToPledge"
              ? "pledge"
              : "donate"
            }, text "${e.target.value}" to ${Utils
              .viewTollFreeNumberFormate(this.tollfreeNumber)
              .slice(-12)}.`
            : "Thank you for your support!",
      });
    }
  }

  handleKeywordOnBlur(e) {
    this.getDuplicateKeyword(e.target.value);
    if (Utils.isRestrictedKeyWord(this.state.keyword) === true) {
      this.setState({
        keywordErrormessage: true,
      });
    } else {
      this.setState({
        keywordErrormessage: false,
      });
    }
  }

  handleAssignToGroupChange(selectedValue) {
    this.setState({
      assignToGroup: selectedValue,
    });
  }

  handleIsAssignToGroup = (e) => {
    const isChecked = e.target.checked;

    this.setState({
      isAssignToGroup: isChecked,
      assignToGroupId: isChecked ? this.state.assignToGroupId : "",
    });

    if (isChecked) {
      this.getGroupList();
    }
  };


  getGroupList() {
    const postObject = {
      header: this.header,
      event: {
        id: this.businessDomainId,
      },
    };

    FetchServerData.callPostService(AllGroupList_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let smsGroupList = output.data.groupList;
          this.setState({
            smsGroupList: smsGroupList,
            // assignToGroup: smsGroupList[0],
          });
        } else {
        }
      }
    );
  }


  handleAlertEmailChange(e) {
    this.setState({
      alertEmail: e.target.value,
    });
  }
  handleAlertMobileNoChange(e) {
    this.setState({
      alertMobileNo: e.target.value,
    });
  }

  handleNeonRecordActivityChange = (event) => {
    this.setState({
      neonRecordActivity: event.target.value === "true",
      isBlackbaudActivity: false,
    });
  };
  handleBlackbaudActivityChange = (event) => {
    if (event.target.value === "true") {
      this.getActionTypes();
    }
    this.setState({
      neonRecordActivity: false,
      isBlackbaudActivity: event.target.value === "true",
      actionType: Utils.getArrayElement(this.state.actionTypeList, 0),
    });
  };

  handleDpTextActivityChange = (event) => {
    this.setState({
      isDptextActivity: event.target.value === "true",
    });
  };
  handleRecordAsPledgeChange(newValue) {
    this.setState({
      isRecordAsPledge: newValue ? newValue.value : false,
    });
  }

  handleTextPledgeMessageChange(e) {
    let cursorPosition = e.target.selectionStart;
    let val = e.target.value;
    // val = val?.replace(/—/g, "");
    // let isMeterSetting = true;
    // if (isMeterSetting) {
    //   this.getPledgeStaticData();
    // }
    if (this.accountSettings?.textMessageLength < Utils.countLetters(val)) {
      this.setState({
        cursorPosition: cursorPosition,
        textPledgeMessage: val,
        isTextMessageLength: true,
        // isMeterSetting: true,
        // isPledge: isMeterSetting === false && false,
      });
    } else {
      this.setState({
        cursorPosition: cursorPosition,
        textPledgeMessage: val,
        isTextMessageLength: false,
        // isMeterSetting: true,
        // isPledge: isMeterSetting === false && false,
      });
    }
    this.adjustTextareaHeight();
  }

  adjustTextareaHeight = () => {
    if (this.textareaRef.current) {
      this.textareaRef.current.style.height = "auto"; // Reset height
      this.textareaRef.current.style.height =
        this.textareaRef.current.scrollHeight + "px"; // Set new height
    }
  };

  handleMeterSettingCheck(e) {
    if (e.target.checked) {
      this.getPledgeStaticData();
    }
    this.setState({
      isPledge: e.target.checked,
    });
  }

  handleInsertItMessageChange(e) {
    this.setState((prevState) => ({
      textMessage: prevState.textMessage?.includes(
        "Msg&data rates apply. STOP to quit."
      )
        ? prevState.textMessage // Prevents duplicate text
        : prevState.textMessage + " Msg&data rates apply. STOP to quit.",
    }));
  }

  handleInsertItPledgeMessageChange = () => {
    const insertText = "Msg&data rates apply. STOP to quit. ";

    this.setState((prevState) => ({
      textPledgeMessage: (prevState.textPledgeMessage || "") + insertText,
    }));
  };

  handleTextMessageChange(e) {
    let cursorPosition = e.target.selectionStart;
    let val = e.target.value;
    let isMeterSetting = val.includes("{{Payment Link}}");
    // if (isMeterSetting) {
    //   this.getPledgeStaticData();
    // }
    let hasEmDash = val.includes("—");
    const isRestricted = Utils.isRestrictedForMessageKeyWord(val);
    if (this.accountSettings?.textMessageLength < Utils.countLetters(val)) {
      this.setState({
        cursorPosition: cursorPosition,
        textMessage: val,
        isTextMessageLength: true,
        isMeterSetting: isMeterSetting,
        isPledge: isMeterSetting,
        isPaymentLinkIncluded: isMeterSetting,
        offlimitKeywordForMessage: isRestricted,
        hasEmDashError: hasEmDash
      });
    } else {
      this.setState({
        cursorPosition: cursorPosition,
        textMessage: val,
        isTextMessageLength: false,
        isMeterSetting: isMeterSetting,
        isPledge: isMeterSetting,
        isPaymentLinkIncluded: isMeterSetting,
        offlimitKeywordForMessage: isRestricted,
        hasEmDashError: hasEmDash
      });
    }
    this.adjustTextareaHeight();
  }

  handleTextMessageInsert(selectedValue) {
    const shouldInsertSpace =
      this.state.cursorPosition > 0 &&
      this.state.textMessage[this.state.cursorPosition - 1] !== " ";

    const newText =
      this.state.textMessage.substring(0, this.state.cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      selectedValue.value +
      this.state.textMessage.substring(this.state.cursorPosition);

    this.setState(
      {
        textMessage: newText,
        cursorPosition:
          this.state.cursorPosition +
          selectedValue.value.length +
          (shouldInsertSpace ? 1 : 0),
      },
      () => {
        const input = document.getElementById("messageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(
            this.state.cursorPosition,
            this.state.cursorPosition
          );
        }
      }
    );
  }


  handleTextPledgeMessageInsert(selectedValue) {
    const isBlackbaud = Utils.equalsIgnoreCase(
      this.crmIntegration,
      "BlackBaudCRM"
    );

    const isPaymentLink =
      selectedValue?.value?.includes("{{Payment Link}}");
    if (isBlackbaud && isPaymentLink) {
      this.setState({
        openPaymentLinkPopup: true,
        selectedVariable: selectedValue,
      });

      this.getCrmStaticData();
      return;
    }

    const shouldInsertSpace =
      this.state.cursorPosition > 0 &&
      this.state.textPledgeMessage[this.state.cursorPosition - 1] !== " ";

    const newText =
      this.state.textPledgeMessage.substring(0, this.state.cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      selectedValue.value +
      this.state.textPledgeMessage.substring(this.state.cursorPosition);

    this.setState(
      {
        textPledgeMessage: newText,
        cursorPosition:
          this.state.cursorPosition +
          selectedValue.value.length +
          (shouldInsertSpace ? 1 : 0),
      },
      () => {
        const input = document.getElementById("textPledgeMessageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(
            this.state.cursorPosition,
            this.state.cursorPosition
          );
        }
      }
    );
  }


  handleTextMessageShortlinkInsert() {
    this.setState({
      textMessage: `${this.state.textMessage} ${this.state.shortUrl}`,
    });
  }

  handleMessageTemplateChange(selectedMessage) {
    let messageType = {
      type: selectedMessage?.messagetype,
      id: selectedMessage?.messagetypeId,
    };
    if (
      selectedMessage?.messageName !== "Custom" &&
      selectedMessage?.messageName !== "Add New Template"
    ) {
      this.handleMessageTypeChange(messageType);
      this.setState({
        messageTemplate: selectedMessage,
        messageName: selectedMessage?.messageName,
        keyword: selectedMessage?.keyword,
        textMessage: selectedMessage?.textMessage,
        messageType: messageType,
      });
    } else {
      this.setState({
        messageTemplate: selectedMessage,
        messageName: "",
        keyword: "",
        textMessage: "",
        messageType: this.smsMessageTypeList
          ? Utils.getArrayElement(this.smsMessageTypeList, 0)
          : null,
      });
    }
  }

  handleActionTypeChange(selectedValue) {
    this.setState({
      actionType: selectedValue,
    });
  }
  handleBlackbaudAppealChange(selectedValue) {
    this.getAppealPackages(selectedValue);
    this.setState({
      blackbaudAppeal: selectedValue,
    });
  }
  handleBlackbaudPackageChange(selectedValue) {
    this.setState({
      blackbaudPackage: selectedValue,
    });
  }
  handleBlackbaudCampaignChange(selectedValue) {
    this.setState({
      blackbaudCampaign: selectedValue,
    });
  }
  handleBlackbaudFundChange(selectedValue) {
    this.setState({
      blackbaudFund: selectedValue,
    });
  }
  handleActivityCodeChange(selectedValue) {
    this.setState({
      activityCode: selectedValue,
    });
  }
  handleAssignToCodeChange(selectedValue) {
    this.setState({
      assignToCode: selectedValue,
    });
  }
  handleGeneralLedgerChange(selectedValue) {
    this.setState({
      generalLedger: selectedValue,
    });
  }
  handleCampaignChange(selectedValue) {
    this.setState({
      campaign: selectedValue,
    });
  }
  handleSolicitationChange(selectedValue) {
    this.setState({
      solicitation: selectedValue,
    });
  }
  handleSubSolicitationChange(selectedValue) {
    this.setState({
      subSolicitation: selectedValue,
    });
  }

  handleClosingTextMessageChange(e) {
    let val = e.target.value;
    // val = val?.replace(/—/g, "");
    let cursorPosition = e.target.selectionStart;

    let isMeterSetting = val.includes("{{Payment Link}}");
    // if (isMeterSetting) {
    //   this.getPledgeStaticData();
    // }

    if (this.accountSettings?.textMessageLength < Utils.countLetters(val)) {
      this.setState({
        closingTextMessage: val,
        isTextMessageLength: true,
        cursorPosition: cursorPosition,
        isMeterSetting: isMeterSetting,
        isPledge: isMeterSetting,
      });
    } else {
      this.setState({
        closingTextMessage: val,
        isTextMessageLength: false,
        cursorPosition: cursorPosition,
        isMeterSetting: isMeterSetting,
        isPledge: isMeterSetting,
      });
    }
  }

  handleClosingInsert(selectedValue) {

    const isBlackbaud = Utils.equalsIgnoreCase(
      this.crmIntegration,
      "BlackBaudCRM"
    );
    const isPaymentLink = selectedValue?.value?.includes("{{Payment Link}}");

    if (isBlackbaud && isPaymentLink) {
      this.setState({
        openPaymentLinkPopup: true,
        isClosingMessage: true,
        selectedVariable: selectedValue,
      });

      this.getCrmStaticData();
      return;
    }

    const { cursorPosition, closingTextMessage } = this.state;

    // Prevent duplicate Payment Link
    if (isPaymentLink && closingTextMessage?.includes("{{Payment Link}}")) {
      return; // stop inserting again
    }

    const shouldInsertSpace =
      cursorPosition > 0 && closingTextMessage[cursorPosition - 1] !== " ";

    const newText =
      closingTextMessage.substring(0, cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      selectedValue.value + closingTextMessage.substring(cursorPosition);

    this.setState(
      {
        closingTextMessage: newText,
        cursorPosition: cursorPosition +
          selectedValue.value.length +
          (shouldInsertSpace ? 1 : 0),
      },
      () => {
        // Ensure cursor is placed correctly
        const input = document.getElementById("closingMessageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(cursorPosition, cursorPosition);
        }
      }
    );
    // this.setState({
    //   closingTextMessage: `${this.state.closingTextMessage} ${selectedValue.value}`,
    // });
  }

  handleClosingShortlinkInsert() {
    this.setState({
      closingTextMessage: `${this.state.closingTextMessage} ${this.state.shortUrl}`,
    });
  }

  // optinFileHandler(event) {
  //   const file = event.target.files[0];
  //   if (!file) return;
  //   this.setState(
  //     {
  //       selectedFile: file,
  //     },
  //     () => this.uploadOptInFile()
  //   );
  // }

  uploadOptInFile(e) {
    // e.preventDefault();
    if (!this.state.selectedFile) {
      PtsAlert.error("Please Select The File");
      return;
    }
    const formData = new FormData();

    // Update the formData object
    formData.append(
      "file",
      this.state.selectedFile,
      this.state.selectedFile.name
    );

    formData.append("sessionid", this.header.sessionid);
    formData.append("userid", this.header.userid);
    formData.append("tid", this.header.tid);
    formData.append("isAp", this.header.isAp);
    formData.append("appclient", "W");
    FetchServerData.callPostService(UpdateMMS_Url, formData).then((output) => {
      if (output.status === "SUCCESS") {
        let uploadFileDetails = output.data;
        let fileName = uploadFileDetails?.filename;
        let urlArr = fileName.split(".");
        let fileType = urlArr[1];
        this.setState({
          mmsUrl: uploadFileDetails.url,
          fileType: fileType,
          fileName: fileName,
          isMms: true,
          mmsId: uploadFileDetails.id,
        });
        PtsAlert.success(output.message);
      } else {
      }
    });
  }

  resetFile() {
    document.getElementsByName("file")[0].value = null;
  }

  createMessageToBackend(e) {
    e.preventDefault();
    const keywordError = Utils.isRestrictedKeyWord(this.state.keyword);
    const messageError = Utils.isRestrictedForMessageKeyWord(this.state.textMessage);
    this.setState({
      keywordErrormessage: keywordError,
      offlimitKeywordForMessage: messageError,
    });

    if (keywordError || messageError || this.state.hasEmDashError) {
      return;
    }

    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.interactive
      )
    ) {
      this.setState({
        textMessage: "",
        messageTemplate: null,
      });
    } else if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.fundraising
      )
    ) {
      if (this.state.donationAmountList.length === 0) {
        this.setState({
          donationAmountError: true,
        });
        return;
      }
    }

    if (
      Utils.equalsIgnoreCase(
        this.state.messageType?.type,
        MESSAGE_TYPES.fundraising
      )
    ) {
      let smsMessageFundRaising = {
        amountQuestion: this.state.amountQuestion,
        // goalAmount: this.state.fundraisingGoal,
        introMessage: this.state.introMessage,
        amountOption1: this.state.amountOption1,
        amountOption2: this.state.amountOption2,
        amountOption3: this.state.amountOption3,
        amountOption4: this.state.amountOption4,
        donnerExperince: {
          name: this.state.donnerExperince?.name,
          displaySequence: this.state.donnerExperince?.displaySequence,
          description: this.state.donnerExperince?.description,
          id: this.state.donnerExperince?.id,
          isChecked: this.state.donnerExperince?.isSelected,
        },
      };
      this.setState({
        smsMessageFundRaising: smsMessageFundRaising,
      });
    }
    for (let i = 0; i < this.itemReferenceList.length; i++) {
      if (this.itemReferenceList[i].current) {
        this.state.questionItems[i].questionType =
          this.itemReferenceList[i].current.state.questionType;
        this.state.questionItems[i].question =
          this.itemReferenceList[i].current.state.question;
        this.state.questionItems[i].discontinueText =
          this.itemReferenceList[i].current.state.discontinueText;
        this.state.questionItems[i].step = i + 1;
      }
    }
    // for (let i = 0; i < this.emailItemReferenceList.length; i++) {
    //   if (this.emailItemReferenceList[i].current) {
    //     this.state.emailItems[i].email =
    //       this.emailItemReferenceList[i].current.state.email;
    //   }
    // }
    // for (let i = 0; i < this.mobileItemReferenceList.length; i++) {
    //   if (this.mobileItemReferenceList[i].current) {
    //     this.state.mobileItems[i].mobile =
    //       this.mobileItemReferenceList[i].current.state.mobileNo;
    //     this.state.mobileItems[i].countryCode =
    //       this.mobileItemReferenceList[i].current.state.countryCode;
    //   }
    // }
    const postObject = {
      header: this.header,
      smsMessage: {
        messageName: this.state.messageName,
        keyword: this.state.keyword?.trim(),
        textMessage: this.state.textMessage,
        messageType: this.state.messageType,
        isNeonActivity: this.state.neonRecordActivity,
        isBlackbaudActivity: this.state.isBlackbaudActivity,
        activityAlert: this.state.activityAlert,
        alertEmails: this.state.emailItems,
        alertMobiles: this.state.mobileItems,
        closingMessage: this.state.closingTextMessage,
        smsMessageQuestions: this.state.questionItems,
        smsMessageFundRaising: this.state.smsMessageFundRaising,
        mmsInfo: this.state.mmsInfo,
        isMms: this.state.isMms,
        mmsType: this.state.documentType,
        blackbaudSmsPropertiesVo: {
          actionType: this.state.actionType,
          appeal: {
            id: this.state.blackbaudAppeal?.id,
            description: this.state.blackbaudAppeal?.description,
          },
          fund: {
            id: this.state.blackbaudFund?.id,
            description: this.state.blackbaudFund?.description,
          },
          packge: {
            id: this.state.blackbaudPackage?.id,
            description: this.state.blackbaudPackage?.description,
          },
          campaign: {
            id: this.state.blackbaudCampaign?.id,
            description: this.state.blackbaudCampaign?.description,
          },
        },
        pledgeDetails: {
          goalAmount: this.state.fundraisingGoal,
          isShowGoalAmount: this.state.isShowGoalAmount,
          isOptinkeyword: this.state.isOptinkeyword,
          isAutoscroll: this.state.isAutoscroll,
          displayType: this.state.displayType,
          displayColor: this.state.displayColor,
          displayEffect: this.state.displayEffect,
          displayStyle: this.state.displayStyle,
        },
        event: {
          id: this.businessDomainId,
        },
      },
    };
    FetchServerData.callPostService(CreateMessage_Url, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
            this.props.navigate("/eventMessages", {
              state: {
                action: "view",
                eventId: this.businessDomainId,
              },
            });
          } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
            this.props.navigate("/dptextMessages", {
              state: {
                action: "view",
                eventId: this.businessDomainId,
              },
            });
          } else {
            this.props.navigate("/messages");
          }
        } else {
        }
      }
    );
  }

  createCancel() {
    if (this.businessDomain === BUSINESS_DOMAIN.eventText) {
      this.props.navigate("/eventMessages");
    } else if (this.businessDomain === BUSINESS_DOMAIN.dpText) {
      this.props.navigate("/dptextMessages");
    } else {
      this.props.navigate("/messages");
    }
  }

  onCopy = (e) => {
    this.setState({ copied: true });
  };

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleAccountDropdownOpen = (e) => {
    this.getShortLinkList();
    this.setState({ open: true, anchorEl: e.currentTarget });
  };

  getShortLinkList() {
    const postObject = {
      header: this.header,
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(ShortLinkList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let shortLinkList = output.data.shortLinkList;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = this.businessDomain === BUSINESS_DOMAIN.eventText ? Utils.getUtcToEventLocalTime(shortLinkList[i].createdon) : Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            shortLinkList: shortLinkList,
          });
        } else {
        }
      }
    );
  }

  addQuestionItem() {
    let items = this.state.questionItems;
    let item = {
      operation: "Add",
      question: "",
      questionType: Utils.getArrayElement(this.interactiveQuestionTypeList, 0),
    };
    items.push(item);
    this.itemReferenceList.push(React.createRef());

    this.setState({ questionItems: items });
  }

  QuestionItemDeleted(item, index) {
    if (this.valueIndexMap.has(index)) {
      this.valueIndexMap.delete(index);
    }
    let items = [];
    let itemToTrash = -999;
    for (let i = 0; i < this.state.questionItems.length; i++) {
      let invItem = this.state.questionItems[i];
      if (Utils.equalsIgnoreCase(this.state.action, "create")) {
        if (item.isDelete === true && item.index === i) {
          itemToTrash = i;
          continue;
        } else {
          invItem =
            this.itemReferenceList[i] && this.itemReferenceList[i].current
              ? this.itemReferenceList[i].current.state
              : invItem;
          items.push(invItem);
        }
      } else {
        if (item.isDelete === true && item.index === i) {
          if (Utils.equalsIgnoreCase(item.operation, "Add")) {
            itemToTrash = i;
            continue;
          }
          invItem.operation = "Delete";
        } else {
          invItem =
            this.itemReferenceList[i] && this.itemReferenceList[i].current
              ? this.itemReferenceList[i].current.state
              : invItem;
        }
        items.push(invItem);
      }
    }

    for (let i = 0; i < this.state.questionItems.length; i++) {
      if (i === itemToTrash) {
      }
    }

    let randomKey = Math.random();
    this.setState({ refreshKey: randomKey, questionItems: items });
  }

  addEmailItem() {
    let items = this.state.emailItems;
    let item = {
      operation: "ADD",
      email: "",
    };
    items.push(item);
    this.emailItemReferenceList.push(React.createRef());

    this.setState({ emailItems: items });
  }

  deleteEmailItem(item) {
    let items = [];
    let itemToTrash = -999;
    for (let i = 0; i < this.state.emailItems.length; i++) {
      let invItem = this.state.emailItems[i];
      if (Utils.equalsIgnoreCase(this.state.action, "create")) {
        if (item.isDeleteEmail === true && item.index === i) {
          itemToTrash = i;
          continue;
        } else {
          invItem =
            this.emailItemReferenceList[i] &&
              this.emailItemReferenceList[i].current
              ? this.emailItemReferenceList[i].current.state
              : invItem;
          items.push(invItem);
        }
      } else {
        if (item.isDeleteEmail === true && item.index === i) {
          if (Utils.equalsIgnoreCase(item.operation, "ADD")) {
            itemToTrash = i;
            continue;
          }
          invItem.operation = "DELETE";
        } else {
          invItem =
            this.emailItemReferenceList[i] &&
              this.emailItemReferenceList[i].current
              ? this.emailItemReferenceList[i].current.state
              : invItem;
        }
        items.push(invItem);
      }
    }

    for (let i = 0; i < this.state.emailItems.length; i++) {
      if (i === itemToTrash) {
      }
    }
    let randomKey = Math.random();
    this.setState({ emailRefreshKey: randomKey, emailItems: items });
  }

  addMobileNoItem() {
    let items = this.state.mobileItems;
    let item = {
      operation: "ADD",
      mobile: "",
    };
    items.push(item);
    this.mobileItemReferenceList.push(React.createRef());

    this.setState({ mobileItems: items });
  }

  deleteMobileNoItem(item) {
    let items = [];
    let itemToTrash = -999;
    for (let i = 0; i < this.state.mobileItems.length; i++) {
      let invItem = this.state.mobileItems[i];
      if (Utils.equalsIgnoreCase(this.state.action, "create")) {
        if (item.isDeleteMobile === true && item.index === i) {
          itemToTrash = i;
          continue;
        } else {
          invItem =
            this.mobileItemReferenceList[i] &&
              this.mobileItemReferenceList[i].current
              ? this.mobileItemReferenceList[i].current.state
              : invItem;
          items.push(invItem);
        }
      } else {
        if (item.isDeleteMobile === true && item.index === i) {
          if (Utils.equalsIgnoreCase(item.operation, "ADD")) {
            itemToTrash = i;
            continue;
          }
          invItem.operation = "DELETE";
        } else {
          invItem =
            this.mobileItemReferenceList[i] &&
              this.mobileItemReferenceList[i].current
              ? this.mobileItemReferenceList[i].current.state
              : invItem;
        }
        items.push(invItem);
      }
    }

    for (let i = 0; i < this.state.mobileItems.length; i++) {
      if (i === itemToTrash) {
      }
    }
    let randomKey = Math.random();
    this.setState({ mobileRefreshKey: randomKey, mobileItems: items });
  }

  getTableHeader() {
    return (
      <thead>
        <tr style={{ background: "#ececec" }}>
          <td
            style={{
              width: "5%",
              border: "1px solid #d8d7d7",
              padding: "0.5em",
            }}
          >
            <strong>#</strong>
          </td>
          <td
            style={{
              width: "10%",
              border: "1px solid #d8d7d7",
              padding: "0.5em",
            }}
          >
            <strong>Question Type</strong>
          </td>
          <td
            style={{
              width: "70%",
              border: "1px solid #d8d7d7",
              padding: "0.5em",
            }}
          >
            <strong>Question</strong>
          </td>
        </tr>
      </thead>
    );
  }

  handleChange(e, selectedValue) {
    const value = e.target.value;
    const modifiedData = [...this.state.smsFundraisingOptionList];
    modifiedData.map((item) => {
      item.isSelected = item.id === +value;
      return item;
    });
    let isIntroMessage = false;
    if (selectedValue.name === "With Introduction") {
      isIntroMessage = true;
    }
    this.setState({
      isIntroMessage: isIntroMessage,
      smsFundraisingOptionList: modifiedData,
      donnerExperince: selectedValue,
    });
  }

  handleIntroMessageChange(e) {
    let val = e.target.value;
    let res = val.substring(0, 75);
    if (res.length <= 75) {
      this.setState({ introMessage: res });
    } else {
      Utils.maxFieldLength(75);
    }
  }

  handleWithIntroductionChange(e) {
    this.setState({
      isWithChecked: !this.state.isWithChecked,
      // isWithoutChecked: false,
    });
  }
  handleWithoutIntroductionChange(e) {
    this.setState({
      // isWithoutChecked: !this.state.isWithoutChecked,
      isWithChecked: !this.state.isWithChecked,
    });
  }

  handleShortlinkUrlChange(e) {
    this.setState({
      shortlinkUrl: e.target.value,
    });
  }

  createShortlinkToBackend() {
    if (this.state.shortlinkUrl === "") {
      return PtsAlert.error("Please enter URL");
    }
    const postObject = {
      header: this.header,
      url: this.state.shortlinkUrl,
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(CreateShort_URL, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortUrl = output.data.shortUrl;
          this.setState({
            shortUrl: shortUrl,
          });
        } else {
        }
      }
    );
  }

  handleCreateShortLinkInsert(selectedValue) {
    this.setState({
      question: `${this.state.question} ${selectedValue}`,
    });
  }

  handleDonationAmountChange(e) {
    let val = e.target.value;
    this.setState({
      donationAmount: val,
    });
  }

  handleFundraisingGoalChange(e) {
    this.setState({
      fundraisingGoal: e.target.value,
    });
  }
  addDonationAmount() {
    let items = this.state.donationAmountList;
    if (items.length <= 3) {
      items.push(this.state.donationAmount);
    }
    this.setState({
      donationAmountList: items,
      amountOption1: items[0],
      amountOption2: items[1],
      amountOption3: items[2],
      amountOption4: items[3],
      donationAmount: "",
    });
  }

  deleteDonationAmount(id) {
    const currentIndex = this.state.donationAmountList.findIndex(
      (d, index) => index === id
    );
    let currentList = [...this.state.donationAmountList];
    currentList.splice(currentIndex, 1);
    this.setState({
      donationAmountList: currentList,
      amountOption1: currentList[0],
      amountOption2: currentList[1],
      amountOption3: currentList[2],
      amountOption4: currentList[3],
    });
  }

  handleInsertItAmountQuestionChange = () => {
    this.setState((prevState) => ({
      amountQuestion: prevState.amountQuestion?.includes(
        "Msg&data rates apply. STOP to quit."
      )
        ? prevState.amountQuestion // Prevents duplicate text
        : prevState.amountQuestion + " Msg&data rates apply. STOP to quit.",
    }));
  };

  handleAmountQustionChange(e) {
    let val = e.target.value;
    if (75 < val.length) {
      this.setState({ amountQuestion: val, isTextMessageLength: true });
    } else {
      this.setState({ amountQuestion: val, isTextMessageLength: false });
    }
  }
  handleAmountQustionShortlinkChange() {
    this.setState({
      amountQuestion: `${this.state.amountQuestion} ${this.state.shortUrl}`,
    });
  }

  handleSmsVariableOnDrag(e) {
    e.preventDefault();
    let smsVariable = e.target.innerHTML;
    this.setState((prevState) => ({
      textMessage: `${prevState.textMessage.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.textMessage.substring(
        this.state.cursorPosition
      )}`,
      cursorPosition: `${prevState.textMessage.substring(
        0,
        this.state.cursorPosition
      )} ${smsVariable} ${prevState.textMessage.substring(
        this.state.cursorPosition
      )}`.length,
    }));
  }

  smsQuestionTypeChange(selectedValue, index) {
    this.valueIndexMap.set(index, selectedValue.type);

    this.setState({ questionType: selectedValue });
  }

  // deleteImageInBackend() {
  //   const postObject = {
  //     header: this.header,
  //     mmsDocumentId: this.state.mmsId,
  //     smsMessage: {
  //       id: this.state.messageId,
  //     },
  //   };
  //   FetchServerData.callPostService(
  //     "/smsmessagems/deleteImage",
  //     postObject
  //   ).then((output) => {
  //     if (output.status === "SUCCESS") {
  //       PtsAlert.success(output.message);
  //       this.setState({
  //         mmsUrl: null,
  //         selectedFile: { name: "" },
  //         fileType: "",
  //         fileName: "",
  //         isMms: false,
  //         mmsId: "",
  //       });
  //     } else {
  //     }
  //   });
  // }

  addMessageTemplate(data) {
    if (
      this.MessageTemplateDialogueRef &&
      this.MessageTemplateDialogueRef.current
    ) {
      this.MessageTemplateDialogueRef.current.showMessageTemplate(
        data,
        "create"
      );
    }
  }
  editMessageTemplate(data) {
    if (
      this.MessageTemplateDialogueRef &&
      this.MessageTemplateDialogueRef.current
    ) {
      this.MessageTemplateDialogueRef.current.showMessageTemplate(data, "edit");
    }
  }

  handaleCustomerMessageTemplate() {
    this.getMessageTemplateList();
  }

  showMessageTemplate(action) {
    return (
      <CustomerMessageTemplate
        ref={this.MessageTemplateDialogueRef}
        action={action}
        onChange={this.handaleCustomerMessageTemplate.bind(this)}
      />
    );
  }

  deleteMsgTemplateDetails(rowData) {
    const postObject = {
      header: this.header,
      messageTemplate: {
        id: rowData.id,
      },
    };

    FetchServerData.callPostService("/custMsgTemplatems/delete", postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.getMessageTemplateList();
        } else {
        }
      })
      .catch((error) => { });
  }

  handle3dEffectThermometer() {
    this.setState({ is3dEffect: !this.state.is3dEffect });
  }
  handleConfettiThermometer() {
    this.setState({ isConfetti: !this.state.isConfetti });
  }
  handleMeterGoal() {
    this.setState({ isShowGoalAmount: !this.state.isShowGoalAmount });
  }

  handleOptinKeyword() {
    this.setState({ isOptinkeyword: !this.state.isOptinkeyword });
  }
  handleAutoScroll() {
    this.setState({ isAutoscroll: !this.state.isAutoscroll });
  }
  handleBannerTextChange(e) {
    this.setState({
      bannerText: e.target.value,
    });
  }
  handleBannerBackgroundColorChange(e) {
    this.setState({ bannerBackground: e.target.value });
  }
  handlebannerTextColorChanges(e) {
    this.setState({ bannerTextColor: e.target.value });
  }
  handleMeterStyleChange(displayStyle) {
    this.setState({ displayStyle: displayStyle });
  }

  getSafeColor(color) {
    if (!color) return "transparent";
    return color.startsWith("#") ? color : `#${color}`;
  }

  handleDisplayTypeChange(displayType) {
    this.setState({ displayType: displayType });
  }
  handleColorChange(color) {
    this.setState({ displayColor: color });
  }
  handleEffectChange(effect) {
    this.setState({ displayEffect: effect });
  }

  meterSetting() {
    const percentage = Math.min(
      (this.state.totalDonation / this.state.fundraisingGoal) * 100,
      100
    );
    return (
      <div
        className={
          Utils.equalsIgnoreCase(
            this.state.messageType?.type,
            MESSAGE_TYPES.textToPledge
          )
            ? "row"
            : "row mb-3"
        }
        style={{ marginTop: "1.5em" }}
      >
        <label
          className="col-sm-2 col-form-label"
          htmlFor="collapsible-supplierType"
        >
          Meter Settings
        </label>
        <div className="col-md-10">
          <div className="row">
            <div className="col-md-6">
              <div className="row d-flex">
                <div className="col-md-3">
                  <label className="form-label">
                    <b>Banner Text</b>
                    <span
                      className="p-0 ms-1"
                      style={{
                        fontWeight: "normal",
                        fontSize: "11px",
                        color: "black",
                      }}
                    ></span>
                  </label>
                </div>
                <div
                  className="col-md-9  bannertextEditor justify-content-end"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {/* <span
                    className="me-2"
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="color"
                      onChange={this.handlebannerTextColorChanges.bind(this)}
                      value={this.state.bannerTextColor}
                      onMouseEnter={() =>
                        this.setState({ isHoveringTextColor: true })
                      }
                      onMouseLeave={() =>
                        this.setState({
                          isHoveringTextColor: false,
                        })
                      }
                      style={{
                        width: 19,
                        height: 19,
                        padding: 0,
                        border: "none",
                        borderRadius: "5px",
                        background: "none",
                        cursor: "pointer",
                        verticalAlign: "middle", // for extra alignment
                        outline:
                          this.state.isHoveringTextColor === true
                            ? "2px solid #999"
                            : "1px solid transparent",
                        boxShadow:
                          this.state.isHoveringTextColor === true
                            ? "0 0 4px rgba(0, 0, 0, 0.3)"
                            : "none",
                        transition: "all 0.2s ease-in-out",
                      }}
                      autoFocus
                    />{" "}
                    <FormatColorTextIcon style={{ fontSize: "19px" }} />
                  </span>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="color"
                      onChange={this.handleBannerBackgroundColorChange.bind(
                        this
                      )}
                      value={this.state.bannerBackground}
                      onMouseEnter={() =>
                        this.setState({ isHoveringBgColor: true })
                      }
                      onMouseLeave={() =>
                        this.setState({ isHoveringBgColor: false })
                      }
                      style={{
                        width: 19,
                        height: 19,
                        padding: 0,
                        border: "none",
                        borderRadius: "5px",
                        background: "none",
                        cursor: "pointer",
                        verticalAlign: "middle", // for extra alignment
                        outline:
                          this.state.isHoveringBgColor === true
                            ? "2px solid #999"
                            : "1px solid transparent",
                        boxShadow:
                          this.state.isHoveringBgColor === true
                            ? "0 0 4px rgba(0, 0, 0, 0.3)"
                            : "none",
                        transition: "all 0.2s ease-in-out",
                      }}
                      autoFocus
                    />
                  </span> */}
                  <BannerColorPicker
                    textColor={this.state.bannerTextColor}
                    backgroundColor={this.state.bannerBackground}
                    onTextColorChange={(color) =>
                      this.setState({ bannerTextColor: color })
                    }
                    onBackgroundChange={(color) =>
                      this.setState({ bannerBackground: color })
                    }
                  />
                </div>
              </div>
              <input
                title=""
                ref={this.textareaRef}
                value={this.state.bannerText}
                onChange={this.handleBannerTextChange.bind(this)}
                className="banner-form-control"
                id="BannerText"
                style={{
                  overflow: "hidden",
                  resize: "none",
                  color: this.state.bannerTextColor,
                  background: this.state.bannerBackground,
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 m-0" id="givbeeText">
              <div className="row justify-content-end mt-3">
                <div className="col-sm-8">
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    disableClearable
                    autoComplete="off"
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.displayTypeList}
                    value={this.state.displayType}
                    getOptionLabel={(option) => option.description}
                    defaultValue={this.state.displayType}
                    onChange={(event, value) => {
                      this.handleDisplayTypeChange(value);
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Please Select"
                        variant="outlined"
                        size="small"
                        className="autoComplete"
                        required
                        title=""
                        style={{ background: "#fff" }}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="row mt-3 justify-content-end">
                <label
                  className="col-sm-7 form-label fw-bold text-end align-self-center"
                  htmlFor="collapsible-style"
                >
                  Style
                </label>
                <div className="col-sm-5">
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    disableClearable
                    autoComplete="off"
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.displayStyles}
                    value={this.state.displayStyle}
                    getOptionLabel={(option) => option.description}
                    defaultValue={this.state.displayStyle}
                    onChange={(event, value) => {
                      this.handleMeterStyleChange(value);
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Please Select"
                        variant="outlined"
                        size="small"
                        className="autoComplete"
                        required
                        title=""
                        style={{ background: "#fff" }}
                      />
                    )}
                  />
                </div>
              </div>
              <div
                className="row justify-content-end"
                style={{ marginTop: "12px" }}
              >
                <label
                  className="col-sm-7 form-label fw-bold text-end align-self-center"
                  htmlFor="collapsible-style"
                >
                  Goal Amount
                </label>

                <div className="col-sm-5 d-flex">
                  <span
                    className="input-group-addon align-content-center inputFundraising"
                    style={{ width: "40px" }}
                  >
                    $
                  </span>
                  <input
                    type="number"
                    autoComplete="off"
                    id="multiStepsFirstName"
                    name="multiStepsFirstName"
                    className="form-control"
                    style={{
                      // textAlign: "end",
                      borderRadius: " 0rem 0.375rem 0.375rem 0rem",
                    }}
                    value={this.state.fundraisingGoal}
                    onChange={this.handleFundraisingGoalChange.bind(this)}
                    onFocus={(event) => {
                      event.target.select();
                    }}
                  />
                </div>
              </div>
              <div className="row mt-3 justify-content-end">
                <label
                  className="col-sm-7 form-label fw-bold text-end align-self-center"
                  htmlFor="collapsible-style"
                >
                  Measure
                </label>
                <div className="col-sm-5">
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    disableClearable
                    autoComplete="off"
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.measureTypes}
                    value={this.state.measureType}
                    getOptionLabel={(option) => option.type}
                    defaultValue={this.state.measureType}
                    onChange={(event, value) => {
                      this.handleMeasureTypeChange(value);
                    }}
                    inputprops={{
                      style: { textTransform: "capitalize" },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Please Select"
                        variant="outlined"
                        size="small"
                        className="autoComplete"
                        required
                        title=""
                        style={{ background: "#fff" }}
                      />
                    )}
                  />
                </div>
              </div>

              {/* <div className="row mt-3 justify-content-end">
                <label
                  className="col-sm-7 form-label fw-bold text-end align-self-center"
                  htmlFor="collapsible-style"
                >
                  Effect
                </label>
                <div className="col-sm-5">
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    disableClearable
                    autoComplete="off"
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.effectTypeList}
                    value={this.state.displayEffect}
                    getOptionLabel={(option) => option.effect}
                    defaultValue={this.state.displayEffect}
                    onChange={(event, value) => {
                      this.handleEffectChange(value);
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Please Select"
                        variant="outlined"
                        size="small"
                        className="autoComplete"
                        required
                        title=""
                        style={{ background: "#fff" }}
                      />
                    )}
                  />
                </div>
              </div> */}
              {this.state.displayStyle?.name !== "Ticker" &&
                this.state.displayStyle?.name !== "Speedometer" && (
                  <div className="row mt-3 justify-content-end">
                    <label
                      className="col-sm-7 form-label fw-bold text-end align-self-center"
                      htmlFor="collapsible-style"
                    >
                      Color
                    </label>
                    <div className="col-sm-5">
                      <Select
                        value={this.state.displayColor?.id}
                        onChange={(event) => this.handleColorChange(event)}
                        className="selectColorCode action-button"
                        style={{
                          backgroundColor: this.getSafeColor(
                            this.state.displayColor?.hashColor
                          ),
                          border: "1px solid #a6adb4",
                          height: "36px",
                          width: "36px",
                        }}
                        renderValue={() => null}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              overflowY: "auto",
                            },
                          },
                          MenuListProps: {
                            className: "colorMenuListWrap",
                          },
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                        }}
                      >
                        {this.state.colorTypeList?.map((option) => (
                          <MenuItem
                            key={option.id}
                            value={option.id}
                            className="colorCodeMenuItem"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              fontSize: "15px",
                              cursor: "pointer",
                              padding: "8px",
                              "&:hover div": {
                                transform: "scale(1.1)",
                                boxShadow: "0 0 6px #e6effc",
                                borderRadius: "3px",
                              },
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: this.getSafeColor(
                                  option.hashColor
                                ),
                                width: 18,
                                height: 18,
                                borderRadius: "3px",
                                border: "1px solid #ccc",
                                transition: "all 0.2s ease-in-out",
                              }}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                )}
              <div className="row mt-3 justify-content-end">
                {this.state.displayStyle?.name !== "Ticker" && (
                  <div className="col-sm-5  d-flex align-items-center align-self-center">
                    <span className="me-2">
                      <input
                        type="checkbox"
                        style={{ cursor: "pointer" }}
                        value={this.state.isShowGoalAmount}
                        onChange={(e) => this.handleMeterGoal(e)}
                        checked={this.state.isShowGoalAmount}
                      />
                    </span>
                    <p
                      className="form-label "
                      htmlFor="collapsible-lastname"
                      onClick={(e) => this.handleMeterGoal(e)}
                      style={{ cursor: "pointer" }}
                    >
                      Meter/Goal
                    </p>
                  </div>
                )}
              </div>
              {this.state.displayStyle?.name !== "Speedometer" &&
                this.state.displayStyle?.name !== "Ticker" && (
                  <div className="row justify-content-end">
                    <div className="col-sm-5  d-flex align-items-center align-self-center">
                      <span className="me-2">
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer" }}
                          value={this.state.is3dEffect}
                          onChange={(e) => this.handle3dEffectThermometer(e)}
                          checked={this.state.is3dEffect}
                        />
                      </span>
                      <p
                        className="form-label "
                        htmlFor="collapsible-lastname"
                        onClick={(e) => this.handle3dEffectThermometer(e)}
                        style={{ cursor: "pointer" }}
                      >
                        3D Effect
                      </p>
                    </div>
                  </div>
                )}
              <div className="row justify-content-end">
                <div className="col-sm-5  d-flex align-items-center align-self-center">
                  <span className="me-2">
                    <input
                      type="checkbox"
                      style={{ cursor: "pointer" }}
                      value={this.state.isConfetti}
                      onChange={(e) => this.handleConfettiThermometer(e)}
                      checked={this.state.isConfetti}
                    />
                  </span>
                  <p
                    className="form-label "
                    htmlFor="collapsible-lastname"
                    onClick={(e) => this.handleConfettiThermometer(e)}
                    style={{ cursor: "pointer" }}
                  >
                    Confetti
                  </p>
                </div>
              </div>
              {/* {this.state.displayStyle?.name !== "Ticker" && (
                <div className="row justify-content-end">
                  <div className="col-sm-5  d-flex align-items-center align-self-center">
                    <span className="me-2">
                      <input
                        type="checkbox"
                        style={{ cursor: "pointer" }}
                        value={this.state.isOptinkeyword}
                        onChange={(e) => this.handleOptinKeyword(e)}
                        checked={this.state.isOptinkeyword}
                      />
                    </span>
                    <p
                      className="form-label "
                      htmlFor="collapsible-lastname"
                      onClick={(e) => this.handleOptinKeyword(e)}
                      style={{ cursor: "pointer" }}
                    >
                      QR Code
                    </p>
                  </div>
                </div>
              )} */}
              {/* <div className="row justify-content-end">
            <div className="col-sm-5  d-flex align-items-center align-self-center">
              <span className="me-2">
                <input
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                  value={this.state.isAutoscroll}
                  onChange={(e) => this.handleAutoScroll(e)}
                  checked={this.state.isAutoscroll}
                />
              </span>
              <p
                className="form-label "
                htmlFor="collapsible-lastname"
                onClick={(e) => this.handleAutoScroll(e)}
                style={{ cursor: "pointer" }}
              >
                Auto-scroll
              </p>
            </div>
          </div> */}
            </div>
            <div className="col-sm-4 text-center position-relative align-self-center">
              <div className="position-relative">
                <>
                  {this.state.isConfetti && (
                    <div
                      className="confetti-container"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        overflow: "hidden",
                        pointerEvents: "none",
                      }}
                    >
                      <Confetti
                        gravity={0.1}
                        wind={0}
                        numberOfPieces={200}
                        width={350} // Restrict width
                        height={400} // Restrict height
                      />
                    </div>
                  )}
                  {this.state.displayStyle?.name === "Wide Meter" && (
                    <>
                      <Container sx={{ textAlign: "center" }}>
                        <Box
                          sx={{
                            top: "4px",
                            height: "41px",
                            width: "62px",
                            left: "122px",
                            zIndex: "999",
                            background: "#ddd",
                            borderRadius: "50px 50px 0px 0px",
                            position: "relative",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column-reverse",
                            border: "12px solid #ccc",
                            borderBottom: "none",
                            transform: "rotateX(10deg)",
                            transformStyle: "preserve-3d",
                            perspective: "1000px",
                            boxShadow: this.state.is3dEffect
                              ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4), inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                              : "none",
                          }}
                        ></Box>
                        <Box
                          sx={{
                            textAlign: "center",
                            position: "relative",
                            height: "220px",
                          }}
                        >
                          {/* Goal Labels */}
                          {this.state.isShowGoalAmount && (
                            <Box
                              sx={{
                                position: "absolute",
                                textAlign: "right",
                                right: "63%",
                                top: "0px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                height: "150px",
                                color: "#353538",
                                fontWeight: "800",
                              }}
                            >
                              {this.state.measureType?.type === "% Meter" ? (
                                <>
                                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                    (value, index) => {
                                      const amount =
                                        this.state.fundraisingGoal * value;
                                      return (
                                        <Typography
                                          key={index}
                                          variant="body2"
                                          sx={{
                                            visibility:
                                              amount === 0
                                                ? "hidden"
                                                : "visible",
                                            fontSize: ["12px", "!important"],
                                          }}
                                        >
                                          {`${(value * 100).toFixed(0)}%`}
                                        </Typography>
                                      );
                                    }
                                  )}
                                </>
                              ) : (
                                <>
                                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                    (value, index) => {
                                      const amount =
                                        this.state.fundraisingGoal * value;
                                      return (
                                        <span
                                          key={index}
                                          variant="body2"
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "400",
                                            visibility:
                                              amount === 0
                                                ? "hidden"
                                                : "visible",
                                          }}
                                        >
                                          ${Utils.formatCompactNumber(amount)}
                                        </span>
                                      );
                                    }
                                  )}
                                </>
                              )}
                            </Box>
                          )}
                          {/* Thermometer Container */}
                          <Box
                            sx={{
                              height: "150px",
                              width: "62px",
                              left: "122px",
                              zIndex: "1",
                              background: "#ddd",
                              position: "relative",
                              overflow: "hidden",
                              display: "flex",
                              flexDirection: "column-reverse",
                              border: "12px solid #ccc",
                              borderBottom: "none",
                              borderTop: "none",
                              boxShadow: this.state.is3dEffect
                                ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                                : "none",
                            }}
                          >
                            {/* Mercury Level */}
                            {this.state.isShowGoalAmount && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  left: "-15px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  height: "150px",
                                  color: "#fff",
                                  fontWeight: "800",
                                }}
                              >
                                {[...Array(50)].map((_, index) => (
                                  <Box
                                    key={index}
                                    sx={{
                                      position: "absolute",
                                      bottom: `${index * 4}%`,
                                      left: "10px",
                                      width: index % 5 === 0 ? "16px" : "10px",
                                      height: index % 5 === 0 ? "1px" : "0.5px",
                                      background: "#000",
                                      opacity: index % 5 === 0 ? 0.8 : 0.6,
                                    }}
                                  />
                                ))}
                              </Box>
                            )}
                            <Box
                              sx={{
                                width: "100%",
                                background: this.state.displayColor?.hashColor,
                                transition: "height 1.5s ease-in-out",
                                height: `${Math.min(
                                  (this.state.totalDonation /
                                    this.state.fundraisingGoal) *
                                  100,
                                  100
                                )}%`,
                                boxShadow: this.state.is3dEffect
                                  ? "inset -4px 0 8px rgba(0, 0, 0, 0.4),inset 4px 0 8px rgba(0, 0, 0, 0.4),-4px 0 8px rgba(0, 0, 0, 0.6),4px 0 8px rgba(0, 0, 0, 0.4)"
                                  : "none",
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              width: "100px",
                              height: "100px",
                              background: this.state.displayColor?.hashColor,
                              borderRadius: "50%",
                              border: "12px solid #ccc",
                              position: "relative",
                              top: "-18px",
                              left: "153px",
                              transform: "translateX(-50%)",
                              boxShadow: this.state.is3dEffect
                                ? "inset -4px 0 8px rgba(0, 0, 0, 0.4), inset 4px 0 8px rgba(0, 0, 0, 0.4)"
                                : "none",

                              // boxShadow: "inset 0 0 25px 10px rgba(255, 255, 200, 0.6)", // Inner glow effect
                              "&::before": {
                                content: '""', // ✅ Required for ::before to show
                                position: "absolute",
                                top: "16%",
                                left: "5%",
                                width: "60%",
                                height: "47%",
                                background:
                                  "radial-gradient(circle, rgba(255,255,255,0.7) 0%, transparent 90%)",
                                clipPath: "ellipse(60% 60% at 60% 60%)",
                                borderRadius: "50%",
                                filter: "blur(1px)",
                                transform: "rotate(-47deg)",
                                zIndex: 2,
                              },
                            }}
                          />
                        </Box>
                      </Container>
                    </>
                  )}
                  {this.state.displayStyle?.name === "Skinny Meter" && (
                    <>
                      <Container sx={{ textAlign: "center" }}>
                        <Box
                          sx={{
                            top: "4px",
                            height: "34px",
                            width: "46px",
                            left: "130px",
                            zIndex: "999",
                            background: "#ddd",
                            borderRadius: "50px 50px 0px 0px",
                            position: "relative",
                            overflow: "hidden",
                            display: "flex",
                            flexDirection: "column-reverse",
                            border: "10px solid #ccc",
                            borderBottom: "none",
                            transform: "rotateX(10deg)",
                            transformStyle: "preserve-3d",
                            perspective: "1000px",
                            boxShadow: this.state.is3dEffect
                              ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4), inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                              : "none",
                          }}
                        ></Box>
                        <Box
                          sx={{
                            textAlign: "center",
                            position: "relative",
                            height: "220px",
                          }}
                        >
                          {this.state.isShowGoalAmount && (
                            <Box
                              sx={{
                                position: "absolute",
                                textAlign: "right",
                                right: "60%",
                                top: "0px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                height: "175px",
                                color: "#353538",
                                fontWeight: "800",
                              }}
                            >
                              {this.state.measureType?.type === "% Meter" ? (
                                <>
                                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                    (value, index) => {
                                      const amount =
                                        this.state.fundraisingGoal * value;
                                      return (
                                        <Typography
                                          key={index}
                                          variant="body2"
                                          sx={{
                                            visibility:
                                              amount === 0
                                                ? "hidden"
                                                : "visible",
                                            fontSize: ["12px", "!important"],
                                          }}
                                        >
                                          {`${(value * 100).toFixed(0)}%`}
                                        </Typography>
                                      );
                                    }
                                  )}
                                </>
                              ) : (
                                <>
                                  {[1, 0.8, 0.6, 0.4, 0.2, 0].map(
                                    (value, index) => {
                                      const amount =
                                        this.state.fundraisingGoal * value;
                                      return (
                                        <span
                                          key={index}
                                          variant="body2"
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: "400",
                                            visibility:
                                              amount === 0
                                                ? "hidden"
                                                : "visible",
                                          }}
                                        >
                                          ${Utils.formatCompactNumber(amount)}
                                        </span>
                                      );
                                    }
                                  )}
                                </>
                              )}
                            </Box>
                          )}
                          <Box
                            sx={{
                              height: "175px",
                              width: "46px",
                              left: "130px",
                              zIndex: "999",
                              background: "#ddd",
                              position: "relative",
                              overflow: "hidden",
                              display: "flex",
                              flexDirection: "column-reverse",
                              border: "10px solid #ccc",
                              borderBottom: "none",
                              borderTop: "none",
                              clipPath:
                                "polygon(0 0, 100% 0, 100% 98%, 50% 100%, 0 98%)",
                              boxShadow: this.state.is3dEffect
                                ? "inset 10px 0 8px -6px rgba(0, 0, 0, 0.4),inset -10px 0 8px -6px rgba(0, 0, 0, 0.4)"
                                : "none",
                            }}
                          >
                            {this.state.isShowGoalAmount && (
                              <Box
                                sx={{
                                  position: "absolute",
                                  left: "-15px",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-betrightween",
                                  height: "175px",
                                  color: "#fff",
                                  fontWeight: "800",
                                }}
                              >
                                {[...Array(50)].map((_, index) => (
                                  <Box
                                    key={index}
                                    sx={{
                                      position: "absolute",
                                      bottom: `${index * 4}%`,
                                      left: "10px",
                                      width: index % 5 === 0 ? "16px" : "10px",
                                      height: index % 5 === 0 ? "1px" : "0.5px",
                                      background: "#000",
                                      opacity: index % 5 === 0 ? 0.8 : 0.6,
                                    }}
                                  />
                                ))}
                              </Box>
                            )}
                            <Box
                              sx={{
                                width: "100%",
                                background: this.state.displayColor?.hashColor,
                                transition: "height 1.5s ease-in-out",
                                height: `${Math.min(
                                  (this.state.totalDonation /
                                    this.state.fundraisingGoal) *
                                  100,
                                  100
                                )}%`,
                                boxShadow: this.state.is3dEffect
                                  ? "inset -4px 0 8px rgba(0, 0, 0, 0.4),inset 4px 0 8px rgba(0, 0, 0, 0.4),-4px 0 8px rgba(0, 0, 0, 0.6),4px 0 8px rgba(0, 0, 0, 0.4)"
                                  : "none",
                              }}
                            />
                          </Box>
                          <Box
                            sx={{
                              width: "75px",
                              height: "75px",
                              background: this.state.displayColor?.hashColor,
                              borderRadius: "50%",
                              border: "10px solid #ccc",
                              position: "relative",
                              top: "-15px",
                              left: "152px",
                              transform: "translateX(-50%)",
                              boxShadow: this.state.is3dEffect
                                ? "inset -4px 0 8px rgba(0, 0, 0, 0.4), inset 4px 0 8px rgba(0, 0, 0, 0.4)"
                                : "none",
                              "&::before": {
                                content: '""', // ✅ Required for ::before to show
                                position: "absolute",
                                top: "11%",
                                left: "8%",
                                width: "86%",
                                height: "60%",
                                background:
                                  "radial-gradient(circle, rgba(255,255,255,0.7) 0%, transparent 90%)",
                                clipPath: "ellipse(40% 40% at 40% 40%)",
                                borderRadius: "50%",
                                filter: "blur(1px)",
                                transform: "rotate(-33deg)",
                                zIndex: 2,
                              },
                            }}
                          />
                        </Box>
                      </Container>
                    </>
                  )}
                  {this.state.displayStyle?.name === "HorizontalBar" && (
                    <>
                      <Container sx={{ textAlign: "center" }}>
                        <HorizontalBar
                          goal={this.state.fundraisingGoal}
                          raised={this.state.totalDonation}
                          color={this.state.displayColor?.hashColor}
                          displayType={this.state.displayStyle?.name}
                          isShowGoalAmount={this.state.isShowGoalAmount}
                          is3dEffect={this.state.is3dEffect}
                          measureType={this.state.measureType}
                          pageId="Pledge"
                        />
                      </Container>
                    </>
                  )}
                  {this.state.displayStyle?.name === "Speedometer" && (
                    <>
                      <span className="pledgeSpeedometer">
                        <ReactSpeedometer
                          labelFontSize="12px"
                          valueTextFontSize="16px"
                          forceRender={true}
                          minValue={0}
                          maxValue={
                            this.state.measureType?.type === "% Meter"
                              ? 100
                              : this.safeNum(this.state.fundraisingGoal)
                          }
                          // value={this.safeNum(this.state.totalDonation)}
                          value={
                            this.state.measureType?.type === "% Meter"
                              ? Math.min(percentage, 100)
                              : Math.min(
                                this.safeNum(this.state.totalDonation),
                                this.safeNum(this.state.fundraisingGoal)
                              )
                          }
                          segmentColors={[
                            "#86cf34",
                            "#eaf03a",
                            "#f09c24",
                            "#f44336",
                          ]}
                          segments={4}
                          maxSegmentLabels={this.state.isShowGoalAmount ? 5 : 0}
                          segmentValueFormatter={(val) =>
                            this.state.measureType?.type === "% Meter"
                              ? `${val.toLocaleString()}%`
                              : `$${this.safeNum(val)?.toLocaleString()}`
                          }
                          currentValueText={`$${this.safeNum(
                            this.state.totalDonation
                          )?.toLocaleString()}`}
                          width={300}
                          height={200}
                          needleColor="#666666"
                          ringWidth={30}
                        />
                      </span>
                    </>
                  )}
                  {this.state.displayStyle?.name === "Ticker" && (
                    <>
                      <div
                        className="row"
                        style={{
                          left: "64px",
                          textAlign: "center",
                          background: "#39b54a",
                          height: "180px",
                          width: "250px",
                          position: "relative",
                          overflow: "hidden",
                          display: "flex",
                          alignItems: "flex-end",
                        }}
                      >
                        <div
                          style={{
                            position: "absolute",
                            top: "42%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            color: "#fff",
                            fontSize: "18px",
                            textAlign: "center",
                            padding: "0 25px",
                            zIndex: 1,
                          }}
                        >
                          Display your own image, slideshow or video on this
                          green screen.
                        </div>
                        <div
                          className="col-sm-12 d-flex align-items-center"
                          style={{
                            width: "100%",
                            backgroundColor: "black",
                            padding: "10px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                              fontSize: "20px",
                              fontWeight: "700",
                              color: "#fff",
                              animation: "scrollLeft 10s linear infinite",
                            }}
                          >
                            {this.state.donationList
                              ?.concat(this.state.donationList) // Duplicate list for smooth scrolling
                              ?.map((item, index) => (
                                <span key={index}>
                                  {item.isShowAnonymous
                                    ? "Anonymous"
                                    : `${item.firstName} ${item.lastName}`}{" "}
                                  ${item.amount} &nbsp;&nbsp;
                                </span>
                              ))}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  smsQuestionOnChange() {
    const isMeterSetting = this.itemReferenceList?.some(
      (ref) =>
        ref.current &&
        ref.current.state &&
        typeof ref.current.state.question === "string" &&
        ref.current.state.question.includes("{{Payment Link}}")
    );
    this.setState({
      isMeterSetting: isMeterSetting,
      isPledge: isMeterSetting,
    });
  }

  safeNum = (val) => {
    const n = Number(val);
    return Number.isFinite(n) ? n : "";
  };

  getInitials(name) {
    if (!name) return "?";
    const parts = name.split(" ");
    return (
      (parts[0][0] || "").toUpperCase() +
      (parts.length > 1 ? parts[parts.length - 1][0].toUpperCase() : "")
    );
  }
  vCardDetails() {
    return (
      <div className="row">
        <div className="col-sm-9 pe-0 d-flex">
          <div className="row">
            <div
              className="p-3"
              style={{
                border: "1px solid #e0e0e0",
                background: "#f2f5f9 ",
              }}
            >
              <div className="row">
                {/* Profile Section */}
                <div className="col-md-3 text-center mb-3 mb-md-0">
                  <div
                    className="d-flex align-items-center justify-content-center text-white mx-auto mb-2"
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #1976d2, #64b5f6)",
                      fontSize: "2rem",
                      fontWeight: "600",
                    }}
                  >
                    {this.state.contact?.coverUrl ? (
                      <img
                        src={this.state.contact?.coverUrl}
                        alt={this.state.contact.name || "Profile"}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      this.getInitials(this.state.contact?.name)
                    )}
                  </div>
                </div>

                {/* Info Section */}
                <div className="col-md-9">
                  {(this.state.contact?.title || this.state.contact?.org) && (
                    <div className="d-flex align-items-start mb-2">
                      <BusinessIcon
                        className="text-primary me-2 mt-1"
                        fontSize="small"
                      />
                      <div>
                        {this.state.contact?.name &&
                          this.state.contact?.org && (
                            <div
                              style={{
                                fontSize: "0.9rem",
                                wordBreak: "break-word",
                              }}
                            >
                              <h6 className="fw-bold mb-0">
                                {this.state.contact?.name || "No Name"}
                              </h6>
                              <small className="">
                                {this.state.contact?.title || ""}{" "}
                                {this.state.contact?.org
                                  ? `${this.state.contact?.org}`
                                  : ""}
                              </small>
                            </div>
                          )}
                      </div>
                    </div>
                  )}

                  {this.state.contact?.phones?.length > 0 && (
                    <div className="d-flex align-items-start mb-2">
                      <PhoneIcon
                        className="text-primary me-2 mt-1"
                        fontSize="small"
                      />
                      <div>
                        {this.state.contact?.phones?.map((p, i) => (
                          <div
                            key={i}
                            style={{
                              fontSize: "0.9rem",
                              wordBreak: "break-word",
                            }}
                          >
                            {typeof p === "object" ? p.value : p}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {this.state.contact?.emails?.length > 0 && (
                    <div className="d-flex align-items-start mb-2">
                      <MailIcon
                        className="text-primary me-2 mt-1"
                        fontSize="small"
                      />
                      <div>
                        {this.state.contact?.emails.map((e, i) => (
                          <div
                            key={i}
                            style={{
                              fontSize: "0.9rem",
                              wordBreak: "break-word",
                            }}
                          >
                            {typeof e === "object" ? e.value : e}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {this.state.contact?.urls?.length > 0 && (
                    <div className="d-flex align-items-start mb-2">
                      <LanguageIcon
                        className="text-primary me-2"
                        fontSize="small"
                      />
                      <div
                        style={{
                          wordBreak: "break-word",
                          whiteSpace: "normal",
                        }}
                      >
                        {this.state.contact?.urls.map((u, i) => (
                          <a
                            key={i}
                            href={u.value || u}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              display: "block", // makes each URL appear on a new line
                              textDecoration: "none",
                              color: "#1976d2",
                              fontSize: "0.9rem",
                              wordBreak: "break-all", // ensures long URLs break properly
                            }}
                          >
                            {u.value || u}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}

                  {this.state.contact.addresses?.length > 0 &&
                    this.state.contact?.addresses?.some(a => a.country && a.country?.trim() !== "") && (
                      <div className="d-flex align-items-start mb-2">
                        <HomeIcon
                          className="text-primary me-2 mt-1"
                          fontSize="small"
                        />
                        <div
                          style={{
                            fontSize: "0.9rem",
                            wordBreak: "break-word",
                            whiteSpace: "normal",
                          }}
                        >
                          {this.state.contact?.addresses.map((a, i) => {
                            const fullAddress = [
                              a.street,
                              a.city,
                              a.state,
                              a.country,
                            ]
                              .filter(Boolean) // removes empty parts
                              .join(", "); // combine with commas
                            return (
                              <div
                                key={i}
                                style={{
                                  marginBottom: "4px",
                                }}
                              >
                                {fullAddress}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}

                  {this.state.contact?.note && (
                    <div className="d-flex align-items-start">
                      <NotesIcon
                        className="text-primary me-2 mt-1"
                        fontSize="small"
                      />
                      <div
                        style={{
                          fontSize: "0.9rem",
                        }}
                      >
                        {this.state.contact?.note}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <span className="fw-bold ms-4">
            <ClearIcon
              className="logoDelete"
              style={{
                cursor: "pointer",
                borderRadius: "50%",
                border: "solid 2px",
              }}
              onClick={this.deleteImageInBackend.bind(this)}
            />
          </span>
        </div>
      </div>
    );
  }

  deleteImageInBackend() {
    this.setState({
      mmsUrl: null,
      selectedFile: { name: "" },
      fileType: "",
      fileName: "",
      isMms: false,
      mmsId: "",
      mmsInfo: null,
      mmsType: "None",
    });
  }

  handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.optinFileHandler(file);
    }
  };

  handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({ selectedFile: file, isDragging: false });
      this.optinFileHandler(file);
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  optinFileHandler(file) {
    if (!file) return;
    const fileType = file?.type?.split("/")[0];
    const fileName = file?.name?.toLowerCase();
    const fileExtension = fileName.split(".").pop();
    const allowedExtensions = ["png", "jpg", "jpeg", "gif", "heic", "heif"];

    if (!allowedExtensions.includes(fileExtension)) {
      PtsAlert.error(
        "Invalid file type. Please upload JPEG, PNG, GIF, HEIC, or HEIF images only."
      );
      return;
    }

    const maxSize = 3 * 1024 * 1024;
    if (file.size > maxSize) {
      PtsAlert.error("File size must not exceed 3 MB.");
      return;
    }

    const fileUrl = URL.createObjectURL(file);
    const reader = new FileReader();

    reader.onloadend = () => {
      let base64Data = reader.result;

      // Remove the prefix: "data:<mimeType>;base64,"
      if (base64Data.startsWith("data:")) {
        base64Data = base64Data.split(",")[1];
      }
      this.setState({
        selectedFile: file,
        documentType: fileType,
        mmsUrl: fileUrl, // for preview
        isMms: true,
        mmsInfo: {
          id: null,
          contentType: fileType,
          filename: file.name,
          fileData: base64Data,
        },
      });
    };

    reader.readAsDataURL(file);
  }

  handleCreateVcardFormOpen() {
    if (this.vCardFormRef && this.vCardFormRef.current) {
      this.vCardFormRef.current.showVCardForm();
    }
  };

  handlevCardChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      this.setState({ selectedFile: file });
      this.handlevCodeFileUpload(file);
    }
  };
  handlevCardDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      this.setState({
        selectedFile: file,
        isDragging: false,
        documentType: "vCard",
      });
      this.handlevCodeFileUpload(file);
    }
  };

  handlevCardDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handlevCardDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  handlevCodeFileUpload = async (file) => {
    if (!file) return;

    const fileUrl = URL.createObjectURL(file);
    const reader = new FileReader();

    reader.onloadend = async () => {
      try {
        let text = reader.result;

        if (!text.startsWith("BEGIN:VCARD")) {
          const index = text.indexOf("BEGIN:VCARD");
          if (index >= 0) text = text.slice(index);
        }

        // Normalize newlines
        text = text.replace(/\r?\n/g, "\r\n").trim();

        // Parse vCard
        const vcard = new VCF().parse(text);

        // Phones
        let phones = vcard.get("tel");
        phones = !phones ? [] : Array.isArray(phones) ? phones : [phones];
        const phoneList = phones.map((tel) => ({
          type: Array.isArray(tel.type) ? tel.type[0] : tel.type || "other",
          value: tel.valueOf(),
        }));

        //  Emails
        let emails = vcard.get("email");
        emails = !emails ? [] : Array.isArray(emails) ? emails : [emails];
        const emailList = emails.map((e) => ({
          type: Array.isArray(e.type) ? e.type[0] : e.type || "other",
          value: e.valueOf(),
        }));

        //  URLs
        let urls = vcard.get("url");
        urls = !urls ? [] : Array.isArray(urls) ? urls : [urls];
        const urlList = urls.map((u) => ({
          type: Array.isArray(u.type) ? u.type[0] : u.type || "other",
          value: u.valueOf(),
        }));

        //  Addresses
        let adr = vcard.get("adr");
        adr = !adr ? [] : Array.isArray(adr) ? adr : [adr];
        const addressList = adr.map((a) => {
          let parts = a.valueOf();
          if (typeof parts === "string") parts = parts.split(";");
          return {
            type: Array.isArray(a.type) ? a.type[0] : a.type || "other",
            poBox: parts[0] || "",
            extended: parts[1] || "",
            street: parts[2] || "",
            city: parts[3] || "",
            state: parts[4] || "",
            postalCode: parts[5] || "",
            country: parts[6] || "",
          };
        });

        //  Handle PHOTO
        let coverUrl = "";
        const photo = vcard.get("photo");
        if (photo) {
          const value = photo.valueOf();
          if (value.startsWith("data:image")) {
            coverUrl = value;
          } else if (value.match(/^\/9j|iVBORw0KGgo|R0lGOD/)) {
            coverUrl = `data:image/jpeg;base64,${value}`;
          } else if (value.startsWith("http")) {
            try {
              const response = await fetch(value);
              const blob = await response.blob();
              const base64 = await new Promise((resolve, reject) => {
                const fr = new FileReader();
                fr.onloadend = () => resolve(fr.result);
                fr.onerror = reject;
                fr.readAsDataURL(blob);
              });
              coverUrl = base64;
            } catch (err) {
              coverUrl = value;
            }
          }
        }
        //  Structured Contact Object
        const contactData = {
          name: vcard.get("fn")?.valueOf() || "",
          nickname: vcard.get("nickname")?.valueOf() || "",
          org: vcard.get("org")?.valueOf() || "",
          title: vcard.get("title")?.valueOf() || "",
          note: vcard.get("note")?.valueOf() || "",
          phones: phoneList,
          emails: emailList,
          urls: urlList,
          addresses: addressList,
          coverUrl: coverUrl || null,
          vcardRaw: text,
        };

        this.setState({
          selectedFile: file,
          documentType: "vCard",
          isMms: true,
          mmsUrl: fileUrl,
          contact: contactData,
          mmsInfo: {
            id: null,
            contentType: "text/vcard",
            filename: file.name,
            fileData: btoa(text),
          },
        });
      } catch (err) { }
    };

    reader.readAsText(file);
  };

  createVCardDetails = async (vCardResponse) => {
    try {
      const raw = vCardResponse?.fileContent;
      const file = vCardResponse?.file;

      if (!raw || typeof raw !== "string") return null;

      let text = raw.replace(/\r?\n/g, "\r\n").trim();

      if (!text.startsWith("BEGIN:VCARD")) {
        const idx = text.indexOf("BEGIN:VCARD");
        if (idx >= 0) text = text.slice(idx).trim();
        else throw new Error("BEGIN:VCARD not found");
      }

      const vcard = new VCF().parse(text);

      const arrayOf = (field) => {
        let val = vcard.get(field);
        if (!val) return [];
        if (!Array.isArray(val)) return [val.valueOf()];
        return val.map((v) => v.valueOf());
      };

      let adr = vcard.get("adr");
      if (!adr) adr = [];
      if (!Array.isArray(adr)) adr = [adr];

      const addresses = adr.map((a) => {
        let parts = a.valueOf();
        if (typeof parts === "string") parts = parts.split(";");

        return {
          street: parts[2] || "",
          city: parts[3] || "",
          state: parts[4] || "",
          postalCode: parts[5] || "",
          country: parts[6] || "",
        };
      });

      const data = {
        name: vcard.get("fn")?.valueOf() || "",
        nickname: vcard.get("nickname")?.valueOf() || "",
        org: vcard.get("org")?.valueOf() || "",
        title: vcard.get("title")?.valueOf() || "",
        phones: arrayOf("tel"),
        emails: arrayOf("email"),
        urls: arrayOf("url"),
        note: vcard.get("note")?.valueOf() || "",
        addresses,
        coverUrl: vcard.get("photo")?.valueOf() || null,
      };

      const blob = new Blob([text], { type: "text/vcard" });
      const fileUrl = URL.createObjectURL(blob);

      const vCardInfo = {
        id: null,
        contentType: "text/vcard",
        filename: file?.name || "contact.vcf",
        fileData: btoa(text),
        extension: ".vcf",
        documentType: "vCard",
      };

      this.setState({
        contact: data,
        vCardFileData: vCardResponse,
        vCardUrl: fileUrl,
        downloadVCard: true,
        documentType: null,
        isVcard: true,
        vCardInfo: vCardInfo,
      });

      return data;

    } catch (err) {
      return null;
    }
  };

  handleClosePaymentLinkPopup = () => {
    this.setState({ openPaymentLinkPopup: false });
  };


  handleInsertPaymentLink = () => {
    const {
      selectedVariable,
      messageType,
      isClosingMessage,
      paymentLinkCallback,
    } = this.state;

    const isInteractive = Utils.equalsIgnoreCase(
      messageType?.type,
      MESSAGE_TYPES.interactive
    );

    //  Interactive + Closing Message
    if (isInteractive && isClosingMessage) {
      this.insertTextAtCursor("closingTextMessage", "{{Payment Link}}");
      return;
    }

    // Interactive (Question flow) FIXED
    if (isInteractive) {
      paymentLinkCallback?.("{{Payment Link}}");

      // Step 2: WAIT for child state update, then sync parent
      setTimeout(() => {
        this.setState((prevState) => {
          const updatedItems = prevState.questionItems.map((item, index) => {
            const ref = this.itemReferenceList[index]?.current;

            if (ref) {
              return {
                ...item,
                question: ref.state.question, // get updated question
                questionType: ref.state.questionType,
                selectedGroups: ref.state.selectedGroups,
                selectedGroupIds: ref.state.selectedGroupsIds,
                groupToJoin: ref.state.groupToJoin?.id,
                discontinueText: ref.state.discontinueText,
                step: index + 1,
              };
            }

            return item;
          });

          return {
            questionItems: updatedItems,
            openPaymentLinkPopup: false,
            paymentLinkCallback: null,
            selectedVariable: null,
          };
        });
      }, 0); // 🔥 important

      return;
    }

    // Normal / Pledge Flow
    if (!selectedVariable) return;

    const isPledge = Utils.equalsIgnoreCase(
      messageType?.type,
      MESSAGE_TYPES.textToPledge
    );

    const fieldName = isPledge
      ? "textPledgeMessage"
      : "textMessage";

    this.insertTextAtCursor(fieldName, selectedVariable.value);
  };

  insertTextAtCursor = (fieldName, text) => {
    const { cursorPosition } = this.state;
    const currentText = this.state[fieldName];

    const isPaymentLink = text.includes("{{Payment Link}}");

    // Prevent duplicate Payment Link
    if (isPaymentLink && currentText.includes("{{Payment Link}}")) {
      this.setState({
        openPaymentLinkPopup: false,
        selectedVariable: null,
      });
      return;
    }

    const shouldInsertSpace =
      cursorPosition > 0 && currentText[cursorPosition - 1] !== " ";

    const newText =
      currentText.substring(0, cursorPosition) +
      (shouldInsertSpace ? " " : "") +
      text +
      currentText.substring(cursorPosition);

    const newCursor =
      cursorPosition + text.length + (shouldInsertSpace ? 1 : 0);

    this.setState(
      {
        [fieldName]: newText,
        cursorPosition: newCursor,
        openPaymentLinkPopup: false,
        selectedVariable: null,
      },
      () => {
        const input = document.getElementById("messageBox");
        if (input) {
          input.focus();
          input.setSelectionRange(newCursor, newCursor);
        }
      }
    );
  };

  blackbaudPaymentLinkOnChange(callback) {
    this.getCrmStaticData();
    this.setState({
      openPaymentLinkPopup: true,
      paymentLinkCallback: callback,
    });
  }

  blackbaudPaymentLinkPopup = () => {
    return (
      <Dialog
        open={this.state.openPaymentLinkPopup}
        onClose={this.handleClosePaymentLinkPopup}
        maxWidth="xl"
        className="blackbaudPaymentLinkDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>
            Choose RE NXT Settings for Transactions
          </span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleClosePaymentLinkPopup.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon
            style={{ color: "#fff", fontWeight: "600" }}
          />
        </IconButton>
        <DialogContent>
          <div className="row d-flex p-3">
            <div className="col-sm-12">
              <div className="row">
                <p className="mb-2" style={{ fontWeight: "600", fontSize: "12px" }}>Define the settings you want to assign to the transactions initiated via the inserted link.</p>
                <p style={{ fontSize: "12px" }}><span style={{ fontWeight: "600" }}>IMPORTANT:</span> The Fund, Appeal and Package you select here must be explicitly linked in Raiser’s Edge. The Appeal must be asigned to the Fund and the Package must belong to the Appeal.  If not, Blackbaud’s Payments API will reject the gift.</p>
              </div>
              <div className="row" style={{ borderTop: "2px solid #d3d0d0d5" }}>
                <div
                  className="col-sm-6 pt-3"
                  id="assetFormLabel"
                >
                  <label
                    className="MuiAutocomplete-label form-label"
                    htmlFor="collapsible-lastname"
                  >
                    BlackBaud Gift Subtype
                  </label>
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.giftSubTypeList}
                    value={this.state.blackbaudGiftsubtype}
                    getOptionLabel={(option) =>
                      option || ""
                    }
                    defaultValue={
                      this.state.blackbaudGiftsubtype
                    }
                    onChange={(event, value) => {
                      this.handleBlackbaudGiftsubtypeChange(
                        value
                      );
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a gift subtype"
                        variant="outlined"
                        size="small"
                        className="autoComplete blackbaudPlacehoder"
                        style={{
                          background: "#fff",
                        }}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="row mt-2 d-flex">
                <div
                  className="col-sm-6"
                  id="assetFormLabel"
                >
                  <label
                    className="MuiAutocomplete-label form-label"
                    htmlFor="collapsible-lastname"
                  >
                    BlackBaud Appeal
                  </label>
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.appealsList}
                    value={this.state.blackbaudAppeal}
                    getOptionLabel={(option) =>
                      option.description || ""
                    }
                    defaultValue={
                      this.state.blackbaudAppeal
                    }
                    onChange={(event, value) => {
                      this.handleBlackbaudAppealChange(
                        value || null
                      );
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for an appeal"
                        variant="outlined"
                        size="small"
                        className="autoComplete blackbaudPlacehoder"
                        style={{
                          background: "#fff",
                        }}
                      />
                    )}
                  />
                </div>
                <div
                  className="col-sm-6"
                  id="assetFormLabel"
                >
                  <label
                    className="MuiAutocomplete-label form-label"
                    htmlFor="collapsible-lastname"
                  >
                    BlackBaud Package
                  </label>
                  <Autocomplete
                    id="size-small-outlined"
                    placeholder="Search for a package"
                    size="small"
                    fullWidth
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.packageList}
                    value={this.state.blackbaudPackage}
                    getOptionLabel={(option) =>
                      option.description || ""
                    }
                    defaultValue={
                      this.state.blackbaudPackage
                    }
                    onChange={(event, value) => {
                      this.handleBlackbaudPackageChange(
                        value
                      );
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a package"
                        variant="outlined"
                        size="small"
                        className="autoComplete blackbaudPlacehoder"
                        style={{
                          background: "#fff",
                        }}
                      />
                    )}
                  />
                </div>
              </div>
              <div className="row mt-2 d-flex">
                <div
                  className="col-sm-6"
                  id="assetFormLabel"
                >
                  <label
                    className="MuiAutocomplete-label form-label"
                    htmlFor="collapsible-lastname"
                  >
                    BlackBaud Campaign
                  </label>
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.campaignsList}
                    value={this.state.blackbaudCampaign}
                    getOptionLabel={(option) =>
                      option.description || ""
                    }
                    defaultValue={
                      this.state.blackbaudCampaign
                    }
                    onChange={(event, value) => {
                      this.handleBlackbaudCampaignChange(
                        value
                      );
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a campaign"
                        variant="outlined"
                        size="small"
                        className="autoComplete blackbaudPlacehoder"
                        style={{
                          background: "#fff",
                        }}
                      />
                    )}
                  />
                </div>
                <div
                  className="col-sm-6"
                  id="assetFormLabel"
                >
                  <label
                    className="MuiAutocomplete-label form-label"
                    htmlFor="collapsible-lastname"
                  >
                    BlackBaud Fund*
                  </label>
                  <Autocomplete
                    id="size-small-outlined"
                    size="small"
                    fullWidth
                    ListboxProps={{
                      className: "custom-listbox",
                    }}
                    options={this.state.fundList}
                    value={this.state.blackbaudFund}
                    getOptionLabel={(option) =>
                      option.description || ""
                    }
                    defaultValue={
                      this.state.blackbaudFund
                    }
                    onChange={(event, value) => {
                      this.handleBlackbaudFundChange(
                        value
                      );
                    }}
                    inputprops={{
                      style: {
                        textTransform: "capitalize",
                      },
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search for a fund"
                        variant="outlined"
                        size="small"
                        className="autoComplete blackbaudPlacehoder"
                        style={{
                          background: "#fff",
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="p-4 pt-2">
          {Utils.equalsIgnoreCase(
            this.state.messageType?.type,
            MESSAGE_TYPES.textToPledge
          ) ? (
            <Button
              type="button"
              variant="contained"
              disabled={this.state.blackbaudFund === null}
              style={{
                textTransform: "initial",
                marginRight: "1rem",
                backgroundColor: "#2e85d1",
                color: "#ffff",
                fontWeight: "600",
                padding: "2px 10px",
                opacity: (this.state.blackbaudFund === null) ? 0.5 : 1,
              }}
              onClick={this.handleInsertPaymentLink}
            >
              {this.state.textPledgeMessage?.includes("{{Payment Link}}") ? "Update Link" : "Insert Link"}
            </Button>
          ) :
            <Button
              type="button"
              variant="contained"
              disabled={this.state.blackbaudFund === null}
              style={{
                textTransform: "initial",
                marginRight: "1rem",
                backgroundColor: "#2e85d1",
                color: "#ffff",
                fontWeight: "600",
                padding: "2px 10px",
                opacity: (this.state.blackbaudFund === null) ? 0.5 : 1,
              }}
              onClick={this.handleInsertPaymentLink}
            >
              {this.state.isPledge ? "Update Link" : "Insert Link"}
            </Button>
          }
        </DialogActions>
      </Dialog>
    );
  };

  render() {
    console.log(this.state.action)
    this.MessageTemplateDialogueRef = React.createRef();
    this.textareaRef = React.createRef();
    this.vCardRef = React.createRef();
    this.vCardFormRef = React.createRef();
    if (this.state.action === "create") {
      return this.createMessage();
    }
  }

  createMessage() {
    const isInteractivePledge = this.itemReferenceList?.some(
      (ref) =>
        ref.current &&
        ref.current.state &&
        typeof ref.current.state.question === "string" &&
        ref.current.state.question.includes("{{Payment Link}}")
    );

    const isBlackBaudCRM = Utils.equalsIgnoreCase(this.crmIntegration, "BlackBaudCRM");
    console.log(isInteractivePledge, isBlackBaudCRM)
    if (this.state.render === false) {
      return <div />;
    } else {
      let questionitems = [];
      /* Create List of Expense Item */
      let itemLoc = 1;
      this.state.questionItems.forEach((element, index) => {
        if ("Delete" !== element.operation) {
          element.step = itemLoc++;
          let itemkey = index + "-" + this.state.refreshKey;
          questionitems.push(
            <MessageQuestion
              ref={this.itemReferenceList[index]}
              key={itemkey}
              data={element}
              srno={index}
              action="edit"
              iteamIndex={index}
              messageType={this.state.messageType}
              questionItems={this.state.questionItems}
              smsVariableList={this.state.smsVariableList}
              onAdd={this.addQuestionItem.bind(this)}
              onDelete={this.QuestionItemDeleted.bind(this)}
              onSuccess={this.smsQuestionTypeChange.bind(this)}
              onChange={this.smsQuestionOnChange.bind(this)}
              onPaymentLink={this.blackbaudPaymentLinkOnChange.bind(this)}
              hasMessageWithYesNoKeyword={this.state.hasMessageWithYesNoKeyword}
            />
          );
        }
      });

      return (
        <>
          <MenuWithBreadScrum
            breadCrumb={this.state.breadCrumb}
            navigate={this.props.navigate}
            messageId={this.state.messageId}
            pageId="viewPage"
            domainObject="Message"
            name="Duplicate message - Please assign a new title and keyword"
          />
          <VCardDialog ref={this.vCardRef} style={{ float: "right" }} />
          <MessageVcard ref={this.vCardFormRef} style={{ float: "right" }} onChange={this.createVCardDetails.bind(this)} />
          <div className="row">
            <ValidatorForm
              className="text-start"
              ref="form"
              onSubmit={this.createMessageToBackend.bind(this)}
            >
              <div className="row">
                <div className="col-md-12">
                  <div className="card " id="giveBeeCard">
                    <div
                      className="card-body"
                      style={{ padding: "1rem 2.5rem" }}
                    >
                      <div className="row">
                        <label
                          className="col-sm-2 col-form-label"
                          htmlFor="collapsible-messagetype"
                        >
                          Message Type
                        </label>
                        <div className="col-sm-3 align-self-center">
                          <span>{this.state.messageType?.typeDetail}</span>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-2 col-form-label"
                          htmlFor="collapsible-lastname"
                        >
                          Message Title
                        </label>
                        <div className="col-sm-3" id="assetFormLabel">
                          <input
                            title=""
                            required
                            type="text"
                            autoComplete="off"
                            id="multiStepsFirstName"
                            name="multiStepsFirstName"
                            className="form-control"
                            value={this.state.messageName}
                            onChange={this.handleMessageNameChange.bind(this)}
                            // onBlur={this.getDuplicateMessageName.bind(this)}
                            validateOnBlur={false}
                            validateOnChange={true}
                            validators={["required"]}
                            errormessages={["This field is required"]}
                          />
                        </div>
                      </div>
                      <div className="row mt-2" style={{ height: "38px" }}>
                        {Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.optIn
                        ) ||
                          Utils.equalsIgnoreCase(
                            this.state.messageType?.type,
                            MESSAGE_TYPES.textToPledge
                          ) ? (
                          <>
                            <label
                              className="col-sm-2 col-form-label"
                              htmlFor="collapsible-firstname"
                            >
                              Keyword
                              {/* <InfoTooltip
                                data="Keywords not allowed: HELP, CANCEL, MENU,
                            GIVBEE, STOP, UNSUBSCRIBE, QUIT, REMOVE,
                            OFF, OPTOUT, OUTPUT, DELETE, STOPALL, ARRET,
                            END."
                                style={{
                                  float: "right",
                                }}
                              /> */}
                            </label>
                            <div className="col-sm-3" id="assetFormLabel">
                              <input
                                title=""
                                required
                                type="text"
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control"
                                value={this.state.keyword}
                                onChange={this.handleKeywordChange.bind(this)}
                                validators={["required"]}
                                errormessages={["This field is required"]}
                              />
                              {this.state.keywordSpaceError && (
                                <div
                                  style={{ color: "red", fontSize: "12.5px" }}
                                >
                                  For this msg type, keyword cannot contain a
                                  space.
                                </div>
                              )}
                            </div>
                            <div className="col-sm-4">
                              {this.state.keywordErrormessage && (
                                <span
                                  style={{ fontSize: "12px", color: "red" }}
                                >
                                  Off-limit Keywords: help, cancel, givbee, stop, unsubscribe, quit, remove, off, optin, optout, output, delete, stopall, arret, start, end, 50/50, sweepstakes, raffle, gamble.
                                </span>
                              )}
                              {!this.state.keywordErrormessage && this.state.keyword !== "" && (
                                <div className="row d-flex" style={{ height: "100%" }}>
                                  <div className="col-sm-5 col-form-label d-flex align-self-center pe-0">
                                    <input
                                      id="assignToGroup"
                                      type="checkbox"
                                      style={{ cursor: "pointer", width: this.businessDomain === BUSINESS_DOMAIN.eventText ? "12px" : "13px" }}
                                      checked={this.state.isAssignToGroup}
                                      onChange={this.handleIsAssignToGroup}
                                    />
                                    <label
                                      htmlFor="assignToGroup"
                                      className="ms-2 mb-0"
                                      style={{ cursor: "pointer", width: "100%" }}
                                    >
                                      Assign to group
                                      <InfoTooltip
                                        data="Any person who uses this message's keyword or opt-in widget will be auto-added to the group selected here."
                                        style={{ float: "right" }}
                                      />
                                    </label>
                                  </div>
                                  <div
                                    className="col-sm-6 pe-0"
                                    style={{ height: "29.25px" }}
                                    id="assetFormLabel"
                                  >
                                    {this.state.isAssignToGroup &&
                                      <Autocomplete
                                        id="size-small-outlined"
                                        size="small"
                                        fullWidth
                                        disableClearable
                                        autoComplete="off"
                                        ListboxProps={{
                                          className: "custom-listbox",
                                        }}
                                        options={this.state.smsGroupList}
                                        value={this.state.assignToGroup}
                                        getOptionLabel={(option) =>
                                          option.name
                                        }
                                        defaultValue={
                                          this.state.assignToGroup
                                        }
                                        onChange={(event, value) => {
                                          this.handleAssignToGroupChange(value);
                                        }}
                                        inputprops={{
                                          style: {
                                            textTransform: "capitalize",
                                          },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Please Select"
                                            variant="outlined"
                                            size="small"
                                            className="autoComplete"
                                            style={{ background: "#fff" }}
                                          />
                                        )}
                                      />
                                    }
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <label
                              className="col-sm-2 col-form-label"
                              htmlFor="collapsible-firstname"
                            >
                              Keyword
                              {/* <InfoTooltip
                                data="Keywords not allowed: HELP, CANCEL, MENU,
                              GIVBEE, STOP, UNSUBSCRIBE, QUIT, REMOVE,
                              OFF, OPTOUT, OUTPUT, DELETE, STOPALL, ARRET,
                              END."
                                style={{
                                  float: "right",
                                }}
                              /> */}
                            </label>
                            <div className="col-sm-3" id="assetFormLabel">
                              <input
                                type="text"
                                autoComplete="off"
                                id="multiStepsFirstName"
                                name="multiStepsFirstName"
                                className="form-control"
                                // required={this.state.isPaymentLinkIncluded}
                                value={this.state.keyword}
                                onChange={this.handleKeywordChange.bind(this)}
                                validators={["required"]}
                                errormessages={["This field is required"]}
                              />
                              {this.state.keywordSpaceError && (
                                <div
                                  style={{ color: "red", fontSize: "12.5px" }}
                                >
                                  For this msg type, keyword cannot contain a
                                  space.
                                </div>
                              )}
                            </div>
                            <div className="col-sm-4">
                              {this.state.keywordErrormessage && (
                                <span
                                  style={{ fontSize: "12px", color: "red" }}
                                >
                                  Off-limit Keywords: help, cancel, givbee, stop, unsubscribe, quit, remove, off, optin, optout, output, delete, stopall, arret, start, end, 50/50, sweepstakes, raffle, gamble.
                                </span>
                              )}
                              {!this.state.keywordErrormessage && this.state.keyword !== "" && (
                                <div className="row d-flex" style={{ height: "100%" }}>
                                  <div className="col-sm-5 col-form-label d-flex  align-self-center pe-0">
                                    <input
                                      id="assignToGroup"
                                      type="checkbox"
                                      style={{ cursor: "pointer", width: this.businessDomain === BUSINESS_DOMAIN.eventText ? "12px" : "13px" }}
                                      checked={this.state.isAssignToGroup}
                                      onChange={this.handleIsAssignToGroup}
                                    />
                                    <label
                                      htmlFor="assignToGroup"
                                      className="ms-2 mb-0"
                                      style={{ cursor: "pointer", width: "100%" }}
                                    >
                                      Assign to group
                                      <InfoTooltip
                                        data="Any person who uses this message's keyword or opt-in widget will be auto-added to the group selected here."
                                        style={{ float: "right" }}
                                      />
                                    </label>
                                  </div>
                                  <div
                                    className="col-sm-6 pe-0"
                                    style={{ height: "29.25px" }}
                                    id="assetFormLabel"
                                  >
                                    {this.state.isAssignToGroup &&
                                      <Autocomplete
                                        id="size-small-outlined"
                                        size="small"
                                        fullWidth
                                        disableClearable
                                        autoComplete="off"
                                        ListboxProps={{
                                          className: "custom-listbox",
                                        }}
                                        options={this.state.smsGroupList}
                                        value={this.state.assignToGroup}
                                        getOptionLabel={(option) =>
                                          option.name
                                        }
                                        defaultValue={
                                          this.state.assignToGroup
                                        }
                                        onChange={(event, value) => {
                                          this.handleAssignToGroupChange(value);
                                        }}
                                        inputprops={{
                                          style: {
                                            textTransform: "capitalize",
                                          },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            placeholder="Please Select"
                                            variant="outlined"
                                            size="small"
                                            className="autoComplete"
                                            style={{ background: "#fff" }}
                                          />
                                        )}
                                      />
                                    }
                                  </div>
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                      <div className="row mt-2">
                        <label
                          className="col-sm-2 col-form-label"
                          htmlFor="collapsible-firstname"
                        >
                          Color Code
                        </label>
                        <div
                          className="col-sm-3 messageSelectColorCode align-self-center"
                          id="assetFormLabel"
                        >
                          <Select
                            value={this.state.colorCodeId}
                            onChange={(event) =>
                              this.handleColorCodeChange(event)
                            }
                            className="selectColorCode action-button"
                            style={{
                              backgroundColor: this.state.colorCode,
                            }}
                            renderValue={() => null}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 250,
                                  overflowY: "auto",
                                },
                              },
                              MenuListProps: {
                                className: "colorMenuListWrap",
                              },
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                            }}
                          >
                            {this.smsCategoryColorList?.map((option) => (
                              <MenuItem
                                key={option.id}
                                value={option.id}
                                className="colorCodeMenuItem"
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "15px",
                                  cursor: "pointer",
                                  padding: "8px",
                                  "&:hover div": {
                                    transform: "scale(1.1)",
                                    boxShadow: "0 0 6px #e6effc",
                                    borderRadius: "3px",
                                  },
                                }}
                              >
                                <div
                                  style={{
                                    backgroundColor: option.hashColor,
                                    width: 18,
                                    height: 18,
                                    borderRadius: "3px",
                                    border: "1px solid #ccc",
                                    transition: "all 0.2s ease-in-out",
                                  }}
                                />
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </div>
                      {this.crmIntegration !== "None" &&
                        this.crmIntegration !== "Cvent" && (
                          <>
                            {this.crmIntegration === "NeonCRM" && (
                              <div className="row mt-2">
                                <label
                                  className="col-sm-2 col-form-label"
                                  htmlFor="collapsible-lastname"
                                >
                                  Record as Activity in Neon
                                </label>
                                <div className="col-sm-3" id="assetFormLabel">
                                  <span className="cursor-pointer">
                                    <input
                                      type="radio"
                                      id="yes"
                                      name="blackbaudActivity"
                                      value="true"
                                      checked={
                                        this.state.neonRecordActivity === true
                                      }
                                      onChange={
                                        this.handleNeonRecordActivityChange
                                      }
                                    />
                                    <label
                                      className="col-form-label ps-1"
                                      htmlFor="yes"
                                    >
                                      Yes
                                    </label>
                                  </span>
                                  <span className="ms-3 cursor-pointer">
                                    <input
                                      type="radio"
                                      id="no"
                                      name="blackbaudActivity"
                                      value="false"
                                      checked={
                                        this.state.neonRecordActivity === false
                                      }
                                      onChange={
                                        this.handleNeonRecordActivityChange
                                      }
                                    />
                                    <label
                                      className="col-form-label ps-1"
                                      htmlFor="no"
                                    >
                                      No
                                    </label>
                                  </span>
                                </div>
                              </div>
                            )}

                            {this.crmIntegration === "BlackBaudCRM" && (
                              <>
                                <div className="row">
                                  <label
                                    className="col-sm-2 col-form-label"
                                    htmlFor="collapsible-lastname"
                                  >
                                    Record in RE NXT
                                  </label>
                                  <div
                                    className="col-sm-3  align-self-center"
                                    id="assetFormLabel"
                                  >
                                    <span className="cursor-pointer">
                                      <input
                                        type="radio"
                                        id="yes"
                                        name="blackbaudActivity"
                                        value="true"
                                        checked={
                                          this.state.isBlackbaudActivity ===
                                          true
                                        }
                                        onChange={
                                          this.handleBlackbaudActivityChange
                                        }
                                      />
                                      <label
                                        className="col-form-label ps-1"
                                        htmlFor="yes"
                                      >
                                        Yes
                                      </label>
                                    </span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span className="cursor-pointer">
                                      <input
                                        type="radio"
                                        id="no"
                                        name="blackbaudActivity"
                                        value="false"
                                        checked={
                                          this.state.isBlackbaudActivity ===
                                          false
                                        }
                                        onChange={
                                          this.handleBlackbaudActivityChange
                                        }
                                      />
                                      <label
                                        className="col-form-label ps-1"
                                        htmlFor="no"
                                      >
                                        No
                                      </label>
                                    </span>
                                  </div>
                                </div>
                                {Utils.equalsIgnoreCase(
                                  this.state.isBlackbaudActivity,
                                  true
                                ) && (
                                    <>
                                      <div className="row mt-2">
                                        <div className="col-sm-2"></div>
                                        <div
                                          className="col-sm-3"
                                          id="assetFormLabel"
                                        >
                                          <label
                                            className="MuiAutocomplete-label form-label"
                                            htmlFor="collapsible-lastname"
                                          >
                                            Action Type
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={this.state.actionTypeList}
                                            value={this.state.actionType}
                                            getOptionLabel={(option) => option}
                                            defaultValue={this.state.actionType}
                                            onChange={(event, value) => {
                                              this.handleActionTypeChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="autoComplete"
                                                style={{
                                                  background: "#fff",
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}

                                {(this.state.isBlackbaudTokenAbsent && this.state.isBlackbaudActivity) &&
                                  <div className="row">
                                    <div className="col-sm-2"></div>
                                    <div
                                      className="col-sm-10"
                                      id="assetFormLabel"
                                    >
                                      <>
                                        <span
                                          className="danger ms-1"
                                          style={{ color: "red", fontSize: "14px" }}
                                        >
                                          Please connect to Blackbaud CRM in Account Settings.
                                        </span>
                                      </>
                                    </div>
                                  </div>
                                }
                              </>
                            )}
                            {this.crmIntegration === BUSINESS_DOMAIN.dpText && (
                              <>
                                <div className="row mt-2">
                                  <label
                                    className="col-sm-2 form-label"
                                    htmlFor="collapsible-lastname"
                                  >
                                    Record as Contact into DP
                                  </label>
                                  <div
                                    className="col-sm-3  align-self-center"
                                    id="assetFormLabel"
                                  >
                                    <span className="cursor-pointer">
                                      <input
                                        type="radio"
                                        id="yes"
                                        name="blackbaudActivity"
                                        value="true"
                                        checked={
                                          this.state.isDptextActivity === true
                                        }
                                        onChange={
                                          this.handleDpTextActivityChange
                                        }
                                      />
                                      <label
                                        className="col-form-label ps-1"
                                        htmlFor="yes"
                                      >
                                        Yes
                                      </label>
                                    </span>
                                    <span className="ms-3 cursor-pointer">
                                      <input
                                        type="radio"
                                        id="no"
                                        name="blackbaudActivity"
                                        value="false"
                                        checked={
                                          this.state.isDptextActivity === false
                                        }
                                        onChange={
                                          this.handleDpTextActivityChange
                                        }
                                      />
                                      <label
                                        className="col-form-label ps-1"
                                        htmlFor="no"
                                      >
                                        No
                                      </label>
                                    </span>
                                  </div>
                                </div>

                                {Utils.equalsIgnoreCase(
                                  this.state.isDptextActivity,
                                  true
                                ) && (
                                    <>
                                      <div className="row mt-2 d-flex">
                                        <div className="col-sm-2"></div>
                                        <div
                                          className="col-sm-3"
                                          id="assetFormLabel"
                                        >
                                          <label
                                            className="MuiAutocomplete-label form-label"
                                            htmlFor="collapsible-lastname"
                                          >
                                            Activity Code
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={this.state.activityCodeList}
                                            value={this.state.activityCode}
                                            getOptionLabel={(option) =>
                                              option.description
                                            }
                                            defaultValue={this.state.activityCode}
                                            onChange={(event, value) => {
                                              this.handleActivityCodeChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="autoComplete"
                                                style={{
                                                  background: "#fff",
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                        <div
                                          className="col-sm-3"
                                          id="assetFormLabel"
                                        >
                                          <label
                                            className="MuiAutocomplete-label form-label"
                                            htmlFor="collapsible-lastname"
                                          >
                                            Assign To
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={this.state.assignToCodeList}
                                            value={this.state.assignToCode}
                                            getOptionLabel={(option) =>
                                              option.description
                                            }
                                            defaultValue={this.state.assignToCode}
                                            onChange={(event, value) => {
                                              this.handleAssignToCodeChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="autoComplete"
                                                style={{
                                                  background: "#fff",
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                      {this.state.isDpTextCrmAbsent &&
                                        <div className="rows d-flex">
                                          <div className="col-sm-2"></div>
                                          <div
                                            className="col-sm-10"
                                            id="assetFormLabel"
                                          >
                                            <>
                                              <span
                                                className="danger ms-1"
                                                style={{ color: "red", fontSize: "14px" }}
                                              >
                                                Please connect to DpText CRM in Account Settings
                                              </span>
                                            </>
                                          </div>
                                        </div>
                                      }
                                    </>
                                  )}
                              </>
                            )}
                            {(this.crmIntegration === BUSINESS_DOMAIN.dpText && Utils.equalsIgnoreCase(this.state.messageType?.type, MESSAGE_TYPES.textToPledge)) && (
                              <>
                                <div className="row mt-2">
                                  <label
                                    className="col-sm-2 form-label"
                                    htmlFor="collapsible-lastname"
                                  >
                                    Record as Pledge into DP
                                  </label>
                                  <div className="col-sm-3" id="assetFormLabel">
                                    <span className="cursor-pointer">
                                      <input
                                        type="radio"
                                        id="yes"
                                        name="dptextRecordAsPledge"
                                        value="true"
                                        checked={
                                          this.state.isRecordAsPledge ===
                                          true
                                        }
                                        onChange={
                                          this.handleRecordAsPledgeChange
                                        }
                                      />
                                      <label
                                        className="col-form-label ps-1"
                                        htmlFor="recordAsPledgeYes"
                                      >
                                        Yes
                                      </label>
                                    </span>
                                    <span className="ms-3 cursor-pointer">
                                      <input
                                        type="radio"
                                        id="no"
                                        name="dptextRecordAsPledge"
                                        value="false"
                                        checked={
                                          this.state.isRecordAsPledge === false
                                        }
                                        onChange={
                                          this.handleRecordAsPledgeChange
                                        }
                                      />
                                      <label
                                        className="col-form-label ps-1"
                                        htmlFor="recordAsPledgeNo"
                                      >
                                        No
                                      </label>
                                    </span>
                                  </div>
                                </div>
                                {Utils.equalsIgnoreCase(
                                  this.state.isRecordAsPledge,
                                  true
                                ) && (
                                    <>
                                      <div className="row mt-2 d-flex">
                                        <div className="col-sm-2"></div>
                                        <div
                                          className="col-sm-3"
                                          id="assetFormLabel"
                                        >
                                          <label
                                            className="MuiAutocomplete-label form-label"
                                            htmlFor="collapsible-lastname"
                                          >
                                            General Ledger
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={this.state.glCodeList}
                                            value={this.state.generalLedger}
                                            getOptionLabel={(option) =>
                                              option.description
                                            }
                                            defaultValue={
                                              this.state.generalLedger
                                            }
                                            onChange={(event, value) => {
                                              this.handleGeneralLedgerChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="autoComplete"
                                                style={{
                                                  background: "#fff",
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                        <div
                                          className="col-sm-3"
                                          id="assetFormLabel"
                                        >
                                          <label
                                            className="MuiAutocomplete-label form-label"
                                            htmlFor="collapsible-lastname"
                                          >
                                            Campaign
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={
                                              this.state.campaignCodeList
                                            }
                                            value={this.state.campaign}
                                            getOptionLabel={(option) =>
                                              option.description
                                            }
                                            defaultValue={
                                              this.state.campaign
                                            }
                                            onChange={(event, value) => {
                                              this.handleCampaignChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="autoComplete"
                                                style={{
                                                  background: "#fff",
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                      <div className="row mt-2 d-flex">
                                        <div className="col-sm-2"></div>
                                        <div
                                          className="col-sm-3"
                                          id="assetFormLabel"
                                        >
                                          <label
                                            className="MuiAutocomplete-label form-label"
                                            htmlFor="collapsible-lastname"
                                          >
                                            Solicitation
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={
                                              this.state
                                                .solicitationCodeList
                                            }
                                            value={this.state.solicitation}
                                            getOptionLabel={(option) =>
                                              option.description
                                            }
                                            defaultValue={
                                              this.state.solicitation
                                            }
                                            onChange={(event, value) => {
                                              this.handleSolicitationChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="autoComplete"
                                                style={{
                                                  background: "#fff",
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                        <div
                                          className="col-sm-3"
                                          id="assetFormLabel"
                                        >
                                          <label
                                            className="MuiAutocomplete-label form-label"
                                            htmlFor="collapsible-lastname"
                                          >
                                            Sub Solicitation
                                          </label>
                                          <Autocomplete
                                            id="size-small-outlined"
                                            size="small"
                                            fullWidth
                                            disableClearable
                                            ListboxProps={{
                                              className: "custom-listbox",
                                            }}
                                            options={
                                              this.state
                                                .subSolicitationCodeList
                                            }
                                            value={
                                              this.state.subSolicitation
                                            }
                                            getOptionLabel={(option) =>
                                              option.description
                                            }
                                            defaultValue={
                                              this.state.subSolicitation
                                            }
                                            onChange={(event, value) => {
                                              this.handleSubSolicitationChange(
                                                value
                                              );
                                            }}
                                            inputprops={{
                                              style: {
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                placeholder="Please Select"
                                                variant="outlined"
                                                size="small"
                                                className="autoComplete"
                                                style={{
                                                  background: "#fff",
                                                }}
                                              />
                                            )}
                                          />
                                        </div>
                                      </div>
                                    </>
                                  )}
                              </>
                            )}
                          </>
                        )}
                      {(Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.standard
                      ) ||
                        Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.accountvCard
                        )) && (
                          <>
                            <hr></hr>
                            <div className="row">
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="col-sm-2 form-label"
                              >
                                Message
                              </label>
                              <div className="col-sm-5" id="assetFormLabel">
                                <textarea
                                  title=""
                                  ref={this.textareaRef}
                                  required
                                  value={this.state.textMessage}
                                  // onDrop={this.handleSmsVariableOnDrop.bind(this)}
                                  onChange={this.handleTextMessageChange.bind(
                                    this
                                  )}
                                  onBlur={this.handleTextMessageChange.bind(this)}
                                  className="form-control"
                                  id="messageBox"
                                  rows="3"
                                  style={{
                                    overflow: "hidden",
                                    resize: "vertical",
                                  }}
                                />
                                <span
                                  className="ms-1"
                                  style={{
                                    fontWeight: "normal",
                                    fontSize: "11px",
                                    color: "black",
                                  }}
                                >
                                  Did you include opt-out language?{" "}
                                  <span
                                    className="anchortag"
                                    onClick={this.handleInsertItMessageChange.bind(
                                      this
                                    )}
                                  >
                                    <u>Insert it.</u>
                                  </span>
                                </span>
                                <span
                                  style={{
                                    fontSize: "14px",
                                    float: "right",
                                  }}
                                >
                                  {Utils.trimLetters(this.state.textMessage)}
                                </span>
                                {this.accountSettings?.textMessageLength <
                                  Utils.countLetters(this.state.textMessage) && (
                                    <>
                                      <br></br>
                                      <span
                                        className="danger ms-1"
                                        style={{ color: "red", fontSize: "14px" }}
                                      >
                                        Your message is limited to{" "}
                                        {this.accountSettings?.textMessageLength}{" "}
                                        characters.
                                      </span>
                                    </>
                                  )}
                                {this.state.offlimitKeywordForMessage && (
                                  <>
                                    <br></br>
                                    <span
                                      style={{ fontSize: "12px", color: "red" }}
                                    >
                                      Off-limit words for msg box: free, bit.ly, tinyurl, 50/50, sweepstakes, raffle, gamble.
                                    </span>
                                  </>
                                )}
                                {this.state.hasEmDashError && (
                                  <>
                                    <br></br>
                                    <span
                                      className="danger ms-1"
                                      style={{ color: "red", fontSize: "14px" }}>
                                      You cannot use em Dash like this: — in the message.
                                    </span>
                                  </>
                                )}
                                <br></br>
                                {/* {this.state.isMeterSetting && (
                                  <>
                                    <div className="d-flex flex-wrap align-items-start mt-2 includeDonationMeter">
                                      <FormControlLabel
                                        style={{
                                          width: "60%", // allows wrapping within container
                                          margin: "0",
                                          padding: "0",
                                          alignItems: "flex-start",
                                        }}
                                        control={
                                          <Checkbox
                                            variant="outlined"
                                            id="isAsset"
                                            checked={this.state.isPledge}
                                            onChange={this.handleMeterSettingCheck.bind(
                                              this
                                            )}
                                            style={{
                                              background: "none",
                                            }}
                                          />
                                        }
                                        label={
                                          <span
                                            className="form-label"
                                            style={{
                                              fontSize: "14px",
                                              margin: "0 8px 0 4px",
                                              wordWrap: "break-word",
                                              whiteSpace: "normal", // IMPORTANT
                                              lineHeight: "1.2", // Optional, improves readability
                                            }}
                                          >
                                            Include Donation Meter
                                            <Tooltip
                                              title="Pledge"
                                              classes={{
                                                popper: "custom-tooltip",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                <i
                                                  className="fa fa-thermometer-three-quarters donationMeter-icon"
                                                  aria-hidden="true"
                                                  style={{
                                                    fontSize: "1.2em",
                                                    marginTop: "4px",
                                                  }}
                                                />
                                              </span>
                                            </Tooltip>
                                          </span>
                                        }
                                      />
                                    </div>
                                  </>
                                )} */}
                              </div>

                              <div className="col-md-3">
                                <ul className="p-0" style={{ listStyle: "none" }}>
                                  {this.state.smsVariableList?.map(
                                    (data, index) => {
                                      return (
                                        <>
                                          {/* {(data.value !== "{{Payment Link}}" ||
                                          this.pledgeDonationIntegration !==
                                            "None") && ( */}
                                          {data?.name === "FirstName" ?
                                            <Tooltip
                                              title={`Alternate: ${this.organization?.firstNameAlternateValue !== null ? this.organization?.firstNameAlternateValue : ""}`}
                                              arrow
                                              classes={{ popper: "alternateCustom-tooltip" }}
                                              placement="right"
                                            >
                                              <li
                                                className="d-flex mt-1 variableButton"
                                                onClick={this.handleTextMessageInsert.bind(
                                                  this,
                                                  data
                                                )}
                                              >
                                                {data.name === "FirstName" && (
                                                  <IconButton className="pe-1">
                                                    <ChatBubbleOutlineIcon
                                                      style={{
                                                        fontSize: "16px",
                                                        width: "25px",
                                                      }}
                                                    />
                                                  </IconButton>
                                                )}

                                                <span
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  // onClick={this.handleTextMessageInsert.bind(
                                                  //   this,
                                                  //   data
                                                  // )}
                                                  key={index}
                                                  draggable
                                                >
                                                  {data.description}
                                                </span>
                                              </li>
                                            </Tooltip>
                                            :
                                            <li
                                              className="d-flex mt-1 variableButton"
                                              onClick={this.handleTextMessageInsert.bind(
                                                this,
                                                data
                                              )}
                                            >
                                              {data.name === "FirstName" && (
                                                <IconButton className="pe-1">
                                                  <ChatBubbleOutlineIcon
                                                    style={{
                                                      fontSize: "16px",
                                                      width: "25px",
                                                    }}
                                                  />
                                                </IconButton>
                                              )}
                                              {data.name === "EventName" && (
                                                <IconButton className="pe-1">
                                                  <i
                                                    class="fa fa-plus"
                                                    aria-hidden="true"
                                                    style={{
                                                      fontSize: "16px",
                                                      width: "25px",
                                                    }}
                                                  ></i>
                                                </IconButton>
                                              )}
                                              {data.name === "EventStartDate" && (
                                                <IconButton className="pe-1">
                                                  <i
                                                    class="fa fa-calendar-plus-o"
                                                    aria-hidden="true"
                                                    style={{
                                                      fontSize: "15px",
                                                      width: "25px",
                                                    }}
                                                  ></i>
                                                </IconButton>
                                              )}
                                              {data.name === "EventEndDate" && (
                                                <IconButton className="pe-1">
                                                  <i
                                                    class="fa fa-calendar-plus-o"
                                                    aria-hidden="true"
                                                    style={{
                                                      fontSize: "15px",
                                                      width: "25px",
                                                    }}
                                                  ></i>
                                                </IconButton>
                                              )}
                                              {data.name === "PaymentLink" && (
                                                <IconButton className="pe-1">
                                                  <i
                                                    class="fa fa-usd"
                                                    aria-hidden="true"
                                                    style={{
                                                      fontSize: "16px",
                                                      width: "25px",
                                                    }}
                                                  ></i>
                                                </IconButton>
                                              )}
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                                // onClick={this.handleTextMessageInsert.bind(
                                                //   this,
                                                //   data
                                                // )}
                                                key={index}
                                                draggable
                                              >
                                                {(isBlackBaudCRM && this.state.isPledge) ? "Edit Payment Link" : data.description}
                                              </span>
                                            </li>
                                          }
                                          {/* )} */}
                                        </>
                                      );
                                    }
                                  )}
                                  <li
                                    className="mt-1 variableButton"
                                    onClick={this.handleAccountDropdownOpen.bind(
                                      this
                                    )}
                                  >
                                    <IconButton
                                      className="pe-1"
                                      style={{ height: "15px" }}
                                    >
                                      <AddLinkIcon
                                        style={{
                                          fontSize: "20px",
                                          width: "25px",
                                        }}
                                      // onClick={this.handleAccountDropdownOpen}
                                      />
                                    </IconButton>
                                    <span
                                    // onClick={this.handleAccountDropdownOpen.bind(
                                    //   this
                                    // )}
                                    >
                                      Insert Short Link
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            {/* {this.state.isPledge && <>{this.meterSetting()}</>} */}
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.interactive
                      ) && (
                          <>
                            <hr className="mb-0"></hr>
                            <div className="row mb-2 mt-3">
                              {questionitems.length === 0 && (
                                <div className="row">
                                  <div
                                    className="col-md-8"
                                    style={{
                                      background: "#ececec",
                                      color: "#000",
                                      fontWeight: "bold",
                                      border: "0.5px solid #ece6e6",
                                      padding: "0.5em",
                                    }}
                                  >
                                    {/* Message Type */}
                                  </div>
                                  <div
                                    className="col-md-4"
                                    style={{
                                      borderRight: "1px solid #eceaea",
                                      background: "#ececec",
                                      color: "#000",
                                      fontWeight: "bold",
                                      padding: "0.5em",
                                      textAlign: "right",
                                    }}
                                  >
                                    <Button
                                      type="button"
                                      variant="contained"
                                      className="btn btn-default "
                                      style={{
                                        textTransform: "capitalize",
                                        padding: "5px 10px",
                                        background: "#37517e",
                                        color: "#fff",
                                        fontWeight: "bold",
                                      }}
                                      startIcon={<AddIcon />}
                                      onClick={this.addQuestionItem.bind(this)}
                                    >
                                      Insert Message
                                    </Button>
                                  </div>
                                </div>
                              )}
                              <div className="row">
                                <label className="col-sm-1 col-form-label">
                                  Messages
                                </label>
                                <div className="col-sm-11">{questionitems}</div>
                              </div>
                            </div>
                            <div className="row justify-content-end">
                              <div className="col-sm-10">
                                <label
                                  htmlFor="exampleFormControlTextarea1"
                                  className="col-form-label"
                                >
                                  Closing Msg
                                </label>
                                <div className="row d-flex mb-2">
                                  <div className="col-md-6">
                                    <textarea
                                      title=""
                                      ref={this.textareaRef}
                                      required
                                      value={this.state.closingTextMessage}
                                      onChange={this.handleClosingTextMessageChange.bind(
                                        this
                                      )}
                                      onBlur={this.handleClosingTextMessageChange.bind(
                                        this
                                      )}
                                      className="form-control"
                                      id="closingMessageBox"
                                      rows="3"
                                      style={{
                                        overflow: "hidden",
                                        resize: "vertical",
                                      }}
                                    />
                                    {this.accountSettings?.textMessageLength <
                                      Utils.countLetters(
                                        this.state.closingTextMessage
                                      ) && (
                                        <span
                                          className="danger ms-1"
                                          style={{ color: "red", fontSize: "14px" }}
                                        >
                                          Your message is limited to{" "}
                                          {this.accountSettings?.textMessageLength}{" "}
                                          characters.
                                        </span>
                                      )}
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        float: "right",
                                      }}
                                    >
                                      {Utils.trimLetters(
                                        this.state.closingTextMessage
                                      )}
                                    </span>
                                  </div>
                                  <div className="col-md-3">
                                    <ul
                                      className="p-0"
                                      style={{ listStyle: "none" }}
                                    >
                                      {this.state.smsVariableList?.map(
                                        (data, index) => {
                                          if (data.name === "PaymentLink" && isInteractivePledge) {
                                            return null;
                                          }

                                          return (
                                            <>
                                              {data?.name === "FirstName" ?
                                                <Tooltip
                                                  title={`Alternate: ${this.organization?.firstNameAlternateValue !== null ? this.organization?.firstNameAlternateValue : ""}`}
                                                  arrow
                                                  classes={{ popper: "alternateCustom-tooltip" }}
                                                  placement="right"
                                                >
                                                  <li
                                                    className="d-flex mt-1 variableButton"
                                                    onClick={this.handleClosingInsert.bind(
                                                      this,
                                                      data
                                                    )}
                                                  >
                                                    {data.name === "FirstName" && (
                                                      <IconButton className="pe-1">
                                                        <ChatBubbleOutlineIcon
                                                          style={{
                                                            fontSize: "16px",
                                                            width: "25px",
                                                          }}
                                                        />
                                                      </IconButton>
                                                    )}

                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      // onClick={this.handleClosingInsert.bind(
                                                      //   this,
                                                      //   data
                                                      // )}
                                                      key={index}
                                                      draggable
                                                    >
                                                      {data.description}
                                                    </span>
                                                  </li>
                                                </Tooltip>
                                                :
                                                <li
                                                  className="d-flex mt-1 variableButton"
                                                  onClick={this.handleClosingInsert.bind(
                                                    this,
                                                    data
                                                  )}
                                                >
                                                  {data.name === "FirstName" && (
                                                    <IconButton className="pe-1">
                                                      <ChatBubbleOutlineIcon
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      />
                                                    </IconButton>
                                                  )}
                                                  {data.name === "EventName" && (
                                                    <IconButton className="pe-1">
                                                      <i
                                                        class="fa fa-plus"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      ></i>
                                                    </IconButton>
                                                  )}
                                                  {data.name === "PaymentLink" && (
                                                    <IconButton className="pe-1">
                                                      <i
                                                        class="fa fa-usd"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      ></i>
                                                    </IconButton>
                                                  )}
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    // onClick={this.handleClosingInsert.bind(
                                                    //   this,
                                                    //   data
                                                    // )}
                                                    key={index}
                                                    draggable
                                                  >
                                                    {(isBlackBaudCRM && this.state.isPledge) ? "Edit Payment Link" : data.description}
                                                  </span>
                                                </li>
                                              }
                                            </>
                                          );
                                        }
                                      )}
                                      <li
                                        className="mt-1 variableButton"
                                        onClick={this.handleAccountDropdownOpen.bind(
                                          this
                                        )}
                                      >
                                        <IconButton
                                          className="pe-1"
                                          style={{ height: "15px" }}
                                        >
                                          <AddLinkIcon
                                            style={{
                                              fontSize: "20px",
                                              width: "25px",
                                            }}
                                          // onClick={
                                          //   this.handleAccountDropdownOpen
                                          // }
                                          />
                                        </IconButton>
                                        <span
                                        // onClick={this.handleAccountDropdownOpen.bind(
                                        //   this
                                        // )}
                                        >
                                          Insert Short Link
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                                {/* {this.state.isMeterSetting && (
                                  <>
                                    <div className="d-flex flex-wrap align-items-start mt-2 includeDonationMeter">
                                      <FormControlLabel
                                        style={{
                                          width: "60%", // allows wrapping within container
                                          margin: "0",
                                          padding: "0",
                                          alignItems: "flex-start",
                                        }}
                                        control={
                                          <Checkbox
                                            variant="outlined"
                                            id="isAsset"
                                            checked={this.state.isPledge}
                                            onChange={this.handleMeterSettingCheck.bind(
                                              this
                                            )}
                                            style={{
                                              background: "none",
                                            }}
                                          />
                                        }
                                        label={
                                          <span
                                            className="form-label"
                                            style={{
                                              fontSize: "14px",
                                              margin: "0 8px 0 4px",
                                              wordWrap: "break-word",
                                              whiteSpace: "normal", // IMPORTANT
                                              lineHeight: "1.2", // Optional, improves readability
                                            }}
                                          >
                                            Include Donation Meter
                                            <Tooltip
                                              title="Pledge"
                                              classes={{
                                                popper: "custom-tooltip",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                <i
                                                  className="fa fa-thermometer-three-quarters donationMeter-icon"
                                                  aria-hidden="true"
                                                  style={{
                                                    fontSize: "1.2em",
                                                    marginTop: "4px",
                                                  }}
                                                />
                                              </span>
                                            </Tooltip>
                                          </span>
                                        }
                                      />
                                    </div>
                                  </>
                                )} */}
                              </div>
                            </div>
                            {/* {this.state.isPledge && <>{this.meterSetting()}</>} */}
                            {this.valueIndexMap
                              .values()
                              .toArray()
                              .findIndex((e) => e === "Pledge") >= 0 && (
                                <>
                                  {this.crmIntegration ===
                                    BUSINESS_DOMAIN.dpText && (
                                      <>
                                        <hr></hr>
                                        <div
                                          className="row"
                                          style={{ marginTop: "1em" }}
                                        >
                                          <div className="col-md-12">
                                            <div className="row mt-2">
                                              <div
                                                className="col-md-6"
                                                id="assetFormLabel"
                                              >
                                                <label
                                                  className="form-label "
                                                  htmlFor="collapsible-lastname"
                                                >
                                                  Record as an Pledge in DP
                                                </label>
                                                <span className="cursor-pointer">
                                                  <input
                                                    type="radio"
                                                    id="yes"
                                                    name="blackbaudActivity"
                                                    value="true"
                                                    checked={
                                                      this.state.isRecordAsPledge ===
                                                      true
                                                    }
                                                    onChange={
                                                      this.handleRecordAsPledgeChange
                                                    }
                                                  />
                                                  <label
                                                    className="col-form-label ps-1"
                                                    htmlFor="yes"
                                                  >
                                                    Yes
                                                  </label>
                                                </span>
                                                <span className="ms-3 cursor-pointer">
                                                  <input
                                                    type="radio"
                                                    id="no"
                                                    name="blackbaudActivity"
                                                    value="false"
                                                    checked={
                                                      this.state.isRecordAsPledge ===
                                                      false
                                                    }
                                                    onChange={
                                                      this.handleRecordAsPledgeChange
                                                    }
                                                  />
                                                  <label
                                                    className="col-form-label ps-1"
                                                    htmlFor="no"
                                                  >
                                                    No
                                                  </label>
                                                </span>
                                                <span className="cursor-pointer">
                                                  <input
                                                    type="radio"
                                                    id="yes"
                                                    name="blackbaudActivity"
                                                    value="true"
                                                    checked={
                                                      this.state.isRecordAsPledge ===
                                                      true
                                                    }
                                                    onChange={
                                                      this.handleRecordAsPledgeChange
                                                    }
                                                  />
                                                  <label
                                                    className="col-form-label ps-1"
                                                    htmlFor="yes"
                                                  >
                                                    Yes
                                                  </label>
                                                </span>
                                                <span className="ms-3 cursor-pointer">
                                                  <input
                                                    type="radio"
                                                    id="no"
                                                    name="blackbaudActivity"
                                                    value="false"
                                                    checked={
                                                      this.state.isRecordAsPledge ===
                                                      false
                                                    }
                                                    onChange={
                                                      this.handleRecordAsPledgeChange
                                                    }
                                                  />
                                                  <label
                                                    className="col-form-label ps-1"
                                                    htmlFor="no"
                                                  >
                                                    No
                                                  </label>
                                                </span>
                                              </div>
                                            </div>
                                            {Utils.equalsIgnoreCase(
                                              this.state.isRecordAsPledge,
                                              true
                                            ) && (
                                                <>
                                                  <div className="row mt-2">
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        General Ledger*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={this.state.glCodeList}
                                                        value={this.state.generalLedger}
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.generalLedger
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleGeneralLedgerChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        Campaign*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={
                                                          this.state.campaignCodeList
                                                        }
                                                        value={this.state.campaign}
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.campaign
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleCampaignChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="row mt-2">
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        Solicitation*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={
                                                          this.state
                                                            .solicitationCodeList
                                                        }
                                                        value={this.state.solicitation}
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.solicitation
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleSolicitationChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        Sub Solicitation*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={
                                                          this.state
                                                            .subSolicitationCodeList
                                                        }
                                                        value={
                                                          this.state.subSolicitation
                                                        }
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.subSolicitation
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleSubSolicitationChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  <hr></hr>
                                  <div className="row" style={{ marginTop: "1em" }}>
                                    <div className="col-md-12">
                                      <div className="row">
                                        <label
                                          className="col-sm-2 col-form-label"
                                          htmlFor="collapsible-supplierType"
                                        >
                                          Pledge Goal Amount
                                        </label>
                                        <div
                                          className="col-md-3 mt-1"
                                          id="assetFormLabel"
                                        >
                                          <div
                                            className="row ms-1 d-flex flex-nowrap"
                                            style={{ width: "140px" }}
                                          >
                                            <span
                                              className="input-group-addon"
                                              style={{ width: "40px" }}
                                            >
                                              $
                                            </span>
                                            <input
                                              type="number"
                                              autoComplete="off"
                                              id="multiStepsFirstName"
                                              name="multiStepsFirstName"
                                              className="form-control"
                                              style={{
                                                borderRadius: "0px 5px 5px 0px",
                                              }}
                                              value={this.state.fundraisingGoal}
                                              onChange={this.handleFundraisingGoalChange.bind(
                                                this
                                              )}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.interactivePledge
                      ) && (
                          <>
                            <hr className="mb-0"></hr>
                            <div className="row mb-2 mt-3">
                              {questionitems.length === 0 && (
                                <div className="row">
                                  <div
                                    className="col-md-8"
                                    style={{
                                      background: "#ececec",
                                      color: "#000",
                                      fontWeight: "bold",
                                      border: "0.5px solid #ece6e6",
                                      padding: "0.5em",
                                    }}
                                  ></div>
                                  <div
                                    className="col-md-4"
                                    style={{
                                      borderRight: "1px solid #eceaea",
                                      background: "#ececec",
                                      color: "#000",
                                      fontWeight: "bold",
                                      padding: "0.5em",
                                      textAlign: "right",
                                    }}
                                  >
                                    <Button
                                      type="button"
                                      variant="contained"
                                      className="btn btn-default "
                                      style={{
                                        textTransform: "capitalize",
                                        padding: "5px 10px",
                                        background: "#37517e",
                                        color: "#fff",
                                        fontWeight: "bold",
                                      }}
                                      startIcon={<AddIcon />}
                                      onClick={this.addQuestionItem.bind(this)}
                                    >
                                      Insert Message
                                    </Button>
                                  </div>
                                </div>
                              )}
                              <div className="row">
                                <label className="col-sm-1 col-form-label">
                                  Messages
                                </label>
                                <div className="col-sm-11">{questionitems}</div>
                              </div>
                            </div>
                            <div className="row justify-content-end">
                              <div className="col-sm-10">
                                <label
                                  htmlFor="exampleFormControlTextarea1"
                                  className="col-form-label"
                                >
                                  Closing Msg
                                </label>
                                <div className="row d-flex mb-2">
                                  <div className="col-md-6">
                                    <textarea
                                      title=""
                                      ref={this.textareaRef}
                                      required
                                      value={this.state.closingTextMessage}
                                      onChange={this.handleClosingTextMessageChange.bind(
                                        this
                                      )}
                                      className="form-control"
                                      id="closingMessageBox"
                                      rows="3"
                                      style={{
                                        overflow: "hidden",
                                        resize: "vertical",
                                      }}
                                    />
                                    {this.accountSettings?.textMessageLength <
                                      Utils.countLetters(
                                        this.state.closingTextMessage
                                      ) && (
                                        <span
                                          className="danger ms-1"
                                          style={{ color: "red", fontSize: "14px" }}
                                        >
                                          Your message is limited to{" "}
                                          {this.accountSettings?.textMessageLength}{" "}
                                          characters.
                                        </span>
                                      )}
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        float: "right",
                                      }}
                                    >
                                      {Utils.trimLetters(
                                        this.state.closingTextMessage
                                      )}
                                    </span>
                                  </div>
                                  <div className="col-md-3">
                                    <ul
                                      className="p-0"
                                      style={{ listStyle: "none" }}
                                    >
                                      {this.state.smsVariableList?.map(
                                        (data, index) => {
                                          return (
                                            <>
                                              {/* {(data.value !==
                                              "{{Payment Link}}" ||
                                              this.pledgeDonationIntegration !==
                                                "None") && ( */}
                                              {data?.name === "FirstName" ?
                                                <Tooltip
                                                  title={`Alternate: ${this.organization?.firstNameAlternateValue !== null ? this.organization?.firstNameAlternateValue : ""}`}
                                                  arrow
                                                  classes={{ popper: "alternateCustom-tooltip" }}
                                                  placement="right"
                                                >
                                                  <li
                                                    className="d-flex mt-1 variableButton"
                                                    onClick={this.handleClosingInsert.bind(
                                                      this,
                                                      data
                                                    )}
                                                  >
                                                    {data.name === "FirstName" && (
                                                      <IconButton className="pe-1">
                                                        <ChatBubbleOutlineIcon
                                                          style={{
                                                            fontSize: "16px",
                                                            width: "25px",
                                                          }}
                                                        />
                                                      </IconButton>
                                                    )}

                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      // onClick={this.handleClosingInsert.bind(
                                                      //   this,
                                                      //   data
                                                      // )}
                                                      key={index}
                                                      draggable
                                                    >
                                                      {data.description}
                                                    </span>
                                                  </li>
                                                </Tooltip>
                                                :
                                                <li
                                                  className="d-flex mt-1 variableButton"
                                                  onClick={this.handleClosingInsert.bind(
                                                    this,
                                                    data
                                                  )}
                                                >
                                                  {data.name === "FirstName" && (
                                                    <IconButton className="pe-1">
                                                      <ChatBubbleOutlineIcon
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      />
                                                    </IconButton>
                                                  )}
                                                  {data.name === "EventName" && (
                                                    <IconButton className="pe-1">
                                                      <i
                                                        class="fa fa-plus"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      ></i>
                                                    </IconButton>
                                                  )}
                                                  {data.name === "PaymentLink" && (
                                                    <IconButton className="pe-1">
                                                      <i
                                                        class="fa fa-usd"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      ></i>
                                                    </IconButton>
                                                  )}
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    // onClick={this.handleClosingInsert.bind(
                                                    //   this,
                                                    //   data
                                                    // )}
                                                    key={index}
                                                    draggable
                                                  >
                                                    {(isBlackBaudCRM && this.state.isPledge) ? "Edit Payment Link" : data.description}
                                                  </span>
                                                </li>
                                              }
                                              {/* )} */}
                                            </>
                                          );
                                        }
                                      )}
                                      <li
                                        className="mt-1 variableButton"
                                        onClick={this.handleAccountDropdownOpen.bind(
                                          this
                                        )}
                                      >
                                        <IconButton
                                          className="pe-1"
                                          style={{ height: "15px" }}
                                        >
                                          <AddLinkIcon
                                            style={{
                                              fontSize: "20px",
                                              width: "25px",
                                            }}
                                          // onClick={
                                          //   this.handleAccountDropdownOpen
                                          // }
                                          />
                                        </IconButton>
                                        <span
                                        // onClick={this.handleAccountDropdownOpen.bind(
                                        //   this
                                        // )}
                                        >
                                          Insert Short Link
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.valueIndexMap
                              .values()
                              .toArray()
                              .findIndex((e) => e === "Pledge") >= 0 && (
                                <>
                                  {this.crmIntegration ===
                                    BUSINESS_DOMAIN.dpText && (
                                      <>
                                        <hr></hr>
                                        <div
                                          className="row"
                                          style={{ marginTop: "1em" }}
                                        >
                                          <div className="col-md-12">
                                            <div className="row mt-2">
                                              <div
                                                className="col-md-6"
                                                id="assetFormLabel"
                                              >
                                                <label
                                                  className="form-label "
                                                  htmlFor="collapsible-lastname"
                                                >
                                                  Record as Pledge into DP
                                                </label>
                                                <span className="cursor-pointer">
                                                  <input
                                                    type="radio"
                                                    id="yes"
                                                    name="blackbaudActivity"
                                                    value="true"
                                                    checked={
                                                      this.state.isRecordAsPledge ===
                                                      true
                                                    }
                                                    onChange={
                                                      this.handleRecordAsPledgeChange
                                                    }
                                                  />
                                                  <label
                                                    className="col-form-label ps-1"
                                                    htmlFor="yes"
                                                  >
                                                    Yes
                                                  </label>
                                                </span>
                                                <span className="ms-3 cursor-pointer">
                                                  <input
                                                    type="radio"
                                                    id="no"
                                                    name="blackbaudActivity"
                                                    value="false"
                                                    checked={
                                                      this.state.isRecordAsPledge ===
                                                      false
                                                    }
                                                    onChange={
                                                      this.handleRecordAsPledgeChange
                                                    }
                                                  />
                                                  <label
                                                    className="col-form-label ps-1"
                                                    htmlFor="no"
                                                  >
                                                    No
                                                  </label>
                                                </span>
                                              </div>
                                            </div>
                                            {Utils.equalsIgnoreCase(
                                              this.state.isRecordAsPledge,
                                              true
                                            ) && (
                                                <>
                                                  <div className="row mt-2">
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        General Ledger*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={this.state.glCodeList}
                                                        value={this.state.generalLedger}
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.generalLedger
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleGeneralLedgerChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        Campaign*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={
                                                          this.state.campaignCodeList
                                                        }
                                                        value={this.state.campaign}
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.campaign
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleCampaignChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="row mt-2">
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        Solicitation*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={
                                                          this.state
                                                            .solicitationCodeList
                                                        }
                                                        value={this.state.solicitation}
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.solicitation
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleSolicitationChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                    <div
                                                      className="col-md-6"
                                                      id="assetFormLabel"
                                                    >
                                                      <label
                                                        className="MuiAutocomplete-label form-label"
                                                        htmlFor="collapsible-lastname"
                                                      >
                                                        Sub Solicitation*
                                                      </label>
                                                      <Autocomplete
                                                        id="size-small-outlined"
                                                        size="small"
                                                        fullWidth
                                                        disableClearable
                                                        ListboxProps={{
                                                          className: "custom-listbox",
                                                        }}
                                                        options={
                                                          this.state
                                                            .subSolicitationCodeList
                                                        }
                                                        value={
                                                          this.state.subSolicitation
                                                        }
                                                        getOptionLabel={(option) =>
                                                          option.description
                                                        }
                                                        defaultValue={
                                                          this.state.subSolicitation
                                                        }
                                                        onChange={(event, value) => {
                                                          this.handleSubSolicitationChange(
                                                            value
                                                          );
                                                        }}
                                                        inputprops={{
                                                          style: {
                                                            textTransform: "capitalize",
                                                          },
                                                        }}
                                                        renderInput={(params) => (
                                                          <TextField
                                                            {...params}
                                                            placeholder="Please Select"
                                                            variant="outlined"
                                                            size="small"
                                                            className="autoComplete"
                                                            style={{
                                                              background: "#fff",
                                                            }}
                                                          />
                                                        )}
                                                      />
                                                    </div>
                                                  </div>
                                                </>
                                              )}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  <hr></hr>
                                  {/* {this.meterSetting()} */}
                                </>
                              )}
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.fundraising
                      ) && (
                          <>
                            <hr />
                            <div className="row" style={{ marginTop: "1em" }}>
                              <div className="col-md-12">
                                <div className="row">
                                  <h6>
                                    <b>Choose a Donor Experience</b>
                                  </h6>
                                </div>
                                {this.state.smsFundraisingOptionList.map(
                                  (row, index) => {
                                    return (
                                      <>
                                        <div className="row p-1">
                                          <label
                                            className="col-sm-2 col-form-label fw-bold"
                                            htmlFor="basic-default-supplierType"
                                            id="assetFormLabel"
                                          >
                                            <span className="me-2 cursor-pointer">
                                              <input
                                                type="radio"
                                                style={{ cursor: "pointer" }}
                                                value={row.id}
                                                onChange={(e) =>
                                                  this.handleChange(e, row)
                                                }
                                                checked={row.isSelected}
                                              />
                                            </span>
                                            {row.name}{" "}
                                            <span className="ms-4 fw-normal">
                                              {row.name === "With Introduction"
                                                ? "(more descriptive)"
                                                : "(fewer steps)"}
                                            </span>
                                          </label>
                                          <div className="col-sm-6 mt-2">
                                            <span>{row.description}</span>
                                          </div>
                                        </div>
                                      </>
                                    );
                                  }
                                )}
                                {this.state.isIntroMessage && (
                                  <div className="row p-1">
                                    <div className="col-sm-2 mt-2"></div>
                                    <div className="col-sm-6 mt-2">
                                      <span>
                                        Enter an Introduction Message that
                                        includes your organization's name and what
                                        this appeal is about. It must also elicit
                                        a "Yes" or "No" reply from recipient.
                                      </span>
                                      <textarea
                                        ref={this.textareaRef}
                                        required
                                        title=""
                                        value={this.state.introMessage}
                                        onChange={this.handleIntroMessageChange.bind(
                                          this
                                        )}
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        rows="3"
                                        style={{
                                          overflow: "hidden",
                                          resize: "vertical",
                                        }}
                                      />
                                      <span
                                        className="ms-2"
                                        style={{
                                          fontSize: "11px",
                                          color: "black",
                                        }}
                                      >
                                        Don’t forget to include opt-out language
                                        in your message if you haven’t done so
                                        recently.
                                      </span>
                                      <span
                                        style={{
                                          fontSize: "14px",
                                          float: "right",
                                        }}
                                      >
                                        {75 -
                                          this.state.introMessage?.trim()?.length}
                                      </span>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <hr />
                            <div className="row" style={{ marginTop: "1.5em" }}>
                              <div className="col-md-12">
                                <div className="row">
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="col-sm-2 col-form-label"
                                  >
                                    Your "How much?" Question
                                  </label>
                                  <div className="col-sm-5">
                                    <textarea
                                      ref={this.textareaRef}
                                      title=""
                                      required
                                      value={this.state.amountQuestion}
                                      onChange={this.handleAmountQustionChange.bind(
                                        this
                                      )}
                                      className="form-control"
                                      id="exampleFormControlTextarea1"
                                      rows="3"
                                      style={{
                                        overflow: "hidden",
                                        resize: "vertical",
                                      }}
                                    />
                                    <span
                                      className="ms-1"
                                      style={{
                                        fontWeight: "normal",
                                        fontSize: "11px",
                                        color: "black",
                                      }}
                                    >
                                      Did you include opt-out language?{" "}
                                      <span
                                        className="anchortag"
                                        onClick={this.handleInsertItAmountQuestionChange.bind(
                                          this
                                        )}
                                      >
                                        <u>Insert it.</u>
                                      </span>
                                    </span>
                                    {75 < this.state.amountQuestion?.length && (
                                      <span
                                        className="danger ms-1"
                                        style={{ color: "red", fontSize: "14px" }}
                                      >
                                        Your message is limited to 75 characters.
                                      </span>
                                    )}
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        float: "right",
                                      }}
                                    >
                                      {75 -
                                        this.state.amountQuestion?.trim()?.length}
                                    </span>
                                  </div>
                                  <div className="col-sm-3">
                                    <ul
                                      className="p-0"
                                      style={{ listStyle: "none" }}
                                    >
                                      <li className="variableButton mt-1">
                                        <IconButton
                                          className="pe-1"
                                          style={{ height: "15px" }}
                                        >
                                          <AddLinkIcon
                                            style={{
                                              fontSize: "20px",
                                              width: "25px",
                                            }}
                                            onClick={
                                              this.handleAccountDropdownOpen
                                            }
                                          />
                                        </IconButton>
                                        <span
                                          onClick={this.handleAccountDropdownOpen.bind(
                                            this
                                          )}
                                        >
                                          Insert Short Link
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            <div className="row" style={{ marginTop: "1em" }}>
                              <label
                                htmlFor="exampleFormControlTextarea1"
                                className="col-sm-2 col-form-label"
                              >
                                Your Suggested Donation Amounts
                                <InfoTooltip
                                  data="Up to 4 allowed"
                                  style={{
                                    float: "right",
                                  }}
                                />
                              </label>
                              <div className="col-md-8">
                                <div className="row mb-3 d-flex">
                                  <div className="col-md-3 d-flex">
                                    <div
                                      className="row ms-0 d-flex flex-nowrap"
                                      style={{ width: "140px" }}
                                    >
                                      <span
                                        className="input-group-addon"
                                        style={{ width: "40px" }}
                                      >
                                        $
                                      </span>
                                      <input
                                        type="number"
                                        autoComplete="off"
                                        id="multiStepsFirstName"
                                        name="multiStepsFirstName"
                                        className="form-control"
                                        style={{
                                          borderRadius: "0px 5px 5px 0px",
                                        }}
                                        value={this.state.donationAmount}
                                        onChange={this.handleDonationAmountChange.bind(
                                          this
                                        )}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-2 align-self-center">
                                    <Button
                                      style={{
                                        width: "80px",
                                        padding: "2px 8px",
                                        background: "#37517e",
                                        color: "#fff",
                                        borderColor: "#37517e",
                                        fontWeight: "bold",
                                        textTransform: "capitalize",
                                      }}
                                      type="button"
                                      className="btn btn-default "
                                      // startIcon={<AddIcon />}
                                      onClick={this.addDonationAmount.bind(this)}
                                    >
                                      Add
                                    </Button>
                                  </div>
                                  <div className="col-md-7">
                                    <ul
                                      className="ps-0 m-0"
                                      style={{
                                        listStyle: "none",
                                        display: "flex",
                                      }}
                                    >
                                      {this.state.donationAmountList.map(
                                        (amountValue, index) => {
                                          return (
                                            <>
                                              {
                                                <div className="donation d-flex">
                                                  <li>
                                                    $
                                                    {Utils.formatWithCommas(
                                                      amountValue
                                                    )}
                                                  </li>
                                                  <span className="ms-4">
                                                    <i
                                                      className="fa fa-times"
                                                      aria-hidden="true"
                                                      onClick={this.deleteDonationAmount.bind(
                                                        this,
                                                        index
                                                      )}
                                                    ></i>
                                                  </span>
                                                </div>
                                              }
                                            </>
                                          );
                                        }
                                      )}
                                    </ul>
                                    <span className="asterisk">
                                      {this.state.donationAmountError
                                        ? "No suggested donation amounts are set."
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <hr />
                            {/* {this.meterSetting()} */}
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.textToPledge
                      ) && (
                          <>
                            <hr />
                            <div className="row" style={{ marginTop: "1.5em" }}>
                              <div className="col-md-12">
                                <label
                                  htmlFor="exampleFormControlTextarea1"
                                  className="form-label"
                                >Message - </label> Thank you. Now enter your donation amount followed by your first and last name. Like this: #Keyword 200 Mark Smith.
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1.5em" }}>
                              <div className="col-md-12">
                                <div className="row">
                                  <label
                                    htmlFor="exampleFormControlTextarea1"
                                    className="col-sm-2 form-label"
                                  >
                                    <span
                                      className="row"
                                      style={{ paddingLeft: "12px" }}
                                    >
                                      Confirmation Msg{" "}
                                    </span>
                                    <span
                                      className="row"
                                      style={{ paddingLeft: "12px" }}
                                    >
                                      (With Payment Link)
                                    </span>
                                  </label>
                                  <div className="col-md-5">
                                    <textarea
                                      required
                                      title=""
                                      value={this.state.textPledgeMessage}
                                      onChange={this.handleTextPledgeMessageChange.bind(
                                        this
                                      )}
                                      onBlur={this.handleTextPledgeMessageChange.bind(
                                        this
                                      )}
                                      className="form-control"
                                      id="textPledgeMessageBox"
                                      rows="3"
                                      style={{
                                        overflow: "hidden",
                                        resize: "vertical",
                                      }}
                                    />
                                    <span
                                      className="ms-1"
                                      style={{
                                        fontWeight: "normal",
                                        fontSize: "11px",
                                        color: "black",
                                      }}
                                    >
                                      Did you include opt-out language?{" "}
                                      <span
                                        className="anchortag"
                                        onClick={this.handleInsertItPledgeMessageChange.bind(
                                          this
                                        )}
                                      >
                                        <u>Insert it.</u>
                                      </span>
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        float: "right",
                                      }}
                                    >
                                      {Utils.trimLetters(
                                        this.state.textPledgeMessage
                                      )}{" "}
                                      /{this.accountSettings?.textMessageLength}
                                    </span>

                                    {this.accountSettings?.textMessageLength <
                                      this.state.textPledgeMessage?.length && (
                                        <>
                                          <br></br>
                                          <span
                                            className="danger ms-1"
                                            style={{ color: "red", fontSize: "14px" }}
                                          >
                                            Your message is limited to{" "}
                                            {this.accountSettings?.textMessageLength}{" "}
                                            characters.
                                          </span>
                                        </>
                                      )}
                                  </div>
                                  <div className="col-md-3">
                                    <ul
                                      className="p-0"
                                      style={{ listStyle: "none" }}
                                    >
                                      {this.state.smsVariableList?.map(
                                        (data, index) => {
                                          return (
                                            <>
                                              {/* {(data.value !==
                                                                "{{Payment Link}}" ||
                                                                this.pledgeDonationIntegration !==
                                                                  "None") && ( */}
                                              {data?.name === "FirstName" ?
                                                <Tooltip
                                                  title={`Alternate: ${this.organization?.firstNameAlternateValue !== null ? this.organization?.firstNameAlternateValue : ""}`}
                                                  arrow
                                                  classes={{ popper: "alternateCustom-tooltip" }}
                                                  placement="right"
                                                >
                                                  <li
                                                    className="d-flex mt-1 variableButton"
                                                    onClick={this.handleTextPledgeMessageInsert.bind(
                                                      this,
                                                      data
                                                    )}
                                                  >
                                                    {data.name === "FirstName" && (
                                                      <IconButton className="pe-1">
                                                        <ChatBubbleOutlineIcon
                                                          style={{
                                                            fontSize: "16px",
                                                            width: "25px",
                                                          }}
                                                        />
                                                      </IconButton>
                                                    )}

                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      // onClick={this.handleTextMessageInsert.bind(
                                                      //   this,
                                                      //   data
                                                      // )}
                                                      key={index}
                                                      draggable
                                                    >
                                                      {data.description}
                                                    </span>
                                                  </li>
                                                </Tooltip>
                                                :
                                                <li
                                                  className="d-flex mt-1 variableButton"
                                                  onClick={this.handleTextPledgeMessageInsert.bind(
                                                    this,
                                                    data
                                                  )}
                                                >
                                                  {data.name === "FirstName" && (
                                                    <IconButton className="pe-1">
                                                      <ChatBubbleOutlineIcon
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      />
                                                    </IconButton>
                                                  )}
                                                  {data.name === "EventName" && (
                                                    <IconButton className="pe-1">
                                                      <i
                                                        class="fa fa-plus"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      ></i>
                                                    </IconButton>
                                                  )}
                                                  {data.name ===
                                                    "EventStartDate" && (
                                                      <IconButton className="pe-1">
                                                        <i
                                                          class="fa fa-calendar-plus-o"
                                                          aria-hidden="true"
                                                          style={{
                                                            fontSize: "15px",
                                                            width: "25px",
                                                          }}
                                                        ></i>
                                                      </IconButton>
                                                    )}
                                                  {data.name === "EventEndDate" && (
                                                    <IconButton className="pe-1">
                                                      <i
                                                        class="fa fa-calendar-plus-o"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "15px",
                                                          width: "25px",
                                                        }}
                                                      ></i>
                                                    </IconButton>
                                                  )}
                                                  {data.name === "PaymentLink" && (
                                                    <IconButton className="pe-1">
                                                      <i
                                                        class="fa fa-usd"
                                                        aria-hidden="true"
                                                        style={{
                                                          fontSize: "16px",
                                                          width: "25px",
                                                        }}
                                                      ></i>
                                                    </IconButton>
                                                  )}
                                                  <span
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    // onClick={this.handleTextMessageInsert.bind(
                                                    //   this,
                                                    //   data
                                                    // )}
                                                    key={index}
                                                    draggable
                                                  >
                                                    {(isBlackBaudCRM && this.state.textPledgeMessage?.includes("{{Payment Link}}")) ? "Edit Payment Link" : data.description}
                                                  </span>
                                                </li>
                                              }
                                              {/* )} */}
                                            </>
                                          );
                                        }
                                      )}
                                      <li className="variableButton mt-1">
                                        <IconButton
                                          className="pe-1"
                                          style={{ height: "15px" }}
                                        >
                                          <AddLinkIcon
                                            // className="anchortag"
                                            style={{
                                              fontSize: "20px",
                                              width: "25px",
                                            }}
                                            onClick={
                                              this.handleAccountDropdownOpen
                                            }
                                          />
                                        </IconButton>
                                        <span
                                          onClick={this.handleAccountDropdownOpen.bind(
                                            this
                                          )}
                                        >
                                          Insert Short Link
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <hr /> */}
                            {/* {this.meterSetting()} */}
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.optIn
                      ) && (
                          <>
                            <hr />
                            <div className="row" style={{ marginTop: "1em" }}>
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-6">
                                    <label
                                      htmlFor="exampleFormControlTextarea1"
                                      className="form-label"
                                    >
                                      Message
                                    </label>
                                    <textarea
                                      ref={this.textareaRef}
                                      title=""
                                      required
                                      value={this.state.textMessage}
                                      onChange={this.handleTextMessageChange.bind(
                                        this
                                      )}
                                      className="form-control"
                                      id="exampleFormControlTextarea1"
                                      rows="3"
                                      style={{
                                        overflow: "hidden",
                                        resize: "vertical",
                                      }}
                                    />
                                    <span
                                      className="ms-1"
                                      style={{
                                        fontWeight: "normal",
                                        fontSize: "11px",
                                        color: "black",
                                      }}
                                    >
                                      Did you include opt-out language?{" "}
                                      <span
                                        className="anchortag"
                                        onClick={this.handleInsertItMessageChange.bind(
                                          this
                                        )}
                                      >
                                        <u>Insert it.</u>
                                      </span>
                                    </span>
                                    <span
                                      className="ms-2"
                                      style={{
                                        fontSize: "14px",
                                        float: "right",
                                      }}
                                    >
                                      {Utils.trimLetters(this.state.textMessage)}
                                    </span>

                                    {this.accountSettings?.textMessageLength <
                                      Utils.countLetters(
                                        this.state.textMessage
                                      ) && (
                                        <>
                                          <br></br>
                                          <span
                                            className="danger ms-1"
                                            style={{ color: "red", fontSize: "14px" }}
                                          >
                                            Your message is limited to{" "}
                                            {this.accountSettings?.textMessageLength}{" "}
                                            characters.
                                          </span>
                                        </>
                                      )}
                                    {this.state.offlimitKeywordForMessage && (
                                      <>
                                        <br></br>
                                        <span
                                          style={{ fontSize: "12px", color: "red" }}
                                        >
                                          Off-limit words for msg box: free, bit.ly, tinyurl, 50/50, sweepstakes, raffle, gamble.
                                        </span>
                                      </>
                                    )}
                                    {this.state.hasEmDashError && (
                                      <>
                                        <br></br>
                                        <span
                                          className="danger ms-1"
                                          style={{ color: "red", fontSize: "14px" }}>
                                          You cannot use em Dash like this: — in the message.
                                        </span>
                                      </>
                                    )}
                                  </div>

                                  <div className="col-md-3 mt-4">
                                    <ul
                                      className="p-0"
                                      style={{ listStyle: "none" }}
                                    >
                                      <li>
                                        <span
                                          className="anchortag"
                                          onClick={this.handleAccountDropdownOpen}
                                        >
                                          Insert Short Link
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      {!(
                        Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.optIn
                        ) ||
                        Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.textToPledge
                        ) ||
                        Utils.equalsIgnoreCase(
                          this.state.messageType?.type,
                          MESSAGE_TYPES.accountvCard
                        )
                      ) && (
                          <>
                            <hr />
                            <div className="row" style={{ marginTop: "1em" }}>
                              <div className="col-md-12">
                                <div className="row">
                                  <label
                                    className="col-sm-2 MuiAutocomplete-label form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Activity Alerts
                                  </label>
                                  <div className="col-sm-10" id="assetFormLabel">
                                    <div className="row">
                                      <div
                                        className="col-sm-6"
                                        id="assetFormLabel"
                                      >
                                        <Autocomplete
                                          id="size-small-outlined"
                                          size="small"
                                          fullWidth
                                          disableClearable
                                          ListboxProps={{
                                            className: "custom-listbox",
                                          }}
                                          autoComplete="off"
                                          options={this.smsActivityAlertList}
                                          value={this.state.activityAlert}
                                          getOptionLabel={(option) =>
                                            option.description
                                          }
                                          defaultValue={this.state.activityAlert}
                                          onChange={(event, value) => {
                                            this.handleActivityAlertChange(value);
                                          }}
                                          inputprops={{
                                            style: {
                                              textTransform: "capitalize",
                                            },
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Please Select"
                                              variant="outlined"
                                              size="small"
                                              className="autoComplete"
                                              // required
                                              style={{ background: "#fff" }}
                                            />
                                          )}
                                        />
                                      </div>
                                    </div>
                                    <div className="row mt-2">
                                      {this.state.activityAlert?.type !==
                                        "Off" && (
                                          <>
                                            <div className="row mt-2">
                                              <div
                                                className="col-sm-6 m-0"
                                                id="givbeeText"
                                              >
                                                <label
                                                  className="col-form-label"
                                                  htmlFor="basic-default-name"
                                                  id="assetFormLabel"
                                                >
                                                  Text
                                                </label>
                                                <input
                                                  // required
                                                  autoFocus={true}
                                                  type="text"
                                                  autoComplete="off"
                                                  id="multiStepsFirstName"
                                                  name="multiStepsFirstName"
                                                  className="form-control"
                                                  placeholder="Use commas to separate multiple mobile numbers"
                                                  value={this.state.mobileItems}
                                                  onChange={this.handleMobileNoChange.bind(
                                                    this
                                                  )}
                                                  validators={["required"]}
                                                  errormessages={[
                                                    "This field is required",
                                                  ]}
                                                />
                                              </div>
                                            </div>
                                            {this.state.activityAlert?.type ===
                                              "REPLY" && (
                                                <div className="row mt-2">
                                                  <div
                                                    className="col-sm-6 m-0"
                                                    id="givbeeText"
                                                  >
                                                    <label
                                                      className="col-form-label"
                                                      htmlFor="basic-default-name"
                                                      id="assetFormLabel"
                                                    >
                                                      Email
                                                    </label>

                                                    <input
                                                      title=""
                                                      required
                                                      // autoFocus={true}
                                                      type="emails"
                                                      autoComplete="off"
                                                      id="multiStepsFirstName"
                                                      name="multiStepsFirstName"
                                                      className="form-control"
                                                      placeholder="Use commas to separate multiple emails"
                                                      value={this.state.emailItems}
                                                      onChange={this.handleEmailsChange.bind(
                                                        this
                                                      )}
                                                      validators={["required"]}
                                                      errormessages={[
                                                        "This field is required",
                                                      ]}
                                                    />
                                                  </div>
                                                </div>
                                              )}
                                          </>
                                        )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.standard
                      ) && (
                          <>
                            {this.accountSettings?.enableMms && (
                              <>
                                <hr />
                                <div
                                  className="row"
                                  style={{ marginTop: "1em", height: "100px" }}
                                >
                                  <label
                                    className="col-sm-2 form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Add Image
                                    {/* <InfoTooltip
                                                 data="Counts as 3 credits instead of 1"
                                                 style={{
                                                   float: "right",
                                                 }}
                                               /> */}
                                    <div>
                                      <small className="uploadInfo-note">
                                        Extra 2 credits/msg.
                                      </small>
                                    </div>
                                  </label>
                                  <div
                                    className="col-sm-9 m-0 align-self-center"
                                    id="givbeeText"
                                  >
                                    <div className="row d-flex align-items-center m-0">
                                      {!this.state.mmsUrl && (
                                        <>
                                          <div className="col-sm-4 ps-0">
                                            <div className="file-upload-wrapper">
                                              <label
                                                htmlFor="file-upload"
                                                className={`customImageVideo-file-upload ${this.state.isDragging
                                                  ? "dragging"
                                                  : ""
                                                  }`}
                                                onDrop={this.handleDrop}
                                                onDragOver={this.handleDragOver}
                                                onDragLeave={this.handleDragLeave}
                                              >
                                                <CloudUploadIcon className="upload-icon" />
                                                <span className="upload-text">
                                                  Drop file here or{" "}
                                                  <span className="browse-link">Browse for file</span>
                                                </span>

                                                <input
                                                  id="file-upload"
                                                  type="file"
                                                  accept="image/*"
                                                  onChange={this.handleFileChange}
                                                />
                                              </label>

                                              {/* <small className="upload-note">
                                                5 MB max (depends on carrier
                                                provider)
                                              </small> */}
                                            </div>
                                          </div>
                                        </>
                                      )}
                                      {this.state.mmsUrl && (
                                        <>
                                          <div className="col-md-6">
                                            <div className="row">
                                              <div className="col-sm-5 pe-0 d-flex">
                                                {this.state.documentType ===
                                                  "video" ? (
                                                  <div
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <ReactPlayer
                                                      src={
                                                        this.state.mmsUrl
                                                          ? this.state.mmsUrl
                                                          : ""
                                                      }
                                                      playing={this.state.playing}
                                                      width="100%"
                                                      height="100px"
                                                      controls={false} // hide default controls
                                                      onClick={
                                                        this.handlePlayPause
                                                      }
                                                      onEnded={() =>
                                                        this.setState({
                                                          playing: false,
                                                        })
                                                      }
                                                    />

                                                    {/* Show play button only when not playing */}
                                                    {!this.state.playing && (
                                                      <button
                                                        onClick={
                                                          this.handlePlayPause
                                                        }
                                                        style={{
                                                          position: "absolute",
                                                          top: "50%",
                                                          left: "50%",
                                                          transform:
                                                            "translate(-50%, -50%)",
                                                          background:
                                                            "rgba(0, 0, 0, 0.6)",
                                                          border: "none",
                                                          borderRadius: "50%",
                                                          width: "35px",
                                                          height: "35px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          justifyContent:
                                                            "center",
                                                          cursor: "pointer",
                                                        }}
                                                      >
                                                        <PlayArrow
                                                          style={{
                                                            fontSize: 30,
                                                            color: "white",
                                                          }}
                                                        />
                                                      </button>
                                                    )}
                                                  </div>
                                                ) : (
                                                  <img
                                                    style={{
                                                      width: "auto",
                                                      height: "8em",
                                                      objectFit: "contain",
                                                      objectPosition: "left",
                                                    }}
                                                    alt=""
                                                    src={
                                                      this.state.mmsUrl
                                                        ? this.state.mmsUrl
                                                        : ""
                                                    }
                                                  />
                                                )}
                                                <span className="fw-bold ms-2">
                                                  <ClearIcon
                                                    className="logoDelete"
                                                    style={{
                                                      cursor: "pointer",
                                                      borderRadius: "50%",
                                                      border: "solid 2px",
                                                      marginBottom: "10px",
                                                    }}
                                                    onClick={this.deleteImageInBackend.bind(
                                                      this
                                                    )}
                                                  />
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      {Utils.equalsIgnoreCase(
                        this.state.messageType?.type,
                        MESSAGE_TYPES.accountvCard
                      ) && (
                          <>
                            {this.accountSettings?.enableMms && (
                              <>
                                <hr />
                                <div className="row" style={{ marginTop: "1em" }}>
                                  <label
                                    className="col-sm-2 form-label"
                                    htmlFor="collapsible-firstname"
                                  >
                                    Add vCard
                                  </label>
                                  <div
                                    className="col-sm-9 m-0 align-self-center"
                                    id="givbeeText"
                                  >
                                    <div className="row d-flex align-items-center m-0">
                                      {!this.state.vCardUrl && (
                                        <>
                                          <div
                                            className="col-md-4 align-self-center csvFile ps-0"
                                            id="assetFormLabel"
                                            style={{
                                              display: "inline-block",
                                              cursor: "pointer",
                                            }}
                                          >
                                            <div className="file-upload-wrapper">
                                              <label
                                                htmlFor="vCode-file-upload"
                                                className={`customImageVideo-file-upload ${this.state.isDragging
                                                  ? "dragging"
                                                  : ""
                                                  }`}
                                                onDrop={this.handlevCardDrop}
                                                onDragOver={
                                                  this.handlevCardDragOver
                                                }
                                                onDragLeave={
                                                  this.handlevCardDragLeave
                                                }
                                              >
                                                <CloudUploadIcon className="upload-icon" />
                                                <span className="upload-text">
                                                  Drop file here or{" "}
                                                  <span className="browse-link">Browse for file</span>
                                                </span>
                                                <input
                                                  id="vCode-file-upload"
                                                  type="file"
                                                  name="file"
                                                  accept=".vcf,text/vcard,text/x-vcard"
                                                  onChange={this.handlevCardChange.bind(
                                                    this
                                                  )}
                                                />
                                              </label>
                                            </div>
                                          </div>
                                          <div className="col-md-4">
                                            <Button
                                              id="ptsHollowButton"
                                              variant="contained"
                                              style={{ textTransform: "initial" }}
                                              type="button"
                                              onClick={this.handleCreateVcardFormOpen.bind(this)}
                                            >
                                              Create vCard
                                            </Button>
                                          </div>
                                        </>
                                      )}
                                      {this.state.vCardUrl && (
                                        <>
                                          <div className="col-md-6">
                                            {this.state.contact !== null &&
                                              this.vCardDetails()}
                                          </div>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                          </>
                        )}
                      <Dialog
                        open={this.state.open}
                        onClose={this.handleAccountDropdownClose.bind(this)}
                        maxWidth="xl"
                      >
                        <DialogTitle id="scroll-dialog-title">
                          <span style={{ color: "#fff" }}>
                            Create Short Link
                          </span>
                        </DialogTitle>
                        <IconButton
                          aria-label="close"
                          onClick={this.handleAccountDropdownClose.bind(this)}
                          style={{
                            position: "absolute",
                            right: 8,
                            top: 4,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        >
                          <CloseIcon
                            style={{ color: "#fff", fontWeight: "600" }}
                          />
                        </IconButton>
                        <DialogContent
                          style={{ padding: "0px 24px 24px 24px" }}
                        >
                          <div
                            md={12}
                            style={{
                              width: "800px",
                              color: "#000",
                              fontSize: "small",
                            }}
                          >
                            <div className="row mt-2">
                              <div
                                className="col-md-6 mt-1"
                                id="assetFormLabel"
                              >
                                <label
                                  className="form-label "
                                  htmlFor="collapsible-supplierType"
                                >
                                  Paste your long link here then click the
                                  button.
                                </label>
                                <input
                                  type="link"
                                  autoComplete="off"
                                  id="multiStepsFirstName"
                                  name="multiStepsFirstName"
                                  className="form-control"
                                  value={this.state.shortlinkUrl}
                                  onChange={this.handleShortlinkUrlChange.bind(
                                    this
                                  )}
                                  validators={["required"]}
                                  errormessages={["This field is required"]}
                                />
                              </div>
                              <div
                                className="col-md-3 align-self-center"
                                style={{ marginTop: "32px" }}
                              >
                                <PtsButton
                                  btnName="Shorten"
                                  onClick={this.createShortlinkToBackend.bind(
                                    this
                                  )}
                                />
                              </div>
                            </div>
                            {this.state.shortUrl && (
                              <div className="row mt-3">
                                <div className="col-md-5">
                                  <span className="ms-2">
                                    <a
                                      href={this.state.shortUrl}
                                      target="_blank"
                                      className="anchortag mt-4"
                                      style={{
                                        width: "220px",
                                        color: "#5faee3",
                                      }}
                                    >
                                      {this.state.shortUrl}
                                    </a>{" "}
                                    &nbsp;
                                    <Tooltip
                                      title="Copy to clipboard"
                                      aria-label="add"
                                      classes={{ popper: "custom-tooltip" }}
                                    >
                                      <IconButton>
                                        <CopyToClipboard
                                          text={this.state.shortUrl}
                                          onClick={this.onCopy}
                                        >
                                          <FileCopyIcon
                                            style={{
                                              color: "gray",
                                              fontSize: "20px",
                                            }}
                                          />
                                        </CopyToClipboard>
                                      </IconButton>
                                    </Tooltip>
                                  </span>
                                </div>
                              </div>
                            )}
                            <div
                              className="shortLinkMenu mt-4"
                              style={{ width: "100%" }}
                            >
                              <MaterialTable
                                title=""
                                icons={UiUtils.getMaterialTableIcons()}
                                localization={{
                                  body: {
                                    emptyDataSourceMessage: (
                                      <h5 className="dataNotAvailable">
                                        No data found.
                                      </h5>
                                    ),
                                  },
                                }}
                                columns={[
                                  {
                                    title: "#",
                                    render: (rowData) =>
                                      rowData.tableData.id + 1,
                                    width: "5%",
                                    align: "left",
                                    cellStyle: {
                                      width: "6%",
                                    },
                                  },
                                  {
                                    title: "Source Link",
                                    field: "sourceLink",
                                    cellStyle: {
                                      width: "20%",
                                    },
                                  },
                                  {
                                    title: "Shortened Link",
                                    field: "targetLink",
                                    render: (rowData) => {
                                      return (
                                        <>
                                          {rowData.targetLink}, &nbsp;
                                          <Tooltip
                                            title="Copy to clipboard"
                                            aria-label="add"
                                            classes={{
                                              popper: "custom-tooltip",
                                            }}
                                          >
                                            <IconButton>
                                              <CopyToClipboard
                                                text={rowData.targetLink}
                                                onClick={this.onCopy}
                                              >
                                                <FileCopyIcon
                                                  style={{
                                                    color: "gray",
                                                    fontSize: "20px",
                                                  }}
                                                />
                                              </CopyToClipboard>
                                            </IconButton>
                                          </Tooltip>
                                        </>
                                      );
                                    },
                                    cellStyle: {
                                      width: "22%",
                                      textTransform: "lowercase",
                                    },
                                  },
                                ]}
                                data={this.state.shortLinkList}
                                options={{
                                  emptyRowsWhenPaging: false,
                                  sorting: true,
                                  search: true,
                                  actionsColumnIndex: -1,
                                  // initialPage: this.state.initialPage,
                                  // pageSize: this.state.pageSize,
                                  pageSizeOptions:
                                    Utils.materialTablePageSize(),
                                  paging: false,
                                  headerStyle: {
                                    backgroundColor: "#37517e",
                                    fontWeight: "bold",
                                    color: "#ffff",
                                    align: "left",
                                  },
                                }}
                                onChangePage={(page, pageSize) => {
                                  this.handleMaterialTablePageChange(
                                    page,
                                    pageSize
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </DialogContent>
                      </Dialog>
                      {this.blackbaudPaymentLinkPopup()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row d-flex align-items-center justify-content-between">
                <div className="col-sm-12 mt-3 text-center">
                  {this.state.isTextMessageLength ? (
                    <CreateButton
                      btnName="Create"
                      disabled={true}
                      type="submit"
                    />
                  ) : (
                    <CreateButton
                      btnName="Create"
                      disabled={false}
                      type="submit"
                    />
                  )}
                  &nbsp;&nbsp;
                  <CancelIconButton onClick={(e) => this.createCancel()} />
                </div>
              </div>
            </ValidatorForm>
            {this.showMessageTemplate(this.state.action)}
          </div>
        </>
      );
    }
  }
}

export default withRouter(CreateSimilarMessage);
